/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type Announce = {
  __typename: "Announce",
  body: string,
  createdAt: string,
  expiredAt?: number | null,
  id: string,
  level: AnnounceLevel,
  owner: string,
  subject: string,
  to: string,
  updatedAt?: string | null,
  ym: string,
};

export enum AnnounceLevel {
  DM = "DM",
  IMPORTANT = "IMPORTANT",
  INFO = "INFO",
  UPDATE = "UPDATE",
  WARN = "WARN",
}


export type AtomicCounter = {
  __typename: "AtomicCounter",
  counterName: string,
  createdAt?: string | null,
  kind: string,
  sequence: number,
  updatedAt?: string | null,
};

export type BatchJobConf = {
  __typename: "BatchJobConf",
  allowedGroups?: Array< string | null > | null,
  createdAt?: string | null,
  jobName: string,
  remarks: string,
  updatedAt?: string | null,
};

export type BuildPrice = {
  __typename: "BuildPrice",
  createdAt?: string | null,
  owner: string,
  unitPriceCB: number,
  unitPriceOther: number,
  unitPriceRC: number,
  unitPriceS: number,
  unitPriceSRC: number,
  unitPriceW: number,
  updatedAt?: string | null,
  year: number,
};

export type CognitoUserResponse = {
  __typename: "CognitoUserResponse",
  errorMessage?: string | null,
  item?: CognitoUser | null,
};

export type CognitoUser = {
  __typename: "CognitoUser",
  Attributes?:  Array<CognitoUserAttribute | null > | null,
  Company?: CompanyType | null,
  Enabled?: boolean | null,
  Groups?:  Array<CognitoGroup | null > | null,
  MFAOptions?:  Array<CognitoUserMFAOption | null > | null,
  User?: UserType | null,
  UserCreateDate?: string | null,
  UserLastModifiedDate?: string | null,
  UserStatus?: CognitoUserUserStatus | null,
  Username?: string | null,
};

export type CognitoUserAttribute = {
  __typename: "CognitoUserAttribute",
  Name?: string | null,
  Value?: string | null,
};

export type CompanyType = {
  __typename: "CompanyType",
  address?: string | null,
  areaNames?: Array< string | null > | null,
  areaPrefs?: Array< string | null > | null,
  areas?: Array< string | null > | null,
  bldConditionCompanies?: Array< string | null > | null,
  bldConditionSelections?: Array< string | null > | null,
  branchAddress?: string | null,
  branchFax?: string | null,
  branchId?: number | null,
  branchName?: string | null,
  branchTel?: string | null,
  branchUrl?: string | null,
  createdAt?: string | null,
  eAreaNames?: Array< string | null > | null,
  eAreas?: Array< string | null > | null,
  email?: string | null,
  estateTypes?: Array< string | null > | null,
  fax?: string | null,
  guaranter?: string | null,
  id: string,
  infoName: string,
  job?: string | null,
  latitude?: number | null,
  license?: string | null,
  licenseCount?: number | null,
  licenseNo?: string | null,
  licenser?: string | null,
  logoImg?: string | null,
  longitude?: number | null,
  name?: string | null,
  organization?: string | null,
  owner?: string | null,
  recNo?: number | null,
  remarks?: string | null,
  remarks2?: string | null,
  searchInfo: string,
  startMark?: string | null,
  tel?: string | null,
  updatedAt?: string | null,
  url?: string | null,
};

export type CognitoGroup = {
  __typename: "CognitoGroup",
  CreationDate?: string | null,
  Description?: string | null,
  GroupName?: string | null,
  LastModifiedDate?: string | null,
  Precedence?: number | null,
  RoleArn?: string | null,
  UserPoolId?: string | null,
};

export type CognitoUserMFAOption = {
  __typename: "CognitoUserMFAOption",
  AttributeName?: string | null,
  DeliveryMedium?: CognitoUserMFAOptionDeliveryMedium | null,
};

export enum CognitoUserMFAOptionDeliveryMedium {
  EMAIL = "EMAIL",
  SMS = "SMS",
}


export type UserType = {
  __typename: "UserType",
  agreement?: boolean | null,
  authenticatedAt?: string | null,
  companyBranchName?: string | null,
  companyId?: string | null,
  companyName?: string | null,
  createdAt?: string | null,
  defaultCondition?: DefaultCondition | null,
  email?: string | null,
  group?: string | null,
  infoName: string,
  name?: string | null,
  nameRuby?: string | null,
  owner?: string | null,
  paid?: boolean | null,
  pricingAvailable?: boolean | null,
  role?: string | null,
  searchInfo?: string | null,
  tel?: string | null,
  trial?: boolean | null,
  trialEndAt?: string | null,
  updatedAt?: string | null,
  username: string,
};

export type DefaultCondition = {
  __typename: "DefaultCondition",
  alsoCreatedAtFrom?: number | null,
  alsoCreatedAtTo?: number | null,
  alsoPricedAtFrom?: number | null,
  alsoPricedAtTo?: number | null,
  areaPrefs?: Array< string | null > | null,
  areas?: Array< string | null > | null,
  bldConditionSelections?: Array< string | null > | null,
  companyRecNo?: number | null,
  completionYMFrom?: number | null,
  completionYMTo?: number | null,
  estatePriceFrom?: number | null,
  estatePriceTo?: number | null,
  estateTypes?: Array< string | null > | null,
  exceptForRent?: boolean | null,
  flat?: boolean | null,
  forRent?: boolean | null,
  petOk?: boolean | null,
  priceLabel?: boolean | null,
  purposeSummaryBs?: Array< string | null > | null,
  roomsFrom?: number | null,
  roomsTo?: number | null,
  squareAreaOfMansionFrom?: number | null,
  squareAreaOfMansionTo?: number | null,
  structureSummaries?: Array< string | null > | null,
  tsuboAreaFrom?: number | null,
  tsuboAreaTo?: number | null,
  tsuboLabel?: boolean | null,
  venderOnly?: boolean | null,
};

export enum CognitoUserUserStatus {
  ARCHIVED = "ARCHIVED",
  COMPROMISED = "COMPROMISED",
  CONFIRMED = "CONFIRMED",
  FORCE_CHANGE_PASSWORD = "FORCE_CHANGE_PASSWORD",
  RESET_REQUIRED = "RESET_REQUIRED",
  UNCONFIRMED = "UNCONFIRMED",
  UNKNOWN = "UNKNOWN",
}


export type Company = {
  __typename: "Company",
  address?: string | null,
  areaNames?: Array< string | null > | null,
  areaPrefs?: Array< string | null > | null,
  areas?: Array< string | null > | null,
  bldConditionCompanies?: Array< string | null > | null,
  bldConditionSelections?: Array< string | null > | null,
  branchAddress?: string | null,
  branchFax?: string | null,
  branchId?: number | null,
  branchName?: string | null,
  branchTel?: string | null,
  branchUrl?: string | null,
  createdAt?: string | null,
  eAreaNames?: Array< string | null > | null,
  eAreas?: Array< string | null > | null,
  email?: string | null,
  estateTypes?: Array< string | null > | null,
  fax?: string | null,
  guaranter?: string | null,
  id: string,
  infoName: string,
  job?: string | null,
  latitude?: number | null,
  license?: string | null,
  licenseCount?: number | null,
  licenseNo?: string | null,
  licenser?: string | null,
  logoImg?: string | null,
  longitude?: number | null,
  name?: string | null,
  organization?: string | null,
  owner?: string | null,
  recNo?: number | null,
  remarks?: string | null,
  remarks2?: string | null,
  searchInfo: string,
  startMark?: string | null,
  tel?: string | null,
  updatedAt?: string | null,
  url?: string | null,
};

export type CompanyForAnonymousResponse = {
  __typename: "CompanyForAnonymousResponse",
  organization?: string | null,
};

export type Dummy = {
  __typename: "Dummy",
  createdAt: string,
  id: string,
  kintoneAppScope?: KintoneAppScope | null,
  kintoneDataKind?: KintoneDataKind | null,
  updatedAt: string,
};

export enum KintoneAppScope {
  CHUBU = "CHUBU",
  CHUSHIKOKU = "CHUSHIKOKU",
  COMMON = "COMMON",
  HOKKAIDO = "HOKKAIDO",
  KANTO = "KANTO",
  KINKI = "KINKI",
  TOHOKU = "TOHOKU",
  YAMAGUCHI_KYUSHU = "YAMAGUCHI_KYUSHU",
}


export enum KintoneDataKind {
  Company = "Company",
  Estate = "Estate",
  Mansion = "Mansion",
}


export type Estate = {
  __typename: "Estate",
  address?: string | null,
  appearanceImgs?: Array< string | null > | null,
  area?: string | null,
  balconyArea?: number | null,
  bcr?: number | null,
  bldConditionType?: string | null,
  buildingCompany?: string | null,
  buildingFloors?: string | null,
  cadastralMapPdf?: string | null,
  carsInParkingN?: number | null,
  city?: string | null,
  cityPlanningType?: string | null,
  cleaningMonth?: number | null,
  clearingType?: string | null,
  collectedAt?: string | null,
  companyAddress?: string | null,
  companyBranchId?: number | null,
  companyFax?: string | null,
  companyGuaranter?: string | null,
  companyId?: string | null,
  companyLicense?: string | null,
  companyName?: string | null,
  companyRecNo?: number | null,
  companyTel?: string | null,
  companyUrl?: string | null,
  completionMonth?: number | null,
  completionMonthS?: string | null,
  completionSchMonth?: number | null,
  condominiumId?: string | null,
  condominiumName?: string | null,
  condominiumRecNo?: number | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  currentStatus?: string | null,
  currentStatusB?: string | null,
  currentStatusFree?: string | null,
  currentStatusG?: string | null,
  deletedOnSumora?: number | null,
  drivewayPay?: string | null,
  eSchool?: Array< string | null > | null,
  estatePrice?: number | null,
  estateType?: string | null,
  estateUrl?: string | null,
  exactLocation?: number | null,
  floor?: number | null,
  floorAreaRatio?: number | null,
  floorStructure?: string | null,
  fullAddress?: string | null,
  gas?: string | null,
  gasPdf?: string | null,
  groundPdf?: string | null,
  groundType?: Array< string | null > | null,
  groundTypeFree?: string | null,
  id: string,
  infoName: string,
  isLot?: number | null,
  jSchool?: Array< string | null > | null,
  landAreaType?: string | null,
  landRights?: string | null,
  latitude?: number | null,
  layout?: string | null,
  layoutImgs?: Array< string | null > | null,
  license?: string | null,
  location?: string | null,
  longitude?: number | null,
  managementFee?: number | null,
  managementType?: string | null,
  manager?: string | null,
  mapImg?: string | null,
  media?: string | null,
  mediationKind?: string | null,
  name?: string | null,
  nearlyLocation?: number | null,
  notFoundAt?: string | null,
  otherCost?: number | null,
  owner?: string | null,
  parking?: string | null,
  parkingFee?: number | null,
  parkingHeight?: number | null,
  parkingMechOrPlane?: string | null,
  parkingTakeOver?: string | null,
  parkingTakeOverFree?: string | null,
  pet?: string | null,
  prefecture?: string | null,
  priceHistory?:  Array<Price | null > | null,
  pricedAt?: string | null,
  purposeB?: string | null,
  purposeSummaryB?: string | null,
  recNo?: number | null,
  remarks?: string | null,
  repairCost?: number | null,
  roadDirection?: string | null,
  roadType?: string | null,
  roadWidth?: number | null,
  room?: string | null,
  searchInfo: string,
  seller?: string | null,
  sewer?: string | null,
  sewerPdf?: string | null,
  sold?: boolean | null,
  squareArea?: number | null,
  status?: string | null,
  store?: string | null,
  structure?: string | null,
  structureFree?: string | null,
  subCompany2Address?: string | null,
  subCompany2Fax?: string | null,
  subCompany2Guaranter?: string | null,
  subCompany2Id?: string | null,
  subCompany2License?: string | null,
  subCompany2Name?: string | null,
  subCompany2Tel?: string | null,
  subCompany2Url?: string | null,
  subCompanyAddress?: string | null,
  subCompanyFax?: string | null,
  subCompanyGuaranter?: string | null,
  subCompanyId?: string | null,
  subCompanyLicense?: string | null,
  subCompanyName?: string | null,
  subCompanyRecNo?: number | null,
  subCompanyTel?: string | null,
  subCompanyUrl?: string | null,
  tileOnZoom12?: string | null,
  tileOnZoom14?: string | null,
  tileOnZoom16?: string | null,
  totalArea?: number | null,
  totalHouses?: number | null,
  traffic?: string | null,
  tsuboArea?: number | null,
  unitPrice?: number | null,
  unsettledLocation?: number | null,
  updatedAt?: string | null,
  url?: string | null,
  useDistrict?: Array< string | null > | null,
  water?: string | null,
  waterPdf?: string | null,
};

export type Price = {
  __typename: "Price",
  price?: number | null,
  pricedAt?: string | null,
};

export type KintoneData = {
  __typename: "KintoneData",
  appScope: string,
  appScopeAndRecNo: string,
  createdAt: string,
  estateUrl: string,
  kind: string,
  mansionName: string,
  recNo: string,
  record?: string | null,
  scrapeeBaseUrl: string,
  sortKey: string,
  sortKeyForStatus: string,
  status: string,
  updatedAt: string,
};

export type PresignedUrlResponse = {
  __typename: "PresignedUrlResponse",
  errorMessage?: string | null,
  url?: string | null,
};

export type PublicEstate = {
  __typename: "PublicEstate",
  createdAt: string,
  distributer: CompanyType,
  estate: EstateType,
  estateId: string,
  expiredAt: number,
  id: string,
  tel?: string | null,
  updatedAt?: string | null,
};

export type EstateType = {
  __typename: "EstateType",
  address?: string | null,
  appearanceImgs?: Array< string | null > | null,
  area?: string | null,
  balconyArea?: number | null,
  bcr?: number | null,
  bldConditionType?: string | null,
  buildingCompany?: string | null,
  buildingFloors?: string | null,
  cadastralMapPdf?: string | null,
  carsInParkingN?: number | null,
  city?: string | null,
  cityPlanningType?: string | null,
  cleaningMonth?: number | null,
  clearingType?: string | null,
  collectedAt?: string | null,
  companyAddress?: string | null,
  companyBranchId?: number | null,
  companyFax?: string | null,
  companyGuaranter?: string | null,
  companyId?: string | null,
  companyLicense?: string | null,
  companyName?: string | null,
  companyRecNo?: number | null,
  companyTel?: string | null,
  companyUrl?: string | null,
  completionMonth?: number | null,
  completionMonthS?: string | null,
  completionSchMonth?: number | null,
  condominiumId?: string | null,
  condominiumName?: string | null,
  condominiumRecNo?: number | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  currentStatus?: string | null,
  currentStatusB?: string | null,
  currentStatusFree?: string | null,
  currentStatusG?: string | null,
  deletedOnSumora?: number | null,
  drivewayPay?: string | null,
  eSchool?: Array< string | null > | null,
  estatePrice?: number | null,
  estateType?: string | null,
  estateUrl?: string | null,
  exactLocation?: number | null,
  floor?: number | null,
  floorAreaRatio?: number | null,
  floorStructure?: string | null,
  fullAddress?: string | null,
  gas?: string | null,
  gasPdf?: string | null,
  groundPdf?: string | null,
  groundType?: Array< string | null > | null,
  groundTypeFree?: string | null,
  id: string,
  infoName: string,
  isLot?: number | null,
  jSchool?: Array< string | null > | null,
  landAreaType?: string | null,
  landRights?: string | null,
  latitude?: number | null,
  layout?: string | null,
  layoutImgs?: Array< string | null > | null,
  license?: string | null,
  location?: string | null,
  longitude?: number | null,
  managementFee?: number | null,
  managementType?: string | null,
  manager?: string | null,
  mapImg?: string | null,
  media?: string | null,
  mediationKind?: string | null,
  name?: string | null,
  nearlyLocation?: number | null,
  notFoundAt?: string | null,
  otherCost?: number | null,
  owner?: string | null,
  parking?: string | null,
  parkingFee?: number | null,
  parkingHeight?: number | null,
  parkingMechOrPlane?: string | null,
  parkingTakeOver?: string | null,
  parkingTakeOverFree?: string | null,
  pet?: string | null,
  prefecture?: string | null,
  priceHistory?:  Array<Price | null > | null,
  pricedAt?: string | null,
  purposeB?: string | null,
  purposeSummaryB?: string | null,
  recNo?: number | null,
  remarks?: string | null,
  repairCost?: number | null,
  roadDirection?: string | null,
  roadType?: string | null,
  roadWidth?: number | null,
  room?: string | null,
  searchInfo: string,
  seller?: string | null,
  sewer?: string | null,
  sewerPdf?: string | null,
  sold?: boolean | null,
  squareArea?: number | null,
  status?: string | null,
  store?: string | null,
  structure?: string | null,
  structureFree?: string | null,
  subCompany2Address?: string | null,
  subCompany2Fax?: string | null,
  subCompany2Guaranter?: string | null,
  subCompany2Id?: string | null,
  subCompany2License?: string | null,
  subCompany2Name?: string | null,
  subCompany2Tel?: string | null,
  subCompany2Url?: string | null,
  subCompanyAddress?: string | null,
  subCompanyFax?: string | null,
  subCompanyGuaranter?: string | null,
  subCompanyId?: string | null,
  subCompanyLicense?: string | null,
  subCompanyName?: string | null,
  subCompanyRecNo?: number | null,
  subCompanyTel?: string | null,
  subCompanyUrl?: string | null,
  tileOnZoom12?: string | null,
  tileOnZoom14?: string | null,
  tileOnZoom16?: string | null,
  totalArea?: number | null,
  totalHouses?: number | null,
  traffic?: string | null,
  tsuboArea?: number | null,
  unitPrice?: number | null,
  unsettledLocation?: number | null,
  updatedAt?: string | null,
  url?: string | null,
  useDistrict?: Array< string | null > | null,
  water?: string | null,
  waterPdf?: string | null,
};

export type Report = {
  __typename: "Report",
  companyId: string,
  companyName: string,
  createdAt: string,
  description?: string | null,
  estateId: string,
  estateName?: string | null,
  expiredAt?: number | null,
  id: string,
  latitude?: number | null,
  longitude?: number | null,
  owner: string,
  reportKind: string,
  updatedAt?: string | null,
  userName: string,
};

export type StickyNote = {
  __typename: "StickyNote",
  color?: StickyNoteColor | null,
  companyId: string,
  createdAt?: string | null,
  description?: string | null,
  icon?: StickyNoteIcon | null,
  id: string,
  infoName: string,
  latitude: number,
  longitude: number,
  memoKind: string,
  openLevel: string,
  owner: string,
  searchInfo: string,
  tileOnZoom12: string,
  tileOnZoom14: string,
  tileOnZoom16: string,
  updatedAt?: string | null,
  url1?: string | null,
  url2?: string | null,
  url3?: string | null,
};

export enum StickyNoteColor {
  blue = "blue",
  red = "red",
  white = "white",
  yellow = "yellow",
}


export enum StickyNoteIcon {
  agree = "agree",
  anti = "anti",
  cart = "cart",
  caution = "caution",
  cone = "cone",
  key = "key",
  normal = "normal",
  parking = "parking",
  person = "person",
  post = "post",
  sale = "sale",
  secret = "secret",
}


export type User = {
  __typename: "User",
  agreement?: boolean | null,
  authenticatedAt?: string | null,
  companyBranchName?: string | null,
  companyId?: string | null,
  companyName?: string | null,
  createdAt?: string | null,
  defaultCondition?: DefaultCondition | null,
  email?: string | null,
  group?: string | null,
  infoName: string,
  name?: string | null,
  nameRuby?: string | null,
  owner?: string | null,
  paid?: boolean | null,
  pricingAvailable?: boolean | null,
  role?: string | null,
  searchInfo?: string | null,
  tel?: string | null,
  trial?: boolean | null,
  trialEndAt?: string | null,
  updatedAt?: string | null,
  username: string,
};

export type ModelAnnounceFilterInputInput = {
  and?: Array< ModelAnnounceFilterInputInput | null > | null,
  body?: CustomModelStringInputInput | null,
  createdAt?: CustomModelStringInputInput | null,
  expiredAt?: CustomModelStringInputInput | null,
  id?: CustomModelIDInputInput | null,
  level?: CustomModelAnnounceLevelInputInput | null,
  not?: ModelAnnounceFilterInputInput | null,
  or?: Array< ModelAnnounceFilterInputInput | null > | null,
  owner?: CustomModelStringInputInput | null,
  subject?: CustomModelStringInputInput | null,
  to?: CustomModelStringInputInput | null,
  updatedAt?: CustomModelStringInputInput | null,
  ym?: CustomModelStringInputInput | null,
};

export type CustomModelStringInputInput = {
  attributeExists?: boolean | null,
  attributeType?: CustomModelStringInputAttributeType | null,
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  size?: CustomModelStringInputSizeInput | null,
};

export enum CustomModelStringInputAttributeType {
  _null = "_null",
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
}


export type CustomModelStringInputSizeInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type CustomModelIDInputInput = {
  attributeExists?: boolean | null,
  attributeType?: CustomModelIDInputAttributeType | null,
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  size?: CustomModelIDInputSizeInput | null,
};

export enum CustomModelIDInputAttributeType {
  _null = "_null",
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
}


export type CustomModelIDInputSizeInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type CustomModelAnnounceLevelInputInput = {
  eq?: AnnounceLevel | null,
  ne?: AnnounceLevel | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelAnnounceConnection = {
  __typename: "ModelAnnounceConnection",
  items?:  Array<AnnounceType | null > | null,
  nextToken?: string | null,
};

export type AnnounceType = {
  __typename: "AnnounceType",
  body: string,
  createdAt: string,
  expiredAt?: number | null,
  id: string,
  level: AnnounceLevel,
  owner: string,
  subject: string,
  to: string,
  updatedAt?: string | null,
  ym: string,
};

export enum ListAnnouncesByYmSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type CustomModelStringKeyConditionInputInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
};

export type ModelAtomicCounterFilterInput = {
  and?: Array< ModelAtomicCounterFilterInput | null > | null,
  counterName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  kind?: ModelStringInput | null,
  not?: ModelAtomicCounterFilterInput | null,
  or?: Array< ModelAtomicCounterFilterInput | null > | null,
  sequence?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelStringInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  _null = "_null",
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
}


export type ModelSizeInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelIDInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  size?: ModelSizeInput | null,
};

export type ModelIntInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelAtomicCounterConnection = {
  __typename: "ModelAtomicCounterConnection",
  items:  Array<AtomicCounter | null >,
  nextToken?: string | null,
};

export type ModelBatchJobConfFilterInput = {
  allowedGroups?: ModelStringInput | null,
  and?: Array< ModelBatchJobConfFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  jobName?: ModelStringInput | null,
  not?: ModelBatchJobConfFilterInput | null,
  or?: Array< ModelBatchJobConfFilterInput | null > | null,
  remarks?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBatchJobConfConnection = {
  __typename: "ModelBatchJobConfConnection",
  items:  Array<BatchJobConf | null >,
  nextToken?: string | null,
};

export type ModelBatchJobFilterInput = {
  and?: Array< ModelBatchJobFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  expiredAt?: ModelIntInput | null,
  id?: ModelIDInput | null,
  jobName?: ModelStringInput | null,
  not?: ModelBatchJobFilterInput | null,
  or?: Array< ModelBatchJobFilterInput | null > | null,
  remarks?: ModelStringInput | null,
  status?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBatchJobConnection = {
  __typename: "ModelBatchJobConnection",
  items:  Array<BatchJob | null >,
  nextToken?: string | null,
};

export type BatchJob = {
  __typename: "BatchJob",
  createdAt?: string | null,
  expiredAt?: number | null,
  id: string,
  jobName: string,
  remarks: string,
  status: string,
  updatedAt?: string | null,
};

export type ModelStringKeyConditionInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
};

export type ModelBuildPriceFilterInput = {
  and?: Array< ModelBuildPriceFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelBuildPriceFilterInput | null,
  or?: Array< ModelBuildPriceFilterInput | null > | null,
  owner?: ModelStringInput | null,
  unitPriceCB?: ModelIntInput | null,
  unitPriceOther?: ModelIntInput | null,
  unitPriceRC?: ModelIntInput | null,
  unitPriceS?: ModelIntInput | null,
  unitPriceSRC?: ModelIntInput | null,
  unitPriceW?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  year?: ModelIntInput | null,
};

export type ModelBuildPriceConnection = {
  __typename: "ModelBuildPriceConnection",
  items:  Array<BuildPrice | null >,
  nextToken?: string | null,
};

export type ModelCognitoUserConnection = {
  __typename: "ModelCognitoUserConnection",
  errorMessage?: string | null,
  items?:  Array<CognitoUser | null > | null,
  nextToken?: string | null,
};

export type ModelCompanyFilterInputInput = {
  address?: CustomModelStringInputInput | null,
  and?: Array< ModelCompanyFilterInputInput | null > | null,
  areaNames?: CustomModelStringInputInput | null,
  areaPrefs?: CustomModelStringInputInput | null,
  areas?: CustomModelStringInputInput | null,
  bldConditionCompanies?: CustomModelStringInputInput | null,
  bldConditionSelections?: CustomModelStringInputInput | null,
  branchAddress?: CustomModelStringInputInput | null,
  branchFax?: CustomModelStringInputInput | null,
  branchId?: CustomModelIntInputInput | null,
  branchName?: CustomModelStringInputInput | null,
  branchTel?: CustomModelStringInputInput | null,
  branchUrl?: CustomModelStringInputInput | null,
  createdAt?: CustomModelStringInputInput | null,
  eAreaNames?: CustomModelStringInputInput | null,
  eAreas?: CustomModelStringInputInput | null,
  email?: CustomModelStringInputInput | null,
  estateTypes?: CustomModelStringInputInput | null,
  fax?: CustomModelStringInputInput | null,
  guaranter?: CustomModelStringInputInput | null,
  id?: CustomModelStringInputInput | null,
  infoName?: CustomModelStringInputInput | null,
  job?: CustomModelStringInputInput | null,
  latitude?: CustomModelFloatInputInput | null,
  license?: CustomModelStringInputInput | null,
  licenseCount?: CustomModelIntInputInput | null,
  licenseNo?: CustomModelStringInputInput | null,
  licenser?: CustomModelStringInputInput | null,
  logoImg?: CustomModelStringInputInput | null,
  longitude?: CustomModelFloatInputInput | null,
  name?: CustomModelStringInputInput | null,
  not?: ModelCompanyFilterInputInput | null,
  or?: Array< ModelCompanyFilterInputInput | null > | null,
  organization?: CustomModelStringInputInput | null,
  owner?: CustomModelStringInputInput | null,
  recNo?: CustomModelIntInputInput | null,
  remarks?: CustomModelStringInputInput | null,
  remarks2?: CustomModelStringInputInput | null,
  searchInfo?: CustomModelStringInputInput | null,
  startMark?: CustomModelStringInputInput | null,
  tel?: CustomModelStringInputInput | null,
  updatedAt?: CustomModelStringInputInput | null,
  url?: CustomModelStringInputInput | null,
};

export type CustomModelIntInputInput = {
  attributeExists?: boolean | null,
  attributeType?: CustomModelIntInputAttributeType | null,
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export enum CustomModelIntInputAttributeType {
  _null = "_null",
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
}


export type CustomModelFloatInputInput = {
  attributeExists?: boolean | null,
  attributeType?: CustomModelFloatInputAttributeType | null,
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export enum CustomModelFloatInputAttributeType {
  _null = "_null",
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
}


export type ModelCompanyConnection = {
  __typename: "ModelCompanyConnection",
  items?:  Array<CompanyType | null > | null,
  nextToken?: string | null,
};

export enum ListCompaniesBySearchInfoSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelDummyFilterInput = {
  and?: Array< ModelDummyFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  id?: ModelStringInput | null,
  kintoneAppScope?: ModelKintoneAppScopeInput | null,
  kintoneDataKind?: ModelKintoneDataKindInput | null,
  not?: ModelDummyFilterInput | null,
  or?: Array< ModelDummyFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelKintoneAppScopeInput = {
  eq?: KintoneAppScope | null,
  ne?: KintoneAppScope | null,
};

export type ModelKintoneDataKindInput = {
  eq?: KintoneDataKind | null,
  ne?: KintoneDataKind | null,
};

export type ModelDummyConnection = {
  __typename: "ModelDummyConnection",
  items:  Array<Dummy | null >,
  nextToken?: string | null,
};

export type ModelEstateFilterInputInput = {
  address?: CustomModelStringInputInput | null,
  and?: Array< ModelEstateFilterInputInput | null > | null,
  appearanceImgs?: CustomModelStringInputInput | null,
  area?: CustomModelStringInputInput | null,
  balconyArea?: CustomModelFloatInputInput | null,
  bcr?: CustomModelIntInputInput | null,
  bldConditionType?: CustomModelStringInputInput | null,
  buildingCompany?: CustomModelStringInputInput | null,
  buildingFloors?: CustomModelStringInputInput | null,
  cadastralMapPdf?: CustomModelStringInputInput | null,
  carsInParkingN?: CustomModelIntInputInput | null,
  city?: CustomModelStringInputInput | null,
  cityPlanningType?: CustomModelStringInputInput | null,
  cleaningMonth?: CustomModelIntInputInput | null,
  clearingType?: CustomModelStringInputInput | null,
  collectedAt?: CustomModelStringInputInput | null,
  companyAddress?: CustomModelStringInputInput | null,
  companyBranchId?: CustomModelIntInputInput | null,
  companyFax?: CustomModelStringInputInput | null,
  companyGuaranter?: CustomModelStringInputInput | null,
  companyId?: CustomModelStringInputInput | null,
  companyLicense?: CustomModelStringInputInput | null,
  companyName?: CustomModelStringInputInput | null,
  companyRecNo?: CustomModelIntInputInput | null,
  companyTel?: CustomModelStringInputInput | null,
  companyUrl?: CustomModelStringInputInput | null,
  completionMonth?: CustomModelIntInputInput | null,
  completionMonthS?: CustomModelStringInputInput | null,
  completionSchMonth?: CustomModelIntInputInput | null,
  condominiumId?: CustomModelStringInputInput | null,
  condominiumName?: CustomModelStringInputInput | null,
  condominiumRecNo?: CustomModelIntInputInput | null,
  confirmed?: CustomModelBooleanInputInput | null,
  createdAt?: CustomModelStringInputInput | null,
  currentStatus?: CustomModelStringInputInput | null,
  currentStatusB?: CustomModelStringInputInput | null,
  currentStatusFree?: CustomModelStringInputInput | null,
  currentStatusG?: CustomModelStringInputInput | null,
  deletedOnSumora?: CustomModelIntInputInput | null,
  drivewayPay?: CustomModelStringInputInput | null,
  eSchool?: CustomModelStringInputInput | null,
  estatePrice?: CustomModelFloatInputInput | null,
  estateType?: CustomModelStringInputInput | null,
  estateUrl?: CustomModelStringInputInput | null,
  exactLocation?: CustomModelIntInputInput | null,
  floor?: CustomModelIntInputInput | null,
  floorAreaRatio?: CustomModelIntInputInput | null,
  floorStructure?: CustomModelStringInputInput | null,
  fullAddress?: CustomModelStringInputInput | null,
  gas?: CustomModelStringInputInput | null,
  gasPdf?: CustomModelStringInputInput | null,
  groundPdf?: CustomModelStringInputInput | null,
  groundType?: CustomModelStringInputInput | null,
  groundTypeFree?: CustomModelStringInputInput | null,
  id?: CustomModelStringInputInput | null,
  infoName?: CustomModelStringInputInput | null,
  isLot?: CustomModelIntInputInput | null,
  jSchool?: CustomModelStringInputInput | null,
  landAreaType?: CustomModelStringInputInput | null,
  landRights?: CustomModelStringInputInput | null,
  latitude?: CustomModelFloatInputInput | null,
  layout?: CustomModelStringInputInput | null,
  layoutImgs?: CustomModelStringInputInput | null,
  license?: CustomModelStringInputInput | null,
  location?: CustomModelStringInputInput | null,
  longitude?: CustomModelFloatInputInput | null,
  managementFee?: CustomModelIntInputInput | null,
  managementType?: CustomModelStringInputInput | null,
  manager?: CustomModelStringInputInput | null,
  mapImg?: CustomModelStringInputInput | null,
  media?: CustomModelStringInputInput | null,
  mediationKind?: CustomModelStringInputInput | null,
  name?: CustomModelStringInputInput | null,
  nearlyLocation?: CustomModelIntInputInput | null,
  not?: ModelEstateFilterInputInput | null,
  notFoundAt?: CustomModelStringInputInput | null,
  or?: Array< ModelEstateFilterInputInput | null > | null,
  otherCost?: CustomModelIntInputInput | null,
  owner?: CustomModelStringInputInput | null,
  parking?: CustomModelStringInputInput | null,
  parkingFee?: CustomModelIntInputInput | null,
  parkingHeight?: CustomModelFloatInputInput | null,
  parkingMechOrPlane?: CustomModelStringInputInput | null,
  parkingTakeOver?: CustomModelStringInputInput | null,
  parkingTakeOverFree?: CustomModelStringInputInput | null,
  pet?: CustomModelStringInputInput | null,
  prefecture?: CustomModelStringInputInput | null,
  pricedAt?: CustomModelStringInputInput | null,
  purposeB?: CustomModelStringInputInput | null,
  purposeSummaryB?: CustomModelStringInputInput | null,
  recNo?: CustomModelIntInputInput | null,
  remarks?: CustomModelStringInputInput | null,
  repairCost?: CustomModelIntInputInput | null,
  roadDirection?: CustomModelStringInputInput | null,
  roadType?: CustomModelStringInputInput | null,
  roadWidth?: CustomModelFloatInputInput | null,
  room?: CustomModelStringInputInput | null,
  searchInfo?: CustomModelStringInputInput | null,
  seller?: CustomModelStringInputInput | null,
  sewer?: CustomModelStringInputInput | null,
  sewerPdf?: CustomModelStringInputInput | null,
  sold?: CustomModelBooleanInputInput | null,
  squareArea?: CustomModelFloatInputInput | null,
  status?: CustomModelStringInputInput | null,
  store?: CustomModelStringInputInput | null,
  structure?: CustomModelStringInputInput | null,
  structureFree?: CustomModelStringInputInput | null,
  subCompany2Address?: CustomModelStringInputInput | null,
  subCompany2Fax?: CustomModelStringInputInput | null,
  subCompany2Guaranter?: CustomModelStringInputInput | null,
  subCompany2Id?: CustomModelStringInputInput | null,
  subCompany2License?: CustomModelStringInputInput | null,
  subCompany2Name?: CustomModelStringInputInput | null,
  subCompany2Tel?: CustomModelStringInputInput | null,
  subCompany2Url?: CustomModelStringInputInput | null,
  subCompanyAddress?: CustomModelStringInputInput | null,
  subCompanyFax?: CustomModelStringInputInput | null,
  subCompanyGuaranter?: CustomModelStringInputInput | null,
  subCompanyId?: CustomModelStringInputInput | null,
  subCompanyLicense?: CustomModelStringInputInput | null,
  subCompanyName?: CustomModelStringInputInput | null,
  subCompanyRecNo?: CustomModelIntInputInput | null,
  subCompanyTel?: CustomModelStringInputInput | null,
  subCompanyUrl?: CustomModelStringInputInput | null,
  tileOnZoom12?: CustomModelStringInputInput | null,
  tileOnZoom14?: CustomModelStringInputInput | null,
  tileOnZoom16?: CustomModelStringInputInput | null,
  totalArea?: CustomModelFloatInputInput | null,
  totalHouses?: CustomModelIntInputInput | null,
  traffic?: CustomModelStringInputInput | null,
  tsuboArea?: CustomModelFloatInputInput | null,
  unitPrice?: CustomModelFloatInputInput | null,
  unsettledLocation?: CustomModelIntInputInput | null,
  updatedAt?: CustomModelStringInputInput | null,
  url?: CustomModelStringInputInput | null,
  useDistrict?: CustomModelStringInputInput | null,
  water?: CustomModelStringInputInput | null,
  waterPdf?: CustomModelStringInputInput | null,
};

export type CustomModelBooleanInputInput = {
  attributeExists?: boolean | null,
  attributeType?: CustomModelBooleanInputAttributeType | null,
  eq?: boolean | null,
  ne?: boolean | null,
};

export enum CustomModelBooleanInputAttributeType {
  _null = "_null",
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
}


export type ModelEstateConnection = {
  __typename: "ModelEstateConnection",
  items?:  Array<EstateType | null > | null,
  nextToken?: string | null,
};

export enum ListEstatesBySearchInfoSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type PointForPricingInputInput = {
  latitude?: number | null,
  longitude?: number | null,
};

export type ModelEstateConnectionForPricing = {
  __typename: "ModelEstateConnectionForPricing",
  items:  Array<EstateResponseForPricing | null >,
};

export type EstateResponseForPricing = {
  __typename: "EstateResponseForPricing",
  address?: string | null,
  appearanceImgs?: Array< string | null > | null,
  area?: string | null,
  balconyArea?: number | null,
  bcr?: number | null,
  bldConditionType?: string | null,
  buildingCompany?: string | null,
  buildingFloors?: string | null,
  cadastralMapPdf?: string | null,
  carsInParkingN?: number | null,
  city?: string | null,
  cityPlanningType?: string | null,
  cleaningMonth?: number | null,
  clearingType?: string | null,
  collectedAt?: string | null,
  companyAddress?: string | null,
  companyBranchId?: number | null,
  companyFax?: string | null,
  companyGuaranter?: string | null,
  companyId?: string | null,
  companyLicense?: string | null,
  companyName?: string | null,
  companyRecNo?: number | null,
  companyTel?: string | null,
  companyUrl?: string | null,
  completionMonth?: number | null,
  completionMonthS?: string | null,
  completionSchMonth?: number | null,
  condominiumId?: string | null,
  condominiumName?: string | null,
  condominiumRecNo?: number | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  currentStatus?: string | null,
  currentStatusB?: string | null,
  currentStatusFree?: string | null,
  currentStatusG?: string | null,
  deletedOnSumora?: number | null,
  drivewayPay?: string | null,
  eSchool?: Array< string | null > | null,
  estatePrice?: number | null,
  estateType?: string | null,
  estateUrl?: string | null,
  exactLocation?: number | null,
  floor?: number | null,
  floorAreaRatio?: number | null,
  floorStructure?: string | null,
  fullAddress?: string | null,
  gas?: string | null,
  gasPdf?: string | null,
  groundPdf?: string | null,
  groundType?: Array< string | null > | null,
  groundTypeFree?: string | null,
  id: string,
  infoName: string,
  isLot?: number | null,
  jSchool?: Array< string | null > | null,
  landAreaType?: string | null,
  landRights?: string | null,
  latitude?: number | null,
  layout?: string | null,
  layoutImgs?: Array< string | null > | null,
  license?: string | null,
  location?: string | null,
  longitude?: number | null,
  managementFee?: number | null,
  managementType?: string | null,
  manager?: string | null,
  mapImg?: string | null,
  media?: string | null,
  mediationKind?: string | null,
  name?: string | null,
  nearlyLocation?: number | null,
  notFoundAt?: string | null,
  otherCost?: number | null,
  owner?: string | null,
  parking?: string | null,
  parkingFee?: number | null,
  parkingHeight?: number | null,
  parkingMechOrPlane?: string | null,
  parkingTakeOver?: string | null,
  parkingTakeOverFree?: string | null,
  pet?: string | null,
  prefecture?: string | null,
  priceHistory?:  Array<Price | null > | null,
  pricedAt?: string | null,
  purposeB?: string | null,
  purposeSummaryB?: string | null,
  recNo?: number | null,
  remarks?: string | null,
  repairCost?: number | null,
  roadDirection?: string | null,
  roadType?: string | null,
  roadWidth?: number | null,
  room?: string | null,
  searchInfo: string,
  seller?: string | null,
  sewer?: string | null,
  sewerPdf?: string | null,
  sold?: boolean | null,
  squareArea?: number | null,
  status?: string | null,
  store?: string | null,
  structure?: string | null,
  structureFree?: string | null,
  subCompany2Address?: string | null,
  subCompany2Fax?: string | null,
  subCompany2Guaranter?: string | null,
  subCompany2Id?: string | null,
  subCompany2License?: string | null,
  subCompany2Name?: string | null,
  subCompany2Tel?: string | null,
  subCompany2Url?: string | null,
  subCompanyAddress?: string | null,
  subCompanyFax?: string | null,
  subCompanyGuaranter?: string | null,
  subCompanyId?: string | null,
  subCompanyLicense?: string | null,
  subCompanyName?: string | null,
  subCompanyRecNo?: number | null,
  subCompanyTel?: string | null,
  subCompanyUrl?: string | null,
  tileOnZoom12?: string | null,
  tileOnZoom14?: string | null,
  tileOnZoom16?: string | null,
  totalArea?: number | null,
  totalHouses?: number | null,
  traffic?: string | null,
  tsuboArea?: number | null,
  unitPrice?: number | null,
  unsettledLocation?: number | null,
  updatedAt?: string | null,
  url?: string | null,
  useDistrict?: Array< string | null > | null,
  water?: string | null,
  waterPdf?: string | null,
};

export type ModelReportFilterInput = {
  and?: Array< ModelReportFilterInput | null > | null,
  companyId?: ModelStringInput | null,
  companyName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  estateId?: ModelStringInput | null,
  estateName?: ModelStringInput | null,
  expiredAt?: ModelIntInput | null,
  id?: ModelIDInput | null,
  latitude?: ModelFloatInput | null,
  longitude?: ModelFloatInput | null,
  not?: ModelReportFilterInput | null,
  or?: Array< ModelReportFilterInput | null > | null,
  owner?: ModelStringInput | null,
  reportKind?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userName?: ModelStringInput | null,
};

export type ModelFloatInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelReportConnection = {
  __typename: "ModelReportConnection",
  items:  Array<Report | null >,
  nextToken?: string | null,
};

export type ModelScrapingFilterInput = {
  and?: Array< ModelScrapingFilterInput | null > | null,
  baseUrl?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  endedAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  input?: ModelStringInput | null,
  not?: ModelScrapingFilterInput | null,
  operation?: ModelStringInput | null,
  or?: Array< ModelScrapingFilterInput | null > | null,
  output?: ModelStringInput | null,
  prefName?: ModelStringInput | null,
  remarks?: ModelStringInput | null,
  resultKey?: ModelStringInput | null,
  sortKey?: ModelStringInput | null,
  startedAt?: ModelStringInput | null,
  status?: ModelStringInput | null,
  totalCount?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelScrapingConnection = {
  __typename: "ModelScrapingConnection",
  items:  Array<Scraping | null >,
  nextToken?: string | null,
};

export type Scraping = {
  __typename: "Scraping",
  baseUrl: string,
  createdAt?: string | null,
  endedAt?: string | null,
  input?: string | null,
  operation?: string | null,
  output?: string | null,
  prefName: string,
  remarks?: string | null,
  resultKey?: string | null,
  sortKey: string,
  startedAt?: string | null,
  status: string,
  totalCount?: number | null,
  updated?: ScrapingUpdateDetail | null,
  updatedAt?: string | null,
  updating?: ScrapingUpdateDetail | null,
};

export type ScrapingUpdateDetail = {
  __typename: "ScrapingUpdateDetail",
  blocked?: number | null,
  expired?: number | null,
  newRecord?: number | null,
  onSite?: number | null,
  requiresAuth?: number | null,
  return?: number | null,
  returnAndUpdatePrice?: number | null,
  scrapingFailed?: number | null,
  updateFailed?: number | null,
  updatePrice?: number | null,
};

export type ModelStickyNoteFilterInputInput = {
  and?: Array< ModelStickyNoteFilterInputInput | null > | null,
  color?: CustomModelStickyNoteColorInputInput | null,
  companyId?: CustomModelStringInputInput | null,
  createdAt?: CustomModelStringInputInput | null,
  description?: CustomModelStringInputInput | null,
  icon?: CustomModelStickyNoteIconInputInput | null,
  id?: CustomModelIDInputInput | null,
  infoName?: CustomModelStringInputInput | null,
  latitude?: CustomModelFloatInputInput | null,
  longitude?: CustomModelFloatInputInput | null,
  memoKind?: CustomModelStringInputInput | null,
  not?: ModelStickyNoteFilterInputInput | null,
  openLevel?: CustomModelStringInputInput | null,
  or?: Array< ModelStickyNoteFilterInputInput | null > | null,
  owner?: CustomModelStringInputInput | null,
  searchInfo?: CustomModelStringInputInput | null,
  tileOnZoom12?: CustomModelStringInputInput | null,
  tileOnZoom14?: CustomModelStringInputInput | null,
  tileOnZoom16?: CustomModelStringInputInput | null,
  updatedAt?: CustomModelStringInputInput | null,
  url1?: CustomModelStringInputInput | null,
  url2?: CustomModelStringInputInput | null,
  url3?: CustomModelStringInputInput | null,
};

export type CustomModelStickyNoteColorInputInput = {
  eq?: StickyNoteColor | null,
  ne?: StickyNoteColor | null,
};

export type CustomModelStickyNoteIconInputInput = {
  eq?: StickyNoteIcon | null,
  ne?: StickyNoteIcon | null,
};

export type ModelStickyNoteConnection = {
  __typename: "ModelStickyNoteConnection",
  items?:  Array<StickyNoteType | null > | null,
  nextToken?: string | null,
};

export type StickyNoteType = {
  __typename: "StickyNoteType",
  color?: StickyNoteColor | null,
  companyId: string,
  createdAt?: string | null,
  description?: string | null,
  icon?: StickyNoteIcon | null,
  id: string,
  infoName: string,
  latitude: number,
  longitude: number,
  memoKind: string,
  openLevel: string,
  owner: string,
  searchInfo: string,
  tileOnZoom12: string,
  tileOnZoom14: string,
  tileOnZoom16: string,
  updatedAt?: string | null,
  url1?: string | null,
  url2?: string | null,
  url3?: string | null,
};

export enum ListStickyNotesBySearchInfoSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelUserFilterInputInput = {
  agreement?: CustomModelBooleanInputInput | null,
  and?: Array< ModelUserFilterInputInput | null > | null,
  authenticatedAt?: CustomModelStringInputInput | null,
  companyBranchName?: CustomModelStringInputInput | null,
  companyId?: CustomModelStringInputInput | null,
  companyName?: CustomModelStringInputInput | null,
  createdAt?: CustomModelStringInputInput | null,
  email?: CustomModelStringInputInput | null,
  group?: CustomModelStringInputInput | null,
  id?: CustomModelIDInputInput | null,
  infoName?: CustomModelStringInputInput | null,
  name?: CustomModelStringInputInput | null,
  nameRuby?: CustomModelStringInputInput | null,
  not?: ModelUserFilterInputInput | null,
  or?: Array< ModelUserFilterInputInput | null > | null,
  owner?: CustomModelStringInputInput | null,
  paid?: CustomModelBooleanInputInput | null,
  pricingAvailable?: CustomModelBooleanInputInput | null,
  role?: CustomModelStringInputInput | null,
  searchInfo?: CustomModelStringInputInput | null,
  tel?: CustomModelStringInputInput | null,
  trial?: CustomModelBooleanInputInput | null,
  trialEndAt?: CustomModelStringInputInput | null,
  updatedAt?: CustomModelStringInputInput | null,
  username?: CustomModelStringInputInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items?:  Array<UserType | null > | null,
  nextToken?: string | null,
};

export enum ListUsersBySearchInfoSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type DeleteEstateInput = {
  companyId?: string | null,
  id: string,
  infoName: string,
};

export type EstateMutationResponse = {
  __typename: "EstateMutationResponse",
  errorMessage?: string | null,
  item?: EstateType | null,
};

export type ModelAnnounceConditionInput = {
  and?: Array< ModelAnnounceConditionInput | null > | null,
  body?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  expiredAt?: ModelIntInput | null,
  level?: ModelAnnounceLevelInput | null,
  not?: ModelAnnounceConditionInput | null,
  or?: Array< ModelAnnounceConditionInput | null > | null,
  owner?: ModelStringInput | null,
  subject?: ModelStringInput | null,
  to?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  ym?: ModelStringInput | null,
};

export type ModelAnnounceLevelInput = {
  eq?: AnnounceLevel | null,
  ne?: AnnounceLevel | null,
};

export type CreateAnnounceInput = {
  body: string,
  createdAt?: string | null,
  expiredAt?: number | null,
  id?: string | null,
  level: AnnounceLevel,
  owner: string,
  subject: string,
  to: string,
  updatedAt?: string | null,
  ym: string,
};

export type ModelBatchJobConditionInput = {
  and?: Array< ModelBatchJobConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  expiredAt?: ModelIntInput | null,
  jobName?: ModelStringInput | null,
  not?: ModelBatchJobConditionInput | null,
  or?: Array< ModelBatchJobConditionInput | null > | null,
  remarks?: ModelStringInput | null,
  status?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateBatchJobInput = {
  createdAt?: string | null,
  expiredAt?: number | null,
  id?: string | null,
  jobName: string,
  remarks: string,
  status: string,
  updatedAt?: string | null,
};

export type ModelBatchJobConfConditionInput = {
  allowedGroups?: ModelStringInput | null,
  and?: Array< ModelBatchJobConfConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  not?: ModelBatchJobConfConditionInput | null,
  or?: Array< ModelBatchJobConfConditionInput | null > | null,
  remarks?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateBatchJobConfInput = {
  allowedGroups?: Array< string | null > | null,
  createdAt?: string | null,
  jobName: string,
  remarks: string,
  updatedAt?: string | null,
};

export type ModelBuildPriceConditionInput = {
  and?: Array< ModelBuildPriceConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  not?: ModelBuildPriceConditionInput | null,
  or?: Array< ModelBuildPriceConditionInput | null > | null,
  owner?: ModelStringInput | null,
  unitPriceCB?: ModelIntInput | null,
  unitPriceOther?: ModelIntInput | null,
  unitPriceRC?: ModelIntInput | null,
  unitPriceS?: ModelIntInput | null,
  unitPriceSRC?: ModelIntInput | null,
  unitPriceW?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateBuildPriceInput = {
  createdAt?: string | null,
  owner: string,
  unitPriceCB: number,
  unitPriceOther: number,
  unitPriceRC: number,
  unitPriceS: number,
  unitPriceSRC: number,
  unitPriceW: number,
  updatedAt?: string | null,
  year: number,
};

export type ModelDummyConditionInput = {
  and?: Array< ModelDummyConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  kintoneAppScope?: ModelKintoneAppScopeInput | null,
  kintoneDataKind?: ModelKintoneDataKindInput | null,
  not?: ModelDummyConditionInput | null,
  or?: Array< ModelDummyConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateDummyInput = {
  id?: string | null,
  kintoneAppScope?: KintoneAppScope | null,
  kintoneDataKind?: KintoneDataKind | null,
};

export type CreateEstateInput = {
  address?: string | null,
  appearanceImgs?: Array< string | null > | null,
  area?: string | null,
  balconyArea?: number | null,
  bcr?: number | null,
  bldConditionType?: string | null,
  buildingCompany?: string | null,
  buildingFloors?: string | null,
  cadastralMapPdf?: string | null,
  carsInParkingN?: number | null,
  city?: string | null,
  cityPlanningType?: string | null,
  cleaningMonth?: number | null,
  clearingType?: string | null,
  collectedAt?: string | null,
  companyAddress?: string | null,
  companyBranchId?: number | null,
  companyFax?: string | null,
  companyGuaranter?: string | null,
  companyId?: string | null,
  companyLicense?: string | null,
  companyName?: string | null,
  companyRecNo?: number | null,
  companyTel?: string | null,
  companyUrl?: string | null,
  completionMonth?: number | null,
  completionMonthS?: string | null,
  completionSchMonth?: number | null,
  condominiumId?: string | null,
  condominiumName?: string | null,
  condominiumRecNo?: number | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  currentStatus?: string | null,
  currentStatusB?: string | null,
  currentStatusFree?: string | null,
  currentStatusG?: string | null,
  deletedOnSumora?: number | null,
  drivewayPay?: string | null,
  eSchool?: Array< string | null > | null,
  estatePrice?: number | null,
  estateType?: string | null,
  estateUrl?: string | null,
  exactLocation?: number | null,
  floor?: number | null,
  floorAreaRatio?: number | null,
  floorStructure?: string | null,
  fullAddress?: string | null,
  gas?: string | null,
  gasPdf?: string | null,
  groundPdf?: string | null,
  groundType?: Array< string | null > | null,
  groundTypeFree?: string | null,
  id: string,
  infoName: string,
  isLot?: number | null,
  jSchool?: Array< string | null > | null,
  landAreaType?: string | null,
  landRights?: string | null,
  latitude?: number | null,
  layout?: string | null,
  layoutImgs?: Array< string | null > | null,
  license?: string | null,
  location?: string | null,
  longitude?: number | null,
  managementFee?: number | null,
  managementType?: string | null,
  manager?: string | null,
  mapImg?: string | null,
  media?: string | null,
  mediationKind?: string | null,
  name?: string | null,
  nearlyLocation?: number | null,
  notFoundAt?: string | null,
  otherCost?: number | null,
  owner?: string | null,
  parking?: string | null,
  parkingFee?: number | null,
  parkingHeight?: number | null,
  parkingMechOrPlane?: string | null,
  parkingTakeOver?: string | null,
  parkingTakeOverFree?: string | null,
  pet?: string | null,
  prefecture?: string | null,
  pricedAt?: string | null,
  purposeB?: string | null,
  purposeSummaryB?: string | null,
  recNo?: number | null,
  remarks?: string | null,
  repairCost?: number | null,
  roadDirection?: string | null,
  roadType?: string | null,
  roadWidth?: number | null,
  room?: string | null,
  searchInfo: string,
  seller?: string | null,
  sewer?: string | null,
  sewerPdf?: string | null,
  squareArea?: number | null,
  status?: string | null,
  store?: string | null,
  structure?: string | null,
  structureFree?: string | null,
  subCompany2Address?: string | null,
  subCompany2Fax?: string | null,
  subCompany2Guaranter?: string | null,
  subCompany2Id?: string | null,
  subCompany2License?: string | null,
  subCompany2Name?: string | null,
  subCompany2Tel?: string | null,
  subCompany2Url?: string | null,
  subCompanyAddress?: string | null,
  subCompanyFax?: string | null,
  subCompanyGuaranter?: string | null,
  subCompanyId?: string | null,
  subCompanyLicense?: string | null,
  subCompanyName?: string | null,
  subCompanyRecNo?: number | null,
  subCompanyTel?: string | null,
  subCompanyUrl?: string | null,
  tileOnZoom12?: string | null,
  tileOnZoom14?: string | null,
  tileOnZoom16?: string | null,
  totalArea?: number | null,
  totalHouses?: number | null,
  traffic?: string | null,
  tsuboArea?: number | null,
  unitPrice?: number | null,
  unsettledLocation?: number | null,
  updatedAt?: string | null,
  url?: string | null,
  useDistrict?: Array< string | null > | null,
  water?: string | null,
  waterPdf?: string | null,
};

export type CreatePublicEstateInput = {
  companyId: string,
  estateId: string,
  tel?: string | null,
};

export type PublicEstateMutationResponse = {
  __typename: "PublicEstateMutationResponse",
  id: string,
};

export type CreatePublicEstatePdfInput = {
  url: string,
};

export type PublicEstatePdfMutationResponse = {
  __typename: "PublicEstatePdfMutationResponse",
  pdf: string,
};

export type ModelReportConditionInput = {
  and?: Array< ModelReportConditionInput | null > | null,
  companyId?: ModelStringInput | null,
  companyName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  estateId?: ModelStringInput | null,
  estateName?: ModelStringInput | null,
  expiredAt?: ModelIntInput | null,
  latitude?: ModelFloatInput | null,
  longitude?: ModelFloatInput | null,
  not?: ModelReportConditionInput | null,
  or?: Array< ModelReportConditionInput | null > | null,
  owner?: ModelStringInput | null,
  reportKind?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userName?: ModelStringInput | null,
};

export type CreateReportInput = {
  companyId: string,
  companyName: string,
  createdAt?: string | null,
  description?: string | null,
  estateId: string,
  estateName?: string | null,
  expiredAt?: number | null,
  id?: string | null,
  latitude?: number | null,
  longitude?: number | null,
  owner: string,
  reportKind: string,
  updatedAt?: string | null,
  userName: string,
};

export type ModelScrapingConditionInput = {
  and?: Array< ModelScrapingConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  endedAt?: ModelStringInput | null,
  input?: ModelStringInput | null,
  not?: ModelScrapingConditionInput | null,
  operation?: ModelStringInput | null,
  or?: Array< ModelScrapingConditionInput | null > | null,
  output?: ModelStringInput | null,
  prefName?: ModelStringInput | null,
  remarks?: ModelStringInput | null,
  resultKey?: ModelStringInput | null,
  startedAt?: ModelStringInput | null,
  status?: ModelStringInput | null,
  totalCount?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateScrapingInput = {
  baseUrl: string,
  createdAt?: string | null,
  endedAt?: string | null,
  input?: string | null,
  operation?: string | null,
  output?: string | null,
  prefName: string,
  remarks?: string | null,
  resultKey?: string | null,
  sortKey: string,
  startedAt?: string | null,
  status: string,
  totalCount?: number | null,
  updated?: ScrapingUpdateDetailInput | null,
  updatedAt?: string | null,
  updating?: ScrapingUpdateDetailInput | null,
};

export type ScrapingUpdateDetailInput = {
  blocked?: number | null,
  expired?: number | null,
  newRecord?: number | null,
  onSite?: number | null,
  requiresAuth?: number | null,
  return?: number | null,
  returnAndUpdatePrice?: number | null,
  scrapingFailed?: number | null,
  updateFailed?: number | null,
  updatePrice?: number | null,
};

export type CreateStickyNoteInput = {
  color?: StickyNoteColor | null,
  companyId: string,
  createdAt?: string | null,
  description?: string | null,
  icon?: StickyNoteIcon | null,
  id?: string | null,
  infoName: string,
  latitude: number,
  longitude: number,
  memoKind: string,
  openLevel: string,
  owner: string,
  searchInfo: string,
  tileOnZoom12: string,
  tileOnZoom14: string,
  tileOnZoom16: string,
  updatedAt?: string | null,
  url1?: string | null,
  url2?: string | null,
  url3?: string | null,
};

export type StickyNoteMutationResponse = {
  __typename: "StickyNoteMutationResponse",
  errorMessage?: string | null,
  item?: StickyNoteType | null,
};

export type DeleteAnnounceInput = {
  id: string,
};

export type DeleteBatchJobInput = {
  id: string,
};

export type DeleteBatchJobConfInput = {
  jobName: string,
};

export type DeleteBuildPriceInput = {
  year: number,
};

export type DeleteCompanyInput = {
  id: string,
  infoName: string,
};

export type CompanyMutationResponse = {
  __typename: "CompanyMutationResponse",
  errorMessage?: string | null,
  item?: CompanyType | null,
};

export type DeleteDummyInput = {
  id: string,
};

export type DeleteReportInput = {
  id: string,
};

export type DeleteStickyNoteInput = {
  companyId?: string | null,
  id: string,
  infoName: string,
};

export type NotifyEstateInput = {
  address?: string | null,
  appearanceImgs?: Array< string | null > | null,
  area?: string | null,
  balconyArea?: number | null,
  bcr?: number | null,
  bldConditionType?: string | null,
  buildingCompany?: string | null,
  buildingFloors?: string | null,
  cadastralMapPdf?: string | null,
  carsInParkingN?: number | null,
  city?: string | null,
  cityPlanningType?: string | null,
  cleaningMonth?: number | null,
  clearingType?: string | null,
  collectedAt?: string | null,
  companyAddress?: string | null,
  companyBranchId?: number | null,
  companyFax?: string | null,
  companyGuaranter?: string | null,
  companyId?: string | null,
  companyLicense?: string | null,
  companyName?: string | null,
  companyRecNo?: number | null,
  companyTel?: string | null,
  companyUrl?: string | null,
  completionMonth?: number | null,
  completionMonthS?: string | null,
  completionSchMonth?: number | null,
  condominiumId?: string | null,
  condominiumName?: string | null,
  condominiumRecNo?: number | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  currentStatus?: string | null,
  currentStatusB?: string | null,
  currentStatusFree?: string | null,
  currentStatusG?: string | null,
  deletedOnSumora?: number | null,
  drivewayPay?: string | null,
  eSchool?: Array< string | null > | null,
  estatePrice?: number | null,
  estateType?: string | null,
  estateUrl?: string | null,
  exactLocation?: number | null,
  floor?: number | null,
  floorAreaRatio?: number | null,
  floorStructure?: string | null,
  fullAddress?: string | null,
  gas?: string | null,
  gasPdf?: string | null,
  groundPdf?: string | null,
  groundType?: Array< string | null > | null,
  groundTypeFree?: string | null,
  id: string,
  infoName: string,
  isLot?: number | null,
  jSchool?: Array< string | null > | null,
  landAreaType?: string | null,
  landRights?: string | null,
  latitude?: number | null,
  layout?: string | null,
  layoutImgs?: Array< string | null > | null,
  license?: string | null,
  location?: string | null,
  longitude?: number | null,
  managementFee?: number | null,
  managementType?: string | null,
  manager?: string | null,
  mapImg?: string | null,
  media?: string | null,
  mediationKind?: string | null,
  name?: string | null,
  nearlyLocation?: number | null,
  notFoundAt?: string | null,
  otherCost?: number | null,
  owner?: string | null,
  parking?: string | null,
  parkingFee?: number | null,
  parkingHeight?: number | null,
  parkingMechOrPlane?: string | null,
  parkingTakeOver?: string | null,
  parkingTakeOverFree?: string | null,
  pet?: string | null,
  prefecture?: string | null,
  priceHistory?: Array< PriceInput | null > | null,
  pricedAt?: string | null,
  purposeB?: string | null,
  purposeSummaryB?: string | null,
  recNo?: number | null,
  remarks?: string | null,
  repairCost?: number | null,
  roadDirection?: string | null,
  roadType?: string | null,
  roadWidth?: number | null,
  room?: string | null,
  searchInfo: string,
  seller?: string | null,
  sewer?: string | null,
  sewerPdf?: string | null,
  sold?: boolean | null,
  squareArea?: number | null,
  status?: string | null,
  store?: string | null,
  structure?: string | null,
  structureFree?: string | null,
  subCompany2Address?: string | null,
  subCompany2Fax?: string | null,
  subCompany2Guaranter?: string | null,
  subCompany2Id?: string | null,
  subCompany2License?: string | null,
  subCompany2Name?: string | null,
  subCompany2Tel?: string | null,
  subCompany2Url?: string | null,
  subCompanyAddress?: string | null,
  subCompanyFax?: string | null,
  subCompanyGuaranter?: string | null,
  subCompanyId?: string | null,
  subCompanyLicense?: string | null,
  subCompanyName?: string | null,
  subCompanyRecNo?: number | null,
  subCompanyTel?: string | null,
  subCompanyUrl?: string | null,
  tileOnZoom12?: string | null,
  tileOnZoom14?: string | null,
  tileOnZoom16?: string | null,
  totalArea?: number | null,
  totalHouses?: number | null,
  traffic?: string | null,
  tsuboArea?: number | null,
  unitPrice?: number | null,
  unsettledLocation?: number | null,
  updatedAt?: string | null,
  url?: string | null,
  useDistrict?: Array< string | null > | null,
  water?: string | null,
  waterPdf?: string | null,
};

export type PriceInput = {
  price?: number | null,
  pricedAt?: string | null,
};

export type EstateNotifyResponse = {
  __typename: "EstateNotifyResponse",
  address?: string | null,
  appearanceImgs?: Array< string | null > | null,
  area?: string | null,
  balconyArea?: number | null,
  bcr?: number | null,
  bldConditionType?: string | null,
  buildingCompany?: string | null,
  buildingFloors?: string | null,
  cadastralMapPdf?: string | null,
  carsInParkingN?: number | null,
  city?: string | null,
  cityPlanningType?: string | null,
  cleaningMonth?: number | null,
  clearingType?: string | null,
  collectedAt?: string | null,
  companyAddress?: string | null,
  companyBranchId?: number | null,
  companyFax?: string | null,
  companyGuaranter?: string | null,
  companyId?: string | null,
  companyLicense?: string | null,
  companyName?: string | null,
  companyRecNo?: number | null,
  companyTel?: string | null,
  companyUrl?: string | null,
  completionMonth?: number | null,
  completionMonthS?: string | null,
  completionSchMonth?: number | null,
  condominiumId?: string | null,
  condominiumName?: string | null,
  condominiumRecNo?: number | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  currentStatus?: string | null,
  currentStatusB?: string | null,
  currentStatusFree?: string | null,
  currentStatusG?: string | null,
  deletedOnSumora?: number | null,
  drivewayPay?: string | null,
  eSchool?: Array< string | null > | null,
  estatePrice?: number | null,
  estateType?: string | null,
  estateUrl?: string | null,
  exactLocation?: number | null,
  floor?: number | null,
  floorAreaRatio?: number | null,
  floorStructure?: string | null,
  fullAddress?: string | null,
  gas?: string | null,
  gasPdf?: string | null,
  groundPdf?: string | null,
  groundType?: Array< string | null > | null,
  groundTypeFree?: string | null,
  id?: string | null,
  infoName?: string | null,
  isLot?: number | null,
  jSchool?: Array< string | null > | null,
  landAreaType?: string | null,
  landRights?: string | null,
  latitude?: number | null,
  layout?: string | null,
  layoutImgs?: Array< string | null > | null,
  license?: string | null,
  location?: string | null,
  longitude?: number | null,
  managementFee?: number | null,
  managementType?: string | null,
  manager?: string | null,
  mapImg?: string | null,
  media?: string | null,
  mediationKind?: string | null,
  name?: string | null,
  nearlyLocation?: number | null,
  notFoundAt?: string | null,
  otherCost?: number | null,
  owner?: string | null,
  parking?: string | null,
  parkingFee?: number | null,
  parkingHeight?: number | null,
  parkingMechOrPlane?: string | null,
  parkingTakeOver?: string | null,
  parkingTakeOverFree?: string | null,
  pet?: string | null,
  prefecture?: string | null,
  priceHistory?:  Array<Price | null > | null,
  pricedAt?: string | null,
  purposeB?: string | null,
  purposeSummaryB?: string | null,
  recNo?: number | null,
  remarks?: string | null,
  repairCost?: number | null,
  roadDirection?: string | null,
  roadType?: string | null,
  roadWidth?: number | null,
  room?: string | null,
  searchInfo?: string | null,
  seller?: string | null,
  sewer?: string | null,
  sewerPdf?: string | null,
  sold?: boolean | null,
  squareArea?: number | null,
  status?: string | null,
  store?: string | null,
  structure?: string | null,
  structureFree?: string | null,
  subCompany2Address?: string | null,
  subCompany2Fax?: string | null,
  subCompany2Guaranter?: string | null,
  subCompany2Id?: string | null,
  subCompany2License?: string | null,
  subCompany2Name?: string | null,
  subCompany2Tel?: string | null,
  subCompany2Url?: string | null,
  subCompanyAddress?: string | null,
  subCompanyFax?: string | null,
  subCompanyGuaranter?: string | null,
  subCompanyId?: string | null,
  subCompanyLicense?: string | null,
  subCompanyName?: string | null,
  subCompanyRecNo?: number | null,
  subCompanyTel?: string | null,
  subCompanyUrl?: string | null,
  tileOnZoom12?: string | null,
  tileOnZoom14?: string | null,
  tileOnZoom16?: string | null,
  totalArea?: number | null,
  totalHouses?: number | null,
  traffic?: string | null,
  tsuboArea?: number | null,
  unitPrice?: number | null,
  unsettledLocation?: number | null,
  updatedAt?: string | null,
  url?: string | null,
  useDistrict?: Array< string | null > | null,
  water?: string | null,
  waterPdf?: string | null,
};

export type DefaultConditionInput = {
  alsoCreatedAtFrom?: number | null,
  alsoCreatedAtTo?: number | null,
  alsoPricedAtFrom?: number | null,
  alsoPricedAtTo?: number | null,
  areaPrefs?: Array< string | null > | null,
  areas?: Array< string | null > | null,
  bldConditionSelections?: Array< string | null > | null,
  companyRecNo?: number | null,
  completionYMFrom?: number | null,
  completionYMTo?: number | null,
  estatePriceFrom?: number | null,
  estatePriceTo?: number | null,
  estateTypes?: Array< string | null > | null,
  exceptForRent?: boolean | null,
  flat?: boolean | null,
  forRent?: boolean | null,
  petOk?: boolean | null,
  priceLabel?: boolean | null,
  purposeSummaryBs?: Array< string | null > | null,
  roomsFrom?: number | null,
  roomsTo?: number | null,
  squareAreaOfMansionFrom?: number | null,
  squareAreaOfMansionTo?: number | null,
  structureSummaries?: Array< string | null > | null,
  tsuboAreaFrom?: number | null,
  tsuboAreaTo?: number | null,
  tsuboLabel?: boolean | null,
  venderOnly?: boolean | null,
};

export type SendAnnounceMailInput = {
  announceId: string,
};

export type SendAnnounceMailResponse = {
  __typename: "SendAnnounceMailResponse",
  errorMessage?: string | null,
};

export type UpdateAnnounceInput = {
  body?: string | null,
  createdAt?: string | null,
  expiredAt?: number | null,
  id: string,
  level?: AnnounceLevel | null,
  owner?: string | null,
  subject?: string | null,
  to?: string | null,
  updatedAt?: string | null,
  ym?: string | null,
};

export type UpdateBatchJobInput = {
  createdAt?: string | null,
  expiredAt?: number | null,
  id: string,
  jobName?: string | null,
  remarks?: string | null,
  status?: string | null,
  updatedAt?: string | null,
};

export type UpdateBatchJobConfInput = {
  allowedGroups?: Array< string | null > | null,
  createdAt?: string | null,
  jobName: string,
  remarks?: string | null,
  updatedAt?: string | null,
};

export type UpdateBuildPriceInput = {
  createdAt?: string | null,
  owner?: string | null,
  unitPriceCB?: number | null,
  unitPriceOther?: number | null,
  unitPriceRC?: number | null,
  unitPriceS?: number | null,
  unitPriceSRC?: number | null,
  unitPriceW?: number | null,
  updatedAt?: string | null,
  year: number,
};

export type UpdateCompanyInput = {
  areaNames?: Array< string | null > | null,
  areaPrefs?: Array< string | null > | null,
  areas?: Array< string | null > | null,
  bldConditionCompanies?: Array< string | null > | null,
  bldConditionSelections?: Array< string | null > | null,
  createdAt?: string | null,
  eAreaNames?: Array< string | null > | null,
  eAreas?: Array< string | null > | null,
  email?: string | null,
  estateTypes?: Array< string | null > | null,
  id: string,
  infoName: string,
  latitude?: number | null,
  logoImg?: string | null,
  longitude?: number | null,
  owner?: string | null,
  remarks2?: string | null,
  updatedAt?: string | null,
};

export type UpdateDummyInput = {
  id: string,
  kintoneAppScope?: KintoneAppScope | null,
  kintoneDataKind?: KintoneDataKind | null,
};

export type UpdateEstateInput = {
  address?: string | null,
  appearanceImgs?: Array< string | null > | null,
  area?: string | null,
  balconyArea?: number | null,
  bcr?: number | null,
  bldConditionType?: string | null,
  buildingCompany?: string | null,
  buildingFloors?: string | null,
  cadastralMapPdf?: string | null,
  carsInParkingN?: number | null,
  city?: string | null,
  cityPlanningType?: string | null,
  cleaningMonth?: number | null,
  clearingType?: string | null,
  collectedAt?: string | null,
  companyAddress?: string | null,
  companyBranchId?: number | null,
  companyFax?: string | null,
  companyGuaranter?: string | null,
  companyId?: string | null,
  companyLicense?: string | null,
  companyName?: string | null,
  companyRecNo?: number | null,
  companyTel?: string | null,
  companyUrl?: string | null,
  completionMonth?: number | null,
  completionMonthS?: string | null,
  completionSchMonth?: number | null,
  condominiumId?: string | null,
  condominiumName?: string | null,
  condominiumRecNo?: number | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  currentStatus?: string | null,
  currentStatusB?: string | null,
  currentStatusFree?: string | null,
  currentStatusG?: string | null,
  deletedOnSumora?: number | null,
  drivewayPay?: string | null,
  eSchool?: Array< string | null > | null,
  estatePrice?: number | null,
  estateType?: string | null,
  estateUrl?: string | null,
  exactLocation?: number | null,
  floor?: number | null,
  floorAreaRatio?: number | null,
  floorStructure?: string | null,
  fullAddress?: string | null,
  gas?: string | null,
  gasPdf?: string | null,
  groundPdf?: string | null,
  groundType?: Array< string | null > | null,
  groundTypeFree?: string | null,
  id: string,
  infoName: string,
  isLot?: number | null,
  jSchool?: Array< string | null > | null,
  landAreaType?: string | null,
  landRights?: string | null,
  latitude?: number | null,
  layout?: string | null,
  layoutImgs?: Array< string | null > | null,
  license?: string | null,
  location?: string | null,
  longitude?: number | null,
  managementFee?: number | null,
  managementType?: string | null,
  manager?: string | null,
  mapImg?: string | null,
  media?: string | null,
  mediationKind?: string | null,
  name?: string | null,
  nearlyLocation?: number | null,
  notFoundAt?: string | null,
  otherCost?: number | null,
  owner?: string | null,
  parking?: string | null,
  parkingFee?: number | null,
  parkingHeight?: number | null,
  parkingMechOrPlane?: string | null,
  parkingTakeOver?: string | null,
  parkingTakeOverFree?: string | null,
  pet?: string | null,
  prefecture?: string | null,
  pricedAt?: string | null,
  purposeB?: string | null,
  purposeSummaryB?: string | null,
  recNo?: number | null,
  remarks?: string | null,
  repairCost?: number | null,
  roadDirection?: string | null,
  roadType?: string | null,
  roadWidth?: number | null,
  room?: string | null,
  searchInfo?: string | null,
  seller?: string | null,
  sewer?: string | null,
  sewerPdf?: string | null,
  squareArea?: number | null,
  status?: string | null,
  store?: string | null,
  structure?: string | null,
  structureFree?: string | null,
  subCompany2Address?: string | null,
  subCompany2Fax?: string | null,
  subCompany2Guaranter?: string | null,
  subCompany2Id?: string | null,
  subCompany2License?: string | null,
  subCompany2Name?: string | null,
  subCompany2Tel?: string | null,
  subCompany2Url?: string | null,
  subCompanyAddress?: string | null,
  subCompanyFax?: string | null,
  subCompanyGuaranter?: string | null,
  subCompanyId?: string | null,
  subCompanyLicense?: string | null,
  subCompanyName?: string | null,
  subCompanyRecNo?: number | null,
  subCompanyTel?: string | null,
  subCompanyUrl?: string | null,
  tileOnZoom12?: string | null,
  tileOnZoom14?: string | null,
  tileOnZoom16?: string | null,
  totalArea?: number | null,
  totalHouses?: number | null,
  traffic?: string | null,
  tsuboArea?: number | null,
  unitPrice?: number | null,
  unsettledLocation?: number | null,
  updatedAt?: string | null,
  url?: string | null,
  useDistrict?: Array< string | null > | null,
  water?: string | null,
  waterPdf?: string | null,
};

export type UpdateReportInput = {
  companyId?: string | null,
  companyName?: string | null,
  createdAt?: string | null,
  description?: string | null,
  estateId?: string | null,
  estateName?: string | null,
  expiredAt?: number | null,
  id: string,
  latitude?: number | null,
  longitude?: number | null,
  owner?: string | null,
  reportKind?: string | null,
  updatedAt?: string | null,
  userName?: string | null,
};

export type UpdateScrapingInput = {
  baseUrl: string,
  createdAt?: string | null,
  endedAt?: string | null,
  input?: string | null,
  operation?: string | null,
  output?: string | null,
  prefName?: string | null,
  remarks?: string | null,
  resultKey?: string | null,
  sortKey: string,
  startedAt?: string | null,
  status?: string | null,
  totalCount?: number | null,
  updated?: ScrapingUpdateDetailInput | null,
  updatedAt?: string | null,
  updating?: ScrapingUpdateDetailInput | null,
};

export type UpdateStickyNoteInput = {
  color?: StickyNoteColor | null,
  companyId?: string | null,
  createdAt?: string | null,
  description?: string | null,
  icon?: StickyNoteIcon | null,
  id: string,
  infoName: string,
  latitude?: number | null,
  longitude?: number | null,
  memoKind?: string | null,
  openLevel?: string | null,
  owner?: string | null,
  searchInfo?: string | null,
  tileOnZoom12?: string | null,
  tileOnZoom14?: string | null,
  tileOnZoom16?: string | null,
  updatedAt?: string | null,
  url1?: string | null,
  url2?: string | null,
  url3?: string | null,
};

export type ModelSubscriptionBatchJobFilterInput = {
  and?: Array< ModelSubscriptionBatchJobFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  expiredAt?: ModelSubscriptionIntInput | null,
  id?: ModelSubscriptionIDInput | null,
  jobName?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionBatchJobFilterInput | null > | null,
  remarks?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionStringInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  in?: Array< string | null > | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIntInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  in?: Array< number | null > | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionIDInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  in?: Array< string | null > | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionDummyFilterInput = {
  and?: Array< ModelSubscriptionDummyFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionStringInput | null,
  kintoneAppScope?: ModelSubscriptionStringInput | null,
  kintoneDataKind?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionDummyFilterInput | null > | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionScrapingFilterInput = {
  and?: Array< ModelSubscriptionScrapingFilterInput | null > | null,
  baseUrl?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  endedAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  input?: ModelSubscriptionStringInput | null,
  operation?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionScrapingFilterInput | null > | null,
  output?: ModelSubscriptionStringInput | null,
  prefName?: ModelSubscriptionStringInput | null,
  remarks?: ModelSubscriptionStringInput | null,
  resultKey?: ModelSubscriptionStringInput | null,
  sortKey?: ModelSubscriptionStringInput | null,
  startedAt?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  totalCount?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type GetAnnounceQueryVariables = {
  id: string,
};

export type GetAnnounceQuery = {
  getAnnounce?:  {
    __typename: "Announce",
    body: string,
    createdAt: string,
    expiredAt?: number | null,
    id: string,
    level: AnnounceLevel,
    owner: string,
    subject: string,
    to: string,
    updatedAt?: string | null,
    ym: string,
  } | null,
};

export type GetAtomicCounterQueryVariables = {
  counterName: string,
};

export type GetAtomicCounterQuery = {
  getAtomicCounter?:  {
    __typename: "AtomicCounter",
    counterName: string,
    createdAt?: string | null,
    kind: string,
    sequence: number,
    updatedAt?: string | null,
  } | null,
};

export type GetBatchJobConfQueryVariables = {
  jobName: string,
};

export type GetBatchJobConfQuery = {
  getBatchJobConf?:  {
    __typename: "BatchJobConf",
    allowedGroups?: Array< string | null > | null,
    createdAt?: string | null,
    jobName: string,
    remarks: string,
    updatedAt?: string | null,
  } | null,
};

export type GetBuildPriceQueryVariables = {
  year: number,
};

export type GetBuildPriceQuery = {
  getBuildPrice?:  {
    __typename: "BuildPrice",
    createdAt?: string | null,
    owner: string,
    unitPriceCB: number,
    unitPriceOther: number,
    unitPriceRC: number,
    unitPriceS: number,
    unitPriceSRC: number,
    unitPriceW: number,
    updatedAt?: string | null,
    year: number,
  } | null,
};

export type GetCognitoUserFQueryVariables = {
  username?: string | null,
};

export type GetCognitoUserFQuery = {
  getCognitoUserF?:  {
    __typename: "CognitoUserResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "CognitoUser",
      Attributes?:  Array< {
        __typename: "CognitoUserAttribute",
        Name?: string | null,
        Value?: string | null,
      } | null > | null,
      Company?:  {
        __typename: "CompanyType",
        address?: string | null,
        areaNames?: Array< string | null > | null,
        areaPrefs?: Array< string | null > | null,
        areas?: Array< string | null > | null,
        bldConditionCompanies?: Array< string | null > | null,
        bldConditionSelections?: Array< string | null > | null,
        branchAddress?: string | null,
        branchFax?: string | null,
        branchId?: number | null,
        branchName?: string | null,
        branchTel?: string | null,
        branchUrl?: string | null,
        createdAt?: string | null,
        eAreaNames?: Array< string | null > | null,
        eAreas?: Array< string | null > | null,
        email?: string | null,
        estateTypes?: Array< string | null > | null,
        fax?: string | null,
        guaranter?: string | null,
        id: string,
        infoName: string,
        job?: string | null,
        latitude?: number | null,
        license?: string | null,
        licenseCount?: number | null,
        licenseNo?: string | null,
        licenser?: string | null,
        logoImg?: string | null,
        longitude?: number | null,
        name?: string | null,
        organization?: string | null,
        owner?: string | null,
        recNo?: number | null,
        remarks?: string | null,
        remarks2?: string | null,
        searchInfo: string,
        startMark?: string | null,
        tel?: string | null,
        updatedAt?: string | null,
        url?: string | null,
      } | null,
      Enabled?: boolean | null,
      Groups?:  Array< {
        __typename: "CognitoGroup",
        CreationDate?: string | null,
        Description?: string | null,
        GroupName?: string | null,
        LastModifiedDate?: string | null,
        Precedence?: number | null,
        RoleArn?: string | null,
        UserPoolId?: string | null,
      } | null > | null,
      MFAOptions?:  Array< {
        __typename: "CognitoUserMFAOption",
        AttributeName?: string | null,
        DeliveryMedium?: CognitoUserMFAOptionDeliveryMedium | null,
      } | null > | null,
      User?:  {
        __typename: "UserType",
        agreement?: boolean | null,
        authenticatedAt?: string | null,
        companyBranchName?: string | null,
        companyId?: string | null,
        companyName?: string | null,
        createdAt?: string | null,
        defaultCondition?:  {
          __typename: "DefaultCondition",
          alsoCreatedAtFrom?: number | null,
          alsoCreatedAtTo?: number | null,
          alsoPricedAtFrom?: number | null,
          alsoPricedAtTo?: number | null,
          areaPrefs?: Array< string | null > | null,
          areas?: Array< string | null > | null,
          bldConditionSelections?: Array< string | null > | null,
          companyRecNo?: number | null,
          completionYMFrom?: number | null,
          completionYMTo?: number | null,
          estatePriceFrom?: number | null,
          estatePriceTo?: number | null,
          estateTypes?: Array< string | null > | null,
          exceptForRent?: boolean | null,
          flat?: boolean | null,
          forRent?: boolean | null,
          petOk?: boolean | null,
          priceLabel?: boolean | null,
          purposeSummaryBs?: Array< string | null > | null,
          roomsFrom?: number | null,
          roomsTo?: number | null,
          squareAreaOfMansionFrom?: number | null,
          squareAreaOfMansionTo?: number | null,
          structureSummaries?: Array< string | null > | null,
          tsuboAreaFrom?: number | null,
          tsuboAreaTo?: number | null,
          tsuboLabel?: boolean | null,
          venderOnly?: boolean | null,
        } | null,
        email?: string | null,
        group?: string | null,
        infoName: string,
        name?: string | null,
        nameRuby?: string | null,
        owner?: string | null,
        paid?: boolean | null,
        pricingAvailable?: boolean | null,
        role?: string | null,
        searchInfo?: string | null,
        tel?: string | null,
        trial?: boolean | null,
        trialEndAt?: string | null,
        updatedAt?: string | null,
        username: string,
      } | null,
      UserCreateDate?: string | null,
      UserLastModifiedDate?: string | null,
      UserStatus?: CognitoUserUserStatus | null,
      Username?: string | null,
    } | null,
  } | null,
};

export type GetCompanyQueryVariables = {
  id: string,
  infoName: string,
};

export type GetCompanyQuery = {
  getCompany?:  {
    __typename: "Company",
    address?: string | null,
    areaNames?: Array< string | null > | null,
    areaPrefs?: Array< string | null > | null,
    areas?: Array< string | null > | null,
    bldConditionCompanies?: Array< string | null > | null,
    bldConditionSelections?: Array< string | null > | null,
    branchAddress?: string | null,
    branchFax?: string | null,
    branchId?: number | null,
    branchName?: string | null,
    branchTel?: string | null,
    branchUrl?: string | null,
    createdAt?: string | null,
    eAreaNames?: Array< string | null > | null,
    eAreas?: Array< string | null > | null,
    email?: string | null,
    estateTypes?: Array< string | null > | null,
    fax?: string | null,
    guaranter?: string | null,
    id: string,
    infoName: string,
    job?: string | null,
    latitude?: number | null,
    license?: string | null,
    licenseCount?: number | null,
    licenseNo?: string | null,
    licenser?: string | null,
    logoImg?: string | null,
    longitude?: number | null,
    name?: string | null,
    organization?: string | null,
    owner?: string | null,
    recNo?: number | null,
    remarks?: string | null,
    remarks2?: string | null,
    searchInfo: string,
    startMark?: string | null,
    tel?: string | null,
    updatedAt?: string | null,
    url?: string | null,
  } | null,
};

export type GetCompanyForAnonymousFQueryVariables = {
  id: string,
};

export type GetCompanyForAnonymousFQuery = {
  getCompanyForAnonymousF?:  {
    __typename: "CompanyForAnonymousResponse",
    organization?: string | null,
  } | null,
};

export type GetDummyQueryVariables = {
  id: string,
};

export type GetDummyQuery = {
  getDummy?:  {
    __typename: "Dummy",
    createdAt: string,
    id: string,
    kintoneAppScope?: KintoneAppScope | null,
    kintoneDataKind?: KintoneDataKind | null,
    updatedAt: string,
  } | null,
};

export type GetEstateQueryVariables = {
  id: string,
  infoName: string,
};

export type GetEstateQuery = {
  getEstate?:  {
    __typename: "Estate",
    address?: string | null,
    appearanceImgs?: Array< string | null > | null,
    area?: string | null,
    balconyArea?: number | null,
    bcr?: number | null,
    bldConditionType?: string | null,
    buildingCompany?: string | null,
    buildingFloors?: string | null,
    cadastralMapPdf?: string | null,
    carsInParkingN?: number | null,
    city?: string | null,
    cityPlanningType?: string | null,
    cleaningMonth?: number | null,
    clearingType?: string | null,
    collectedAt?: string | null,
    companyAddress?: string | null,
    companyBranchId?: number | null,
    companyFax?: string | null,
    companyGuaranter?: string | null,
    companyId?: string | null,
    companyLicense?: string | null,
    companyName?: string | null,
    companyRecNo?: number | null,
    companyTel?: string | null,
    companyUrl?: string | null,
    completionMonth?: number | null,
    completionMonthS?: string | null,
    completionSchMonth?: number | null,
    condominiumId?: string | null,
    condominiumName?: string | null,
    condominiumRecNo?: number | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    currentStatus?: string | null,
    currentStatusB?: string | null,
    currentStatusFree?: string | null,
    currentStatusG?: string | null,
    deletedOnSumora?: number | null,
    drivewayPay?: string | null,
    eSchool?: Array< string | null > | null,
    estatePrice?: number | null,
    estateType?: string | null,
    estateUrl?: string | null,
    exactLocation?: number | null,
    floor?: number | null,
    floorAreaRatio?: number | null,
    floorStructure?: string | null,
    fullAddress?: string | null,
    gas?: string | null,
    gasPdf?: string | null,
    groundPdf?: string | null,
    groundType?: Array< string | null > | null,
    groundTypeFree?: string | null,
    id: string,
    infoName: string,
    isLot?: number | null,
    jSchool?: Array< string | null > | null,
    landAreaType?: string | null,
    landRights?: string | null,
    latitude?: number | null,
    layout?: string | null,
    layoutImgs?: Array< string | null > | null,
    license?: string | null,
    location?: string | null,
    longitude?: number | null,
    managementFee?: number | null,
    managementType?: string | null,
    manager?: string | null,
    mapImg?: string | null,
    media?: string | null,
    mediationKind?: string | null,
    name?: string | null,
    nearlyLocation?: number | null,
    notFoundAt?: string | null,
    otherCost?: number | null,
    owner?: string | null,
    parking?: string | null,
    parkingFee?: number | null,
    parkingHeight?: number | null,
    parkingMechOrPlane?: string | null,
    parkingTakeOver?: string | null,
    parkingTakeOverFree?: string | null,
    pet?: string | null,
    prefecture?: string | null,
    priceHistory?:  Array< {
      __typename: "Price",
      price?: number | null,
      pricedAt?: string | null,
    } | null > | null,
    pricedAt?: string | null,
    purposeB?: string | null,
    purposeSummaryB?: string | null,
    recNo?: number | null,
    remarks?: string | null,
    repairCost?: number | null,
    roadDirection?: string | null,
    roadType?: string | null,
    roadWidth?: number | null,
    room?: string | null,
    searchInfo: string,
    seller?: string | null,
    sewer?: string | null,
    sewerPdf?: string | null,
    sold?: boolean | null,
    squareArea?: number | null,
    status?: string | null,
    store?: string | null,
    structure?: string | null,
    structureFree?: string | null,
    subCompany2Address?: string | null,
    subCompany2Fax?: string | null,
    subCompany2Guaranter?: string | null,
    subCompany2Id?: string | null,
    subCompany2License?: string | null,
    subCompany2Name?: string | null,
    subCompany2Tel?: string | null,
    subCompany2Url?: string | null,
    subCompanyAddress?: string | null,
    subCompanyFax?: string | null,
    subCompanyGuaranter?: string | null,
    subCompanyId?: string | null,
    subCompanyLicense?: string | null,
    subCompanyName?: string | null,
    subCompanyRecNo?: number | null,
    subCompanyTel?: string | null,
    subCompanyUrl?: string | null,
    tileOnZoom12?: string | null,
    tileOnZoom14?: string | null,
    tileOnZoom16?: string | null,
    totalArea?: number | null,
    totalHouses?: number | null,
    traffic?: string | null,
    tsuboArea?: number | null,
    unitPrice?: number | null,
    unsettledLocation?: number | null,
    updatedAt?: string | null,
    url?: string | null,
    useDistrict?: Array< string | null > | null,
    water?: string | null,
    waterPdf?: string | null,
  } | null,
};

export type GetKintoneDataQueryVariables = {
  appScopeAndRecNo: string,
  kind: string,
};

export type GetKintoneDataQuery = {
  getKintoneData?:  {
    __typename: "KintoneData",
    appScope: string,
    appScopeAndRecNo: string,
    createdAt: string,
    estateUrl: string,
    kind: string,
    mansionName: string,
    recNo: string,
    record?: string | null,
    scrapeeBaseUrl: string,
    sortKey: string,
    sortKeyForStatus: string,
    status: string,
    updatedAt: string,
  } | null,
};

export type GetPresignedUrlForAnonymousFQueryVariables = {
  key?: string | null,
};

export type GetPresignedUrlForAnonymousFQuery = {
  getPresignedUrlForAnonymousF?:  {
    __typename: "PresignedUrlResponse",
    errorMessage?: string | null,
    url?: string | null,
  } | null,
};

export type GetPresignedUrlForDeleteFQueryVariables = {
  companyId?: string | null,
  estateId?: string | null,
  key?: string | null,
};

export type GetPresignedUrlForDeleteFQuery = {
  getPresignedUrlForDeleteF?:  {
    __typename: "PresignedUrlResponse",
    errorMessage?: string | null,
    url?: string | null,
  } | null,
};

export type GetPresignedUrlForGetFQueryVariables = {
  companyId?: string | null,
  estateId?: string | null,
  key?: string | null,
};

export type GetPresignedUrlForGetFQuery = {
  getPresignedUrlForGetF?:  {
    __typename: "PresignedUrlResponse",
    errorMessage?: string | null,
    url?: string | null,
  } | null,
};

export type GetPresignedUrlForPutFQueryVariables = {
  companyId?: string | null,
  estateId?: string | null,
  key?: string | null,
};

export type GetPresignedUrlForPutFQuery = {
  getPresignedUrlForPutF?:  {
    __typename: "PresignedUrlResponse",
    errorMessage?: string | null,
    url?: string | null,
  } | null,
};

export type GetPublicEstateQueryVariables = {
  id: string,
};

export type GetPublicEstateQuery = {
  getPublicEstate?:  {
    __typename: "PublicEstate",
    createdAt: string,
    distributer:  {
      __typename: "CompanyType",
      address?: string | null,
      areaNames?: Array< string | null > | null,
      areaPrefs?: Array< string | null > | null,
      areas?: Array< string | null > | null,
      bldConditionCompanies?: Array< string | null > | null,
      bldConditionSelections?: Array< string | null > | null,
      branchAddress?: string | null,
      branchFax?: string | null,
      branchId?: number | null,
      branchName?: string | null,
      branchTel?: string | null,
      branchUrl?: string | null,
      createdAt?: string | null,
      eAreaNames?: Array< string | null > | null,
      eAreas?: Array< string | null > | null,
      email?: string | null,
      estateTypes?: Array< string | null > | null,
      fax?: string | null,
      guaranter?: string | null,
      id: string,
      infoName: string,
      job?: string | null,
      latitude?: number | null,
      license?: string | null,
      licenseCount?: number | null,
      licenseNo?: string | null,
      licenser?: string | null,
      logoImg?: string | null,
      longitude?: number | null,
      name?: string | null,
      organization?: string | null,
      owner?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      remarks2?: string | null,
      searchInfo: string,
      startMark?: string | null,
      tel?: string | null,
      updatedAt?: string | null,
      url?: string | null,
    },
    estate:  {
      __typename: "EstateType",
      address?: string | null,
      appearanceImgs?: Array< string | null > | null,
      area?: string | null,
      balconyArea?: number | null,
      bcr?: number | null,
      bldConditionType?: string | null,
      buildingCompany?: string | null,
      buildingFloors?: string | null,
      cadastralMapPdf?: string | null,
      carsInParkingN?: number | null,
      city?: string | null,
      cityPlanningType?: string | null,
      cleaningMonth?: number | null,
      clearingType?: string | null,
      collectedAt?: string | null,
      companyAddress?: string | null,
      companyBranchId?: number | null,
      companyFax?: string | null,
      companyGuaranter?: string | null,
      companyId?: string | null,
      companyLicense?: string | null,
      companyName?: string | null,
      companyRecNo?: number | null,
      companyTel?: string | null,
      companyUrl?: string | null,
      completionMonth?: number | null,
      completionMonthS?: string | null,
      completionSchMonth?: number | null,
      condominiumId?: string | null,
      condominiumName?: string | null,
      condominiumRecNo?: number | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      currentStatus?: string | null,
      currentStatusB?: string | null,
      currentStatusFree?: string | null,
      currentStatusG?: string | null,
      deletedOnSumora?: number | null,
      drivewayPay?: string | null,
      eSchool?: Array< string | null > | null,
      estatePrice?: number | null,
      estateType?: string | null,
      estateUrl?: string | null,
      exactLocation?: number | null,
      floor?: number | null,
      floorAreaRatio?: number | null,
      floorStructure?: string | null,
      fullAddress?: string | null,
      gas?: string | null,
      gasPdf?: string | null,
      groundPdf?: string | null,
      groundType?: Array< string | null > | null,
      groundTypeFree?: string | null,
      id: string,
      infoName: string,
      isLot?: number | null,
      jSchool?: Array< string | null > | null,
      landAreaType?: string | null,
      landRights?: string | null,
      latitude?: number | null,
      layout?: string | null,
      layoutImgs?: Array< string | null > | null,
      license?: string | null,
      location?: string | null,
      longitude?: number | null,
      managementFee?: number | null,
      managementType?: string | null,
      manager?: string | null,
      mapImg?: string | null,
      media?: string | null,
      mediationKind?: string | null,
      name?: string | null,
      nearlyLocation?: number | null,
      notFoundAt?: string | null,
      otherCost?: number | null,
      owner?: string | null,
      parking?: string | null,
      parkingFee?: number | null,
      parkingHeight?: number | null,
      parkingMechOrPlane?: string | null,
      parkingTakeOver?: string | null,
      parkingTakeOverFree?: string | null,
      pet?: string | null,
      prefecture?: string | null,
      priceHistory?:  Array< {
        __typename: "Price",
        price?: number | null,
        pricedAt?: string | null,
      } | null > | null,
      pricedAt?: string | null,
      purposeB?: string | null,
      purposeSummaryB?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      repairCost?: number | null,
      roadDirection?: string | null,
      roadType?: string | null,
      roadWidth?: number | null,
      room?: string | null,
      searchInfo: string,
      seller?: string | null,
      sewer?: string | null,
      sewerPdf?: string | null,
      sold?: boolean | null,
      squareArea?: number | null,
      status?: string | null,
      store?: string | null,
      structure?: string | null,
      structureFree?: string | null,
      subCompany2Address?: string | null,
      subCompany2Fax?: string | null,
      subCompany2Guaranter?: string | null,
      subCompany2Id?: string | null,
      subCompany2License?: string | null,
      subCompany2Name?: string | null,
      subCompany2Tel?: string | null,
      subCompany2Url?: string | null,
      subCompanyAddress?: string | null,
      subCompanyFax?: string | null,
      subCompanyGuaranter?: string | null,
      subCompanyId?: string | null,
      subCompanyLicense?: string | null,
      subCompanyName?: string | null,
      subCompanyRecNo?: number | null,
      subCompanyTel?: string | null,
      subCompanyUrl?: string | null,
      tileOnZoom12?: string | null,
      tileOnZoom14?: string | null,
      tileOnZoom16?: string | null,
      totalArea?: number | null,
      totalHouses?: number | null,
      traffic?: string | null,
      tsuboArea?: number | null,
      unitPrice?: number | null,
      unsettledLocation?: number | null,
      updatedAt?: string | null,
      url?: string | null,
      useDistrict?: Array< string | null > | null,
      water?: string | null,
      waterPdf?: string | null,
    },
    estateId: string,
    expiredAt: number,
    id: string,
    tel?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type GetReportQueryVariables = {
  id: string,
};

export type GetReportQuery = {
  getReport?:  {
    __typename: "Report",
    companyId: string,
    companyName: string,
    createdAt: string,
    description?: string | null,
    estateId: string,
    estateName?: string | null,
    expiredAt?: number | null,
    id: string,
    latitude?: number | null,
    longitude?: number | null,
    owner: string,
    reportKind: string,
    updatedAt?: string | null,
    userName: string,
  } | null,
};

export type GetStickyNoteQueryVariables = {
  id: string,
  infoName: string,
};

export type GetStickyNoteQuery = {
  getStickyNote?:  {
    __typename: "StickyNote",
    color?: StickyNoteColor | null,
    companyId: string,
    createdAt?: string | null,
    description?: string | null,
    icon?: StickyNoteIcon | null,
    id: string,
    infoName: string,
    latitude: number,
    longitude: number,
    memoKind: string,
    openLevel: string,
    owner: string,
    searchInfo: string,
    tileOnZoom12: string,
    tileOnZoom14: string,
    tileOnZoom16: string,
    updatedAt?: string | null,
    url1?: string | null,
    url2?: string | null,
    url3?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  infoName: string,
  username: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    agreement?: boolean | null,
    authenticatedAt?: string | null,
    companyBranchName?: string | null,
    companyId?: string | null,
    companyName?: string | null,
    createdAt?: string | null,
    defaultCondition?:  {
      __typename: "DefaultCondition",
      alsoCreatedAtFrom?: number | null,
      alsoCreatedAtTo?: number | null,
      alsoPricedAtFrom?: number | null,
      alsoPricedAtTo?: number | null,
      areaPrefs?: Array< string | null > | null,
      areas?: Array< string | null > | null,
      bldConditionSelections?: Array< string | null > | null,
      companyRecNo?: number | null,
      completionYMFrom?: number | null,
      completionYMTo?: number | null,
      estatePriceFrom?: number | null,
      estatePriceTo?: number | null,
      estateTypes?: Array< string | null > | null,
      exceptForRent?: boolean | null,
      flat?: boolean | null,
      forRent?: boolean | null,
      petOk?: boolean | null,
      priceLabel?: boolean | null,
      purposeSummaryBs?: Array< string | null > | null,
      roomsFrom?: number | null,
      roomsTo?: number | null,
      squareAreaOfMansionFrom?: number | null,
      squareAreaOfMansionTo?: number | null,
      structureSummaries?: Array< string | null > | null,
      tsuboAreaFrom?: number | null,
      tsuboAreaTo?: number | null,
      tsuboLabel?: boolean | null,
      venderOnly?: boolean | null,
    } | null,
    email?: string | null,
    group?: string | null,
    infoName: string,
    name?: string | null,
    nameRuby?: string | null,
    owner?: string | null,
    paid?: boolean | null,
    pricingAvailable?: boolean | null,
    role?: string | null,
    searchInfo?: string | null,
    tel?: string | null,
    trial?: boolean | null,
    trialEndAt?: string | null,
    updatedAt?: string | null,
    username: string,
  } | null,
};

export type ListAnnouncesQueryVariables = {
  filter?: ModelAnnounceFilterInputInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAnnouncesQuery = {
  listAnnounces?:  {
    __typename: "ModelAnnounceConnection",
    items?:  Array< {
      __typename: "AnnounceType",
      body: string,
      createdAt: string,
      expiredAt?: number | null,
      id: string,
      level: AnnounceLevel,
      owner: string,
      subject: string,
      to: string,
      updatedAt?: string | null,
      ym: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListAnnouncesByYmQueryVariables = {
  filter?: ModelAnnounceFilterInputInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ListAnnouncesByYmSortDirection | null,
  to?: CustomModelStringKeyConditionInputInput | null,
  ym: string,
};

export type ListAnnouncesByYmQuery = {
  listAnnouncesByYm?:  {
    __typename: "ModelAnnounceConnection",
    items?:  Array< {
      __typename: "AnnounceType",
      body: string,
      createdAt: string,
      expiredAt?: number | null,
      id: string,
      level: AnnounceLevel,
      owner: string,
      subject: string,
      to: string,
      updatedAt?: string | null,
      ym: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListAtomicCountersQueryVariables = {
  counterName?: string | null,
  filter?: ModelAtomicCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAtomicCountersQuery = {
  listAtomicCounters?:  {
    __typename: "ModelAtomicCounterConnection",
    items:  Array< {
      __typename: "AtomicCounter",
      counterName: string,
      createdAt?: string | null,
      kind: string,
      sequence: number,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBatchJobConfsQueryVariables = {
  filter?: ModelBatchJobConfFilterInput | null,
  jobName?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBatchJobConfsQuery = {
  listBatchJobConfs?:  {
    __typename: "ModelBatchJobConfConnection",
    items:  Array< {
      __typename: "BatchJobConf",
      allowedGroups?: Array< string | null > | null,
      createdAt?: string | null,
      jobName: string,
      remarks: string,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBatchJobsQueryVariables = {
  filter?: ModelBatchJobFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBatchJobsQuery = {
  listBatchJobs?:  {
    __typename: "ModelBatchJobConnection",
    items:  Array< {
      __typename: "BatchJob",
      createdAt?: string | null,
      expiredAt?: number | null,
      id: string,
      jobName: string,
      remarks: string,
      status: string,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBatchJobsByJobNameQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelBatchJobFilterInput | null,
  jobName: string,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBatchJobsByJobNameQuery = {
  listBatchJobsByJobName?:  {
    __typename: "ModelBatchJobConnection",
    items:  Array< {
      __typename: "BatchJob",
      createdAt?: string | null,
      expiredAt?: number | null,
      id: string,
      jobName: string,
      remarks: string,
      status: string,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListBuildPricesQueryVariables = {
  filter?: ModelBuildPriceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  year?: number | null,
};

export type ListBuildPricesQuery = {
  listBuildPrices?:  {
    __typename: "ModelBuildPriceConnection",
    items:  Array< {
      __typename: "BuildPrice",
      createdAt?: string | null,
      owner: string,
      unitPriceCB: number,
      unitPriceOther: number,
      unitPriceRC: number,
      unitPriceS: number,
      unitPriceSRC: number,
      unitPriceW: number,
      updatedAt?: string | null,
      year: number,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCognitoUsersFQueryVariables = {
  companyIds?: Array< string | null > | null,
  email?: string | null,
  groups?: Array< string | null > | null,
  name?: string | null,
  nameRuby?: string | null,
  nextToken?: string | null,
  paid?: boolean | null,
  pricingAvailable?: boolean | null,
  trial?: boolean | null,
  username?: string | null,
};

export type ListCognitoUsersFQuery = {
  listCognitoUsersF?:  {
    __typename: "ModelCognitoUserConnection",
    errorMessage?: string | null,
    items?:  Array< {
      __typename: "CognitoUser",
      Attributes?:  Array< {
        __typename: "CognitoUserAttribute",
        Name?: string | null,
        Value?: string | null,
      } | null > | null,
      Company?:  {
        __typename: "CompanyType",
        address?: string | null,
        areaNames?: Array< string | null > | null,
        areaPrefs?: Array< string | null > | null,
        areas?: Array< string | null > | null,
        bldConditionCompanies?: Array< string | null > | null,
        bldConditionSelections?: Array< string | null > | null,
        branchAddress?: string | null,
        branchFax?: string | null,
        branchId?: number | null,
        branchName?: string | null,
        branchTel?: string | null,
        branchUrl?: string | null,
        createdAt?: string | null,
        eAreaNames?: Array< string | null > | null,
        eAreas?: Array< string | null > | null,
        email?: string | null,
        estateTypes?: Array< string | null > | null,
        fax?: string | null,
        guaranter?: string | null,
        id: string,
        infoName: string,
        job?: string | null,
        latitude?: number | null,
        license?: string | null,
        licenseCount?: number | null,
        licenseNo?: string | null,
        licenser?: string | null,
        logoImg?: string | null,
        longitude?: number | null,
        name?: string | null,
        organization?: string | null,
        owner?: string | null,
        recNo?: number | null,
        remarks?: string | null,
        remarks2?: string | null,
        searchInfo: string,
        startMark?: string | null,
        tel?: string | null,
        updatedAt?: string | null,
        url?: string | null,
      } | null,
      Enabled?: boolean | null,
      Groups?:  Array< {
        __typename: "CognitoGroup",
        CreationDate?: string | null,
        Description?: string | null,
        GroupName?: string | null,
        LastModifiedDate?: string | null,
        Precedence?: number | null,
        RoleArn?: string | null,
        UserPoolId?: string | null,
      } | null > | null,
      MFAOptions?:  Array< {
        __typename: "CognitoUserMFAOption",
        AttributeName?: string | null,
        DeliveryMedium?: CognitoUserMFAOptionDeliveryMedium | null,
      } | null > | null,
      User?:  {
        __typename: "UserType",
        agreement?: boolean | null,
        authenticatedAt?: string | null,
        companyBranchName?: string | null,
        companyId?: string | null,
        companyName?: string | null,
        createdAt?: string | null,
        defaultCondition?:  {
          __typename: "DefaultCondition",
          alsoCreatedAtFrom?: number | null,
          alsoCreatedAtTo?: number | null,
          alsoPricedAtFrom?: number | null,
          alsoPricedAtTo?: number | null,
          areaPrefs?: Array< string | null > | null,
          areas?: Array< string | null > | null,
          bldConditionSelections?: Array< string | null > | null,
          companyRecNo?: number | null,
          completionYMFrom?: number | null,
          completionYMTo?: number | null,
          estatePriceFrom?: number | null,
          estatePriceTo?: number | null,
          estateTypes?: Array< string | null > | null,
          exceptForRent?: boolean | null,
          flat?: boolean | null,
          forRent?: boolean | null,
          petOk?: boolean | null,
          priceLabel?: boolean | null,
          purposeSummaryBs?: Array< string | null > | null,
          roomsFrom?: number | null,
          roomsTo?: number | null,
          squareAreaOfMansionFrom?: number | null,
          squareAreaOfMansionTo?: number | null,
          structureSummaries?: Array< string | null > | null,
          tsuboAreaFrom?: number | null,
          tsuboAreaTo?: number | null,
          tsuboLabel?: boolean | null,
          venderOnly?: boolean | null,
        } | null,
        email?: string | null,
        group?: string | null,
        infoName: string,
        name?: string | null,
        nameRuby?: string | null,
        owner?: string | null,
        paid?: boolean | null,
        pricingAvailable?: boolean | null,
        role?: string | null,
        searchInfo?: string | null,
        tel?: string | null,
        trial?: boolean | null,
        trialEndAt?: string | null,
        updatedAt?: string | null,
        username: string,
      } | null,
      UserCreateDate?: string | null,
      UserLastModifiedDate?: string | null,
      UserStatus?: CognitoUserUserStatus | null,
      Username?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListCompaniesQueryVariables = {
  filter?: ModelCompanyFilterInputInput | null,
  id?: string | null,
  infoName?: ModelStringKeyConditionInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCompaniesQuery = {
  listCompanies?:  {
    __typename: "ModelCompanyConnection",
    items?:  Array< {
      __typename: "CompanyType",
      address?: string | null,
      areaNames?: Array< string | null > | null,
      areaPrefs?: Array< string | null > | null,
      areas?: Array< string | null > | null,
      bldConditionCompanies?: Array< string | null > | null,
      bldConditionSelections?: Array< string | null > | null,
      branchAddress?: string | null,
      branchFax?: string | null,
      branchId?: number | null,
      branchName?: string | null,
      branchTel?: string | null,
      branchUrl?: string | null,
      createdAt?: string | null,
      eAreaNames?: Array< string | null > | null,
      eAreas?: Array< string | null > | null,
      email?: string | null,
      estateTypes?: Array< string | null > | null,
      fax?: string | null,
      guaranter?: string | null,
      id: string,
      infoName: string,
      job?: string | null,
      latitude?: number | null,
      license?: string | null,
      licenseCount?: number | null,
      licenseNo?: string | null,
      licenser?: string | null,
      logoImg?: string | null,
      longitude?: number | null,
      name?: string | null,
      organization?: string | null,
      owner?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      remarks2?: string | null,
      searchInfo: string,
      startMark?: string | null,
      tel?: string | null,
      updatedAt?: string | null,
      url?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListCompaniesBySearchInfoQueryVariables = {
  filter?: ModelCompanyFilterInputInput | null,
  infoName: string,
  limit?: number | null,
  nextToken?: string | null,
  searchInfo?: CustomModelStringKeyConditionInputInput | null,
  sortDirection?: ListCompaniesBySearchInfoSortDirection | null,
};

export type ListCompaniesBySearchInfoQuery = {
  listCompaniesBySearchInfo?:  {
    __typename: "ModelCompanyConnection",
    items?:  Array< {
      __typename: "CompanyType",
      address?: string | null,
      areaNames?: Array< string | null > | null,
      areaPrefs?: Array< string | null > | null,
      areas?: Array< string | null > | null,
      bldConditionCompanies?: Array< string | null > | null,
      bldConditionSelections?: Array< string | null > | null,
      branchAddress?: string | null,
      branchFax?: string | null,
      branchId?: number | null,
      branchName?: string | null,
      branchTel?: string | null,
      branchUrl?: string | null,
      createdAt?: string | null,
      eAreaNames?: Array< string | null > | null,
      eAreas?: Array< string | null > | null,
      email?: string | null,
      estateTypes?: Array< string | null > | null,
      fax?: string | null,
      guaranter?: string | null,
      id: string,
      infoName: string,
      job?: string | null,
      latitude?: number | null,
      license?: string | null,
      licenseCount?: number | null,
      licenseNo?: string | null,
      licenser?: string | null,
      logoImg?: string | null,
      longitude?: number | null,
      name?: string | null,
      organization?: string | null,
      owner?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      remarks2?: string | null,
      searchInfo: string,
      startMark?: string | null,
      tel?: string | null,
      updatedAt?: string | null,
      url?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListDummiesQueryVariables = {
  filter?: ModelDummyFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDummiesQuery = {
  listDummies?:  {
    __typename: "ModelDummyConnection",
    items:  Array< {
      __typename: "Dummy",
      createdAt: string,
      id: string,
      kintoneAppScope?: KintoneAppScope | null,
      kintoneDataKind?: KintoneDataKind | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEstatesQueryVariables = {
  filter?: ModelEstateFilterInputInput | null,
  id?: string | null,
  infoName?: ModelStringKeyConditionInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEstatesQuery = {
  listEstates?:  {
    __typename: "ModelEstateConnection",
    items?:  Array< {
      __typename: "EstateType",
      address?: string | null,
      appearanceImgs?: Array< string | null > | null,
      area?: string | null,
      balconyArea?: number | null,
      bcr?: number | null,
      bldConditionType?: string | null,
      buildingCompany?: string | null,
      buildingFloors?: string | null,
      cadastralMapPdf?: string | null,
      carsInParkingN?: number | null,
      city?: string | null,
      cityPlanningType?: string | null,
      cleaningMonth?: number | null,
      clearingType?: string | null,
      collectedAt?: string | null,
      companyAddress?: string | null,
      companyBranchId?: number | null,
      companyFax?: string | null,
      companyGuaranter?: string | null,
      companyId?: string | null,
      companyLicense?: string | null,
      companyName?: string | null,
      companyRecNo?: number | null,
      companyTel?: string | null,
      companyUrl?: string | null,
      completionMonth?: number | null,
      completionMonthS?: string | null,
      completionSchMonth?: number | null,
      condominiumId?: string | null,
      condominiumName?: string | null,
      condominiumRecNo?: number | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      currentStatus?: string | null,
      currentStatusB?: string | null,
      currentStatusFree?: string | null,
      currentStatusG?: string | null,
      deletedOnSumora?: number | null,
      drivewayPay?: string | null,
      eSchool?: Array< string | null > | null,
      estatePrice?: number | null,
      estateType?: string | null,
      estateUrl?: string | null,
      exactLocation?: number | null,
      floor?: number | null,
      floorAreaRatio?: number | null,
      floorStructure?: string | null,
      fullAddress?: string | null,
      gas?: string | null,
      gasPdf?: string | null,
      groundPdf?: string | null,
      groundType?: Array< string | null > | null,
      groundTypeFree?: string | null,
      id: string,
      infoName: string,
      isLot?: number | null,
      jSchool?: Array< string | null > | null,
      landAreaType?: string | null,
      landRights?: string | null,
      latitude?: number | null,
      layout?: string | null,
      layoutImgs?: Array< string | null > | null,
      license?: string | null,
      location?: string | null,
      longitude?: number | null,
      managementFee?: number | null,
      managementType?: string | null,
      manager?: string | null,
      mapImg?: string | null,
      media?: string | null,
      mediationKind?: string | null,
      name?: string | null,
      nearlyLocation?: number | null,
      notFoundAt?: string | null,
      otherCost?: number | null,
      owner?: string | null,
      parking?: string | null,
      parkingFee?: number | null,
      parkingHeight?: number | null,
      parkingMechOrPlane?: string | null,
      parkingTakeOver?: string | null,
      parkingTakeOverFree?: string | null,
      pet?: string | null,
      prefecture?: string | null,
      priceHistory?:  Array< {
        __typename: "Price",
        price?: number | null,
        pricedAt?: string | null,
      } | null > | null,
      pricedAt?: string | null,
      purposeB?: string | null,
      purposeSummaryB?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      repairCost?: number | null,
      roadDirection?: string | null,
      roadType?: string | null,
      roadWidth?: number | null,
      room?: string | null,
      searchInfo: string,
      seller?: string | null,
      sewer?: string | null,
      sewerPdf?: string | null,
      sold?: boolean | null,
      squareArea?: number | null,
      status?: string | null,
      store?: string | null,
      structure?: string | null,
      structureFree?: string | null,
      subCompany2Address?: string | null,
      subCompany2Fax?: string | null,
      subCompany2Guaranter?: string | null,
      subCompany2Id?: string | null,
      subCompany2License?: string | null,
      subCompany2Name?: string | null,
      subCompany2Tel?: string | null,
      subCompany2Url?: string | null,
      subCompanyAddress?: string | null,
      subCompanyFax?: string | null,
      subCompanyGuaranter?: string | null,
      subCompanyId?: string | null,
      subCompanyLicense?: string | null,
      subCompanyName?: string | null,
      subCompanyRecNo?: number | null,
      subCompanyTel?: string | null,
      subCompanyUrl?: string | null,
      tileOnZoom12?: string | null,
      tileOnZoom14?: string | null,
      tileOnZoom16?: string | null,
      totalArea?: number | null,
      totalHouses?: number | null,
      traffic?: string | null,
      tsuboArea?: number | null,
      unitPrice?: number | null,
      unsettledLocation?: number | null,
      updatedAt?: string | null,
      url?: string | null,
      useDistrict?: Array< string | null > | null,
      water?: string | null,
      waterPdf?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListEstatesBySearchInfoQueryVariables = {
  filter?: ModelEstateFilterInputInput | null,
  infoName: string,
  limit?: number | null,
  nextToken?: string | null,
  searchInfo?: CustomModelStringKeyConditionInputInput | null,
  sortDirection?: ListEstatesBySearchInfoSortDirection | null,
};

export type ListEstatesBySearchInfoQuery = {
  listEstatesBySearchInfo?:  {
    __typename: "ModelEstateConnection",
    items?:  Array< {
      __typename: "EstateType",
      address?: string | null,
      appearanceImgs?: Array< string | null > | null,
      area?: string | null,
      balconyArea?: number | null,
      bcr?: number | null,
      bldConditionType?: string | null,
      buildingCompany?: string | null,
      buildingFloors?: string | null,
      cadastralMapPdf?: string | null,
      carsInParkingN?: number | null,
      city?: string | null,
      cityPlanningType?: string | null,
      cleaningMonth?: number | null,
      clearingType?: string | null,
      collectedAt?: string | null,
      companyAddress?: string | null,
      companyBranchId?: number | null,
      companyFax?: string | null,
      companyGuaranter?: string | null,
      companyId?: string | null,
      companyLicense?: string | null,
      companyName?: string | null,
      companyRecNo?: number | null,
      companyTel?: string | null,
      companyUrl?: string | null,
      completionMonth?: number | null,
      completionMonthS?: string | null,
      completionSchMonth?: number | null,
      condominiumId?: string | null,
      condominiumName?: string | null,
      condominiumRecNo?: number | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      currentStatus?: string | null,
      currentStatusB?: string | null,
      currentStatusFree?: string | null,
      currentStatusG?: string | null,
      deletedOnSumora?: number | null,
      drivewayPay?: string | null,
      eSchool?: Array< string | null > | null,
      estatePrice?: number | null,
      estateType?: string | null,
      estateUrl?: string | null,
      exactLocation?: number | null,
      floor?: number | null,
      floorAreaRatio?: number | null,
      floorStructure?: string | null,
      fullAddress?: string | null,
      gas?: string | null,
      gasPdf?: string | null,
      groundPdf?: string | null,
      groundType?: Array< string | null > | null,
      groundTypeFree?: string | null,
      id: string,
      infoName: string,
      isLot?: number | null,
      jSchool?: Array< string | null > | null,
      landAreaType?: string | null,
      landRights?: string | null,
      latitude?: number | null,
      layout?: string | null,
      layoutImgs?: Array< string | null > | null,
      license?: string | null,
      location?: string | null,
      longitude?: number | null,
      managementFee?: number | null,
      managementType?: string | null,
      manager?: string | null,
      mapImg?: string | null,
      media?: string | null,
      mediationKind?: string | null,
      name?: string | null,
      nearlyLocation?: number | null,
      notFoundAt?: string | null,
      otherCost?: number | null,
      owner?: string | null,
      parking?: string | null,
      parkingFee?: number | null,
      parkingHeight?: number | null,
      parkingMechOrPlane?: string | null,
      parkingTakeOver?: string | null,
      parkingTakeOverFree?: string | null,
      pet?: string | null,
      prefecture?: string | null,
      priceHistory?:  Array< {
        __typename: "Price",
        price?: number | null,
        pricedAt?: string | null,
      } | null > | null,
      pricedAt?: string | null,
      purposeB?: string | null,
      purposeSummaryB?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      repairCost?: number | null,
      roadDirection?: string | null,
      roadType?: string | null,
      roadWidth?: number | null,
      room?: string | null,
      searchInfo: string,
      seller?: string | null,
      sewer?: string | null,
      sewerPdf?: string | null,
      sold?: boolean | null,
      squareArea?: number | null,
      status?: string | null,
      store?: string | null,
      structure?: string | null,
      structureFree?: string | null,
      subCompany2Address?: string | null,
      subCompany2Fax?: string | null,
      subCompany2Guaranter?: string | null,
      subCompany2Id?: string | null,
      subCompany2License?: string | null,
      subCompany2Name?: string | null,
      subCompany2Tel?: string | null,
      subCompany2Url?: string | null,
      subCompanyAddress?: string | null,
      subCompanyFax?: string | null,
      subCompanyGuaranter?: string | null,
      subCompanyId?: string | null,
      subCompanyLicense?: string | null,
      subCompanyName?: string | null,
      subCompanyRecNo?: number | null,
      subCompanyTel?: string | null,
      subCompanyUrl?: string | null,
      tileOnZoom12?: string | null,
      tileOnZoom14?: string | null,
      tileOnZoom16?: string | null,
      totalArea?: number | null,
      totalHouses?: number | null,
      traffic?: string | null,
      tsuboArea?: number | null,
      unitPrice?: number | null,
      unsettledLocation?: number | null,
      updatedAt?: string | null,
      url?: string | null,
      useDistrict?: Array< string | null > | null,
      water?: string | null,
      waterPdf?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListEstatesForPricingFQueryVariables = {
  estateTypes: Array< string | null >,
  points: Array< PointForPricingInputInput | null >,
  tileOnZoom16s: Array< string | null >,
};

export type ListEstatesForPricingFQuery = {
  listEstatesForPricingF?:  {
    __typename: "ModelEstateConnectionForPricing",
    items:  Array< {
      __typename: "EstateResponseForPricing",
      address?: string | null,
      appearanceImgs?: Array< string | null > | null,
      area?: string | null,
      balconyArea?: number | null,
      bcr?: number | null,
      bldConditionType?: string | null,
      buildingCompany?: string | null,
      buildingFloors?: string | null,
      cadastralMapPdf?: string | null,
      carsInParkingN?: number | null,
      city?: string | null,
      cityPlanningType?: string | null,
      cleaningMonth?: number | null,
      clearingType?: string | null,
      collectedAt?: string | null,
      companyAddress?: string | null,
      companyBranchId?: number | null,
      companyFax?: string | null,
      companyGuaranter?: string | null,
      companyId?: string | null,
      companyLicense?: string | null,
      companyName?: string | null,
      companyRecNo?: number | null,
      companyTel?: string | null,
      companyUrl?: string | null,
      completionMonth?: number | null,
      completionMonthS?: string | null,
      completionSchMonth?: number | null,
      condominiumId?: string | null,
      condominiumName?: string | null,
      condominiumRecNo?: number | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      currentStatus?: string | null,
      currentStatusB?: string | null,
      currentStatusFree?: string | null,
      currentStatusG?: string | null,
      deletedOnSumora?: number | null,
      drivewayPay?: string | null,
      eSchool?: Array< string | null > | null,
      estatePrice?: number | null,
      estateType?: string | null,
      estateUrl?: string | null,
      exactLocation?: number | null,
      floor?: number | null,
      floorAreaRatio?: number | null,
      floorStructure?: string | null,
      fullAddress?: string | null,
      gas?: string | null,
      gasPdf?: string | null,
      groundPdf?: string | null,
      groundType?: Array< string | null > | null,
      groundTypeFree?: string | null,
      id: string,
      infoName: string,
      isLot?: number | null,
      jSchool?: Array< string | null > | null,
      landAreaType?: string | null,
      landRights?: string | null,
      latitude?: number | null,
      layout?: string | null,
      layoutImgs?: Array< string | null > | null,
      license?: string | null,
      location?: string | null,
      longitude?: number | null,
      managementFee?: number | null,
      managementType?: string | null,
      manager?: string | null,
      mapImg?: string | null,
      media?: string | null,
      mediationKind?: string | null,
      name?: string | null,
      nearlyLocation?: number | null,
      notFoundAt?: string | null,
      otherCost?: number | null,
      owner?: string | null,
      parking?: string | null,
      parkingFee?: number | null,
      parkingHeight?: number | null,
      parkingMechOrPlane?: string | null,
      parkingTakeOver?: string | null,
      parkingTakeOverFree?: string | null,
      pet?: string | null,
      prefecture?: string | null,
      priceHistory?:  Array< {
        __typename: "Price",
        price?: number | null,
        pricedAt?: string | null,
      } | null > | null,
      pricedAt?: string | null,
      purposeB?: string | null,
      purposeSummaryB?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      repairCost?: number | null,
      roadDirection?: string | null,
      roadType?: string | null,
      roadWidth?: number | null,
      room?: string | null,
      searchInfo: string,
      seller?: string | null,
      sewer?: string | null,
      sewerPdf?: string | null,
      sold?: boolean | null,
      squareArea?: number | null,
      status?: string | null,
      store?: string | null,
      structure?: string | null,
      structureFree?: string | null,
      subCompany2Address?: string | null,
      subCompany2Fax?: string | null,
      subCompany2Guaranter?: string | null,
      subCompany2Id?: string | null,
      subCompany2License?: string | null,
      subCompany2Name?: string | null,
      subCompany2Tel?: string | null,
      subCompany2Url?: string | null,
      subCompanyAddress?: string | null,
      subCompanyFax?: string | null,
      subCompanyGuaranter?: string | null,
      subCompanyId?: string | null,
      subCompanyLicense?: string | null,
      subCompanyName?: string | null,
      subCompanyRecNo?: number | null,
      subCompanyTel?: string | null,
      subCompanyUrl?: string | null,
      tileOnZoom12?: string | null,
      tileOnZoom14?: string | null,
      tileOnZoom16?: string | null,
      totalArea?: number | null,
      totalHouses?: number | null,
      traffic?: string | null,
      tsuboArea?: number | null,
      unitPrice?: number | null,
      unsettledLocation?: number | null,
      updatedAt?: string | null,
      url?: string | null,
      useDistrict?: Array< string | null > | null,
      water?: string | null,
      waterPdf?: string | null,
    } | null >,
  } | null,
};

export type ListReportsQueryVariables = {
  filter?: ModelReportFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListReportsQuery = {
  listReports?:  {
    __typename: "ModelReportConnection",
    items:  Array< {
      __typename: "Report",
      companyId: string,
      companyName: string,
      createdAt: string,
      description?: string | null,
      estateId: string,
      estateName?: string | null,
      expiredAt?: number | null,
      id: string,
      latitude?: number | null,
      longitude?: number | null,
      owner: string,
      reportKind: string,
      updatedAt?: string | null,
      userName: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListScrapingsQueryVariables = {
  baseUrl?: string | null,
  filter?: ModelScrapingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  sortKey?: ModelStringKeyConditionInput | null,
};

export type ListScrapingsQuery = {
  listScrapings?:  {
    __typename: "ModelScrapingConnection",
    items:  Array< {
      __typename: "Scraping",
      baseUrl: string,
      createdAt?: string | null,
      endedAt?: string | null,
      input?: string | null,
      operation?: string | null,
      output?: string | null,
      prefName: string,
      remarks?: string | null,
      resultKey?: string | null,
      sortKey: string,
      startedAt?: string | null,
      status: string,
      totalCount?: number | null,
      updated?:  {
        __typename: "ScrapingUpdateDetail",
        blocked?: number | null,
        expired?: number | null,
        newRecord?: number | null,
        onSite?: number | null,
        requiresAuth?: number | null,
        return?: number | null,
        returnAndUpdatePrice?: number | null,
        scrapingFailed?: number | null,
        updateFailed?: number | null,
        updatePrice?: number | null,
      } | null,
      updatedAt?: string | null,
      updating?:  {
        __typename: "ScrapingUpdateDetail",
        blocked?: number | null,
        expired?: number | null,
        newRecord?: number | null,
        onSite?: number | null,
        requiresAuth?: number | null,
        return?: number | null,
        returnAndUpdatePrice?: number | null,
        scrapingFailed?: number | null,
        updateFailed?: number | null,
        updatePrice?: number | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListStickyNotesQueryVariables = {
  filter?: ModelStickyNoteFilterInputInput | null,
  id?: string | null,
  infoName?: ModelStringKeyConditionInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListStickyNotesQuery = {
  listStickyNotes?:  {
    __typename: "ModelStickyNoteConnection",
    items?:  Array< {
      __typename: "StickyNoteType",
      color?: StickyNoteColor | null,
      companyId: string,
      createdAt?: string | null,
      description?: string | null,
      icon?: StickyNoteIcon | null,
      id: string,
      infoName: string,
      latitude: number,
      longitude: number,
      memoKind: string,
      openLevel: string,
      owner: string,
      searchInfo: string,
      tileOnZoom12: string,
      tileOnZoom14: string,
      tileOnZoom16: string,
      updatedAt?: string | null,
      url1?: string | null,
      url2?: string | null,
      url3?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListStickyNotesBySearchInfoQueryVariables = {
  filter?: ModelStickyNoteFilterInputInput | null,
  infoName: string,
  limit?: number | null,
  nextToken?: string | null,
  searchInfo?: CustomModelStringKeyConditionInputInput | null,
  sortDirection?: ListStickyNotesBySearchInfoSortDirection | null,
};

export type ListStickyNotesBySearchInfoQuery = {
  listStickyNotesBySearchInfo?:  {
    __typename: "ModelStickyNoteConnection",
    items?:  Array< {
      __typename: "StickyNoteType",
      color?: StickyNoteColor | null,
      companyId: string,
      createdAt?: string | null,
      description?: string | null,
      icon?: StickyNoteIcon | null,
      id: string,
      infoName: string,
      latitude: number,
      longitude: number,
      memoKind: string,
      openLevel: string,
      owner: string,
      searchInfo: string,
      tileOnZoom12: string,
      tileOnZoom14: string,
      tileOnZoom16: string,
      updatedAt?: string | null,
      url1?: string | null,
      url2?: string | null,
      url3?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInputInput | null,
  infoName?: ModelStringKeyConditionInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  username?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items?:  Array< {
      __typename: "UserType",
      agreement?: boolean | null,
      authenticatedAt?: string | null,
      companyBranchName?: string | null,
      companyId?: string | null,
      companyName?: string | null,
      createdAt?: string | null,
      defaultCondition?:  {
        __typename: "DefaultCondition",
        alsoCreatedAtFrom?: number | null,
        alsoCreatedAtTo?: number | null,
        alsoPricedAtFrom?: number | null,
        alsoPricedAtTo?: number | null,
        areaPrefs?: Array< string | null > | null,
        areas?: Array< string | null > | null,
        bldConditionSelections?: Array< string | null > | null,
        companyRecNo?: number | null,
        completionYMFrom?: number | null,
        completionYMTo?: number | null,
        estatePriceFrom?: number | null,
        estatePriceTo?: number | null,
        estateTypes?: Array< string | null > | null,
        exceptForRent?: boolean | null,
        flat?: boolean | null,
        forRent?: boolean | null,
        petOk?: boolean | null,
        priceLabel?: boolean | null,
        purposeSummaryBs?: Array< string | null > | null,
        roomsFrom?: number | null,
        roomsTo?: number | null,
        squareAreaOfMansionFrom?: number | null,
        squareAreaOfMansionTo?: number | null,
        structureSummaries?: Array< string | null > | null,
        tsuboAreaFrom?: number | null,
        tsuboAreaTo?: number | null,
        tsuboLabel?: boolean | null,
        venderOnly?: boolean | null,
      } | null,
      email?: string | null,
      group?: string | null,
      infoName: string,
      name?: string | null,
      nameRuby?: string | null,
      owner?: string | null,
      paid?: boolean | null,
      pricingAvailable?: boolean | null,
      role?: string | null,
      searchInfo?: string | null,
      tel?: string | null,
      trial?: boolean | null,
      trialEndAt?: string | null,
      updatedAt?: string | null,
      username: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListUsersBySearchInfoQueryVariables = {
  filter?: ModelUserFilterInputInput | null,
  infoName: string,
  limit?: number | null,
  nextToken?: string | null,
  searchInfo?: CustomModelStringKeyConditionInputInput | null,
  sortDirection?: ListUsersBySearchInfoSortDirection | null,
};

export type ListUsersBySearchInfoQuery = {
  listUsersBySearchInfo?:  {
    __typename: "ModelUserConnection",
    items?:  Array< {
      __typename: "UserType",
      agreement?: boolean | null,
      authenticatedAt?: string | null,
      companyBranchName?: string | null,
      companyId?: string | null,
      companyName?: string | null,
      createdAt?: string | null,
      defaultCondition?:  {
        __typename: "DefaultCondition",
        alsoCreatedAtFrom?: number | null,
        alsoCreatedAtTo?: number | null,
        alsoPricedAtFrom?: number | null,
        alsoPricedAtTo?: number | null,
        areaPrefs?: Array< string | null > | null,
        areas?: Array< string | null > | null,
        bldConditionSelections?: Array< string | null > | null,
        companyRecNo?: number | null,
        completionYMFrom?: number | null,
        completionYMTo?: number | null,
        estatePriceFrom?: number | null,
        estatePriceTo?: number | null,
        estateTypes?: Array< string | null > | null,
        exceptForRent?: boolean | null,
        flat?: boolean | null,
        forRent?: boolean | null,
        petOk?: boolean | null,
        priceLabel?: boolean | null,
        purposeSummaryBs?: Array< string | null > | null,
        roomsFrom?: number | null,
        roomsTo?: number | null,
        squareAreaOfMansionFrom?: number | null,
        squareAreaOfMansionTo?: number | null,
        structureSummaries?: Array< string | null > | null,
        tsuboAreaFrom?: number | null,
        tsuboAreaTo?: number | null,
        tsuboLabel?: boolean | null,
        venderOnly?: boolean | null,
      } | null,
      email?: string | null,
      group?: string | null,
      infoName: string,
      name?: string | null,
      nameRuby?: string | null,
      owner?: string | null,
      paid?: boolean | null,
      pricingAvailable?: boolean | null,
      role?: string | null,
      searchInfo?: string | null,
      tel?: string | null,
      trial?: boolean | null,
      trialEndAt?: string | null,
      updatedAt?: string | null,
      username: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type AgreeCognitoUserFMutationVariables = {
  agreement?: boolean | null,
  username: string,
};

export type AgreeCognitoUserFMutation = {
  agreeCognitoUserF?:  {
    __typename: "CognitoUserResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "CognitoUser",
      Attributes?:  Array< {
        __typename: "CognitoUserAttribute",
        Name?: string | null,
        Value?: string | null,
      } | null > | null,
      Company?:  {
        __typename: "CompanyType",
        address?: string | null,
        areaNames?: Array< string | null > | null,
        areaPrefs?: Array< string | null > | null,
        areas?: Array< string | null > | null,
        bldConditionCompanies?: Array< string | null > | null,
        bldConditionSelections?: Array< string | null > | null,
        branchAddress?: string | null,
        branchFax?: string | null,
        branchId?: number | null,
        branchName?: string | null,
        branchTel?: string | null,
        branchUrl?: string | null,
        createdAt?: string | null,
        eAreaNames?: Array< string | null > | null,
        eAreas?: Array< string | null > | null,
        email?: string | null,
        estateTypes?: Array< string | null > | null,
        fax?: string | null,
        guaranter?: string | null,
        id: string,
        infoName: string,
        job?: string | null,
        latitude?: number | null,
        license?: string | null,
        licenseCount?: number | null,
        licenseNo?: string | null,
        licenser?: string | null,
        logoImg?: string | null,
        longitude?: number | null,
        name?: string | null,
        organization?: string | null,
        owner?: string | null,
        recNo?: number | null,
        remarks?: string | null,
        remarks2?: string | null,
        searchInfo: string,
        startMark?: string | null,
        tel?: string | null,
        updatedAt?: string | null,
        url?: string | null,
      } | null,
      Enabled?: boolean | null,
      Groups?:  Array< {
        __typename: "CognitoGroup",
        CreationDate?: string | null,
        Description?: string | null,
        GroupName?: string | null,
        LastModifiedDate?: string | null,
        Precedence?: number | null,
        RoleArn?: string | null,
        UserPoolId?: string | null,
      } | null > | null,
      MFAOptions?:  Array< {
        __typename: "CognitoUserMFAOption",
        AttributeName?: string | null,
        DeliveryMedium?: CognitoUserMFAOptionDeliveryMedium | null,
      } | null > | null,
      User?:  {
        __typename: "UserType",
        agreement?: boolean | null,
        authenticatedAt?: string | null,
        companyBranchName?: string | null,
        companyId?: string | null,
        companyName?: string | null,
        createdAt?: string | null,
        defaultCondition?:  {
          __typename: "DefaultCondition",
          alsoCreatedAtFrom?: number | null,
          alsoCreatedAtTo?: number | null,
          alsoPricedAtFrom?: number | null,
          alsoPricedAtTo?: number | null,
          areaPrefs?: Array< string | null > | null,
          areas?: Array< string | null > | null,
          bldConditionSelections?: Array< string | null > | null,
          companyRecNo?: number | null,
          completionYMFrom?: number | null,
          completionYMTo?: number | null,
          estatePriceFrom?: number | null,
          estatePriceTo?: number | null,
          estateTypes?: Array< string | null > | null,
          exceptForRent?: boolean | null,
          flat?: boolean | null,
          forRent?: boolean | null,
          petOk?: boolean | null,
          priceLabel?: boolean | null,
          purposeSummaryBs?: Array< string | null > | null,
          roomsFrom?: number | null,
          roomsTo?: number | null,
          squareAreaOfMansionFrom?: number | null,
          squareAreaOfMansionTo?: number | null,
          structureSummaries?: Array< string | null > | null,
          tsuboAreaFrom?: number | null,
          tsuboAreaTo?: number | null,
          tsuboLabel?: boolean | null,
          venderOnly?: boolean | null,
        } | null,
        email?: string | null,
        group?: string | null,
        infoName: string,
        name?: string | null,
        nameRuby?: string | null,
        owner?: string | null,
        paid?: boolean | null,
        pricingAvailable?: boolean | null,
        role?: string | null,
        searchInfo?: string | null,
        tel?: string | null,
        trial?: boolean | null,
        trialEndAt?: string | null,
        updatedAt?: string | null,
        username: string,
      } | null,
      UserCreateDate?: string | null,
      UserLastModifiedDate?: string | null,
      UserStatus?: CognitoUserUserStatus | null,
      Username?: string | null,
    } | null,
  } | null,
};

export type ClearAreaOfDefaultConditionOfUserFMutationVariables = {
  username: string,
};

export type ClearAreaOfDefaultConditionOfUserFMutation = {
  clearAreaOfDefaultConditionOfUserF?:  {
    __typename: "CognitoUserResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "CognitoUser",
      Attributes?:  Array< {
        __typename: "CognitoUserAttribute",
        Name?: string | null,
        Value?: string | null,
      } | null > | null,
      Company?:  {
        __typename: "CompanyType",
        address?: string | null,
        areaNames?: Array< string | null > | null,
        areaPrefs?: Array< string | null > | null,
        areas?: Array< string | null > | null,
        bldConditionCompanies?: Array< string | null > | null,
        bldConditionSelections?: Array< string | null > | null,
        branchAddress?: string | null,
        branchFax?: string | null,
        branchId?: number | null,
        branchName?: string | null,
        branchTel?: string | null,
        branchUrl?: string | null,
        createdAt?: string | null,
        eAreaNames?: Array< string | null > | null,
        eAreas?: Array< string | null > | null,
        email?: string | null,
        estateTypes?: Array< string | null > | null,
        fax?: string | null,
        guaranter?: string | null,
        id: string,
        infoName: string,
        job?: string | null,
        latitude?: number | null,
        license?: string | null,
        licenseCount?: number | null,
        licenseNo?: string | null,
        licenser?: string | null,
        logoImg?: string | null,
        longitude?: number | null,
        name?: string | null,
        organization?: string | null,
        owner?: string | null,
        recNo?: number | null,
        remarks?: string | null,
        remarks2?: string | null,
        searchInfo: string,
        startMark?: string | null,
        tel?: string | null,
        updatedAt?: string | null,
        url?: string | null,
      } | null,
      Enabled?: boolean | null,
      Groups?:  Array< {
        __typename: "CognitoGroup",
        CreationDate?: string | null,
        Description?: string | null,
        GroupName?: string | null,
        LastModifiedDate?: string | null,
        Precedence?: number | null,
        RoleArn?: string | null,
        UserPoolId?: string | null,
      } | null > | null,
      MFAOptions?:  Array< {
        __typename: "CognitoUserMFAOption",
        AttributeName?: string | null,
        DeliveryMedium?: CognitoUserMFAOptionDeliveryMedium | null,
      } | null > | null,
      User?:  {
        __typename: "UserType",
        agreement?: boolean | null,
        authenticatedAt?: string | null,
        companyBranchName?: string | null,
        companyId?: string | null,
        companyName?: string | null,
        createdAt?: string | null,
        defaultCondition?:  {
          __typename: "DefaultCondition",
          alsoCreatedAtFrom?: number | null,
          alsoCreatedAtTo?: number | null,
          alsoPricedAtFrom?: number | null,
          alsoPricedAtTo?: number | null,
          areaPrefs?: Array< string | null > | null,
          areas?: Array< string | null > | null,
          bldConditionSelections?: Array< string | null > | null,
          companyRecNo?: number | null,
          completionYMFrom?: number | null,
          completionYMTo?: number | null,
          estatePriceFrom?: number | null,
          estatePriceTo?: number | null,
          estateTypes?: Array< string | null > | null,
          exceptForRent?: boolean | null,
          flat?: boolean | null,
          forRent?: boolean | null,
          petOk?: boolean | null,
          priceLabel?: boolean | null,
          purposeSummaryBs?: Array< string | null > | null,
          roomsFrom?: number | null,
          roomsTo?: number | null,
          squareAreaOfMansionFrom?: number | null,
          squareAreaOfMansionTo?: number | null,
          structureSummaries?: Array< string | null > | null,
          tsuboAreaFrom?: number | null,
          tsuboAreaTo?: number | null,
          tsuboLabel?: boolean | null,
          venderOnly?: boolean | null,
        } | null,
        email?: string | null,
        group?: string | null,
        infoName: string,
        name?: string | null,
        nameRuby?: string | null,
        owner?: string | null,
        paid?: boolean | null,
        pricingAvailable?: boolean | null,
        role?: string | null,
        searchInfo?: string | null,
        tel?: string | null,
        trial?: boolean | null,
        trialEndAt?: string | null,
        updatedAt?: string | null,
        username: string,
      } | null,
      UserCreateDate?: string | null,
      UserLastModifiedDate?: string | null,
      UserStatus?: CognitoUserUserStatus | null,
      Username?: string | null,
    } | null,
  } | null,
};

export type ConvertEstateGroundToLotFMutationVariables = {
  input: DeleteEstateInput,
};

export type ConvertEstateGroundToLotFMutation = {
  convertEstateGroundToLotF?:  {
    __typename: "EstateMutationResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "EstateType",
      address?: string | null,
      appearanceImgs?: Array< string | null > | null,
      area?: string | null,
      balconyArea?: number | null,
      bcr?: number | null,
      bldConditionType?: string | null,
      buildingCompany?: string | null,
      buildingFloors?: string | null,
      cadastralMapPdf?: string | null,
      carsInParkingN?: number | null,
      city?: string | null,
      cityPlanningType?: string | null,
      cleaningMonth?: number | null,
      clearingType?: string | null,
      collectedAt?: string | null,
      companyAddress?: string | null,
      companyBranchId?: number | null,
      companyFax?: string | null,
      companyGuaranter?: string | null,
      companyId?: string | null,
      companyLicense?: string | null,
      companyName?: string | null,
      companyRecNo?: number | null,
      companyTel?: string | null,
      companyUrl?: string | null,
      completionMonth?: number | null,
      completionMonthS?: string | null,
      completionSchMonth?: number | null,
      condominiumId?: string | null,
      condominiumName?: string | null,
      condominiumRecNo?: number | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      currentStatus?: string | null,
      currentStatusB?: string | null,
      currentStatusFree?: string | null,
      currentStatusG?: string | null,
      deletedOnSumora?: number | null,
      drivewayPay?: string | null,
      eSchool?: Array< string | null > | null,
      estatePrice?: number | null,
      estateType?: string | null,
      estateUrl?: string | null,
      exactLocation?: number | null,
      floor?: number | null,
      floorAreaRatio?: number | null,
      floorStructure?: string | null,
      fullAddress?: string | null,
      gas?: string | null,
      gasPdf?: string | null,
      groundPdf?: string | null,
      groundType?: Array< string | null > | null,
      groundTypeFree?: string | null,
      id: string,
      infoName: string,
      isLot?: number | null,
      jSchool?: Array< string | null > | null,
      landAreaType?: string | null,
      landRights?: string | null,
      latitude?: number | null,
      layout?: string | null,
      layoutImgs?: Array< string | null > | null,
      license?: string | null,
      location?: string | null,
      longitude?: number | null,
      managementFee?: number | null,
      managementType?: string | null,
      manager?: string | null,
      mapImg?: string | null,
      media?: string | null,
      mediationKind?: string | null,
      name?: string | null,
      nearlyLocation?: number | null,
      notFoundAt?: string | null,
      otherCost?: number | null,
      owner?: string | null,
      parking?: string | null,
      parkingFee?: number | null,
      parkingHeight?: number | null,
      parkingMechOrPlane?: string | null,
      parkingTakeOver?: string | null,
      parkingTakeOverFree?: string | null,
      pet?: string | null,
      prefecture?: string | null,
      priceHistory?:  Array< {
        __typename: "Price",
        price?: number | null,
        pricedAt?: string | null,
      } | null > | null,
      pricedAt?: string | null,
      purposeB?: string | null,
      purposeSummaryB?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      repairCost?: number | null,
      roadDirection?: string | null,
      roadType?: string | null,
      roadWidth?: number | null,
      room?: string | null,
      searchInfo: string,
      seller?: string | null,
      sewer?: string | null,
      sewerPdf?: string | null,
      sold?: boolean | null,
      squareArea?: number | null,
      status?: string | null,
      store?: string | null,
      structure?: string | null,
      structureFree?: string | null,
      subCompany2Address?: string | null,
      subCompany2Fax?: string | null,
      subCompany2Guaranter?: string | null,
      subCompany2Id?: string | null,
      subCompany2License?: string | null,
      subCompany2Name?: string | null,
      subCompany2Tel?: string | null,
      subCompany2Url?: string | null,
      subCompanyAddress?: string | null,
      subCompanyFax?: string | null,
      subCompanyGuaranter?: string | null,
      subCompanyId?: string | null,
      subCompanyLicense?: string | null,
      subCompanyName?: string | null,
      subCompanyRecNo?: number | null,
      subCompanyTel?: string | null,
      subCompanyUrl?: string | null,
      tileOnZoom12?: string | null,
      tileOnZoom14?: string | null,
      tileOnZoom16?: string | null,
      totalArea?: number | null,
      totalHouses?: number | null,
      traffic?: string | null,
      tsuboArea?: number | null,
      unitPrice?: number | null,
      unsettledLocation?: number | null,
      updatedAt?: string | null,
      url?: string | null,
      useDistrict?: Array< string | null > | null,
      water?: string | null,
      waterPdf?: string | null,
    } | null,
  } | null,
};

export type ConvertEstateLotToGroundFMutationVariables = {
  input: DeleteEstateInput,
};

export type ConvertEstateLotToGroundFMutation = {
  convertEstateLotToGroundF?:  {
    __typename: "EstateMutationResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "EstateType",
      address?: string | null,
      appearanceImgs?: Array< string | null > | null,
      area?: string | null,
      balconyArea?: number | null,
      bcr?: number | null,
      bldConditionType?: string | null,
      buildingCompany?: string | null,
      buildingFloors?: string | null,
      cadastralMapPdf?: string | null,
      carsInParkingN?: number | null,
      city?: string | null,
      cityPlanningType?: string | null,
      cleaningMonth?: number | null,
      clearingType?: string | null,
      collectedAt?: string | null,
      companyAddress?: string | null,
      companyBranchId?: number | null,
      companyFax?: string | null,
      companyGuaranter?: string | null,
      companyId?: string | null,
      companyLicense?: string | null,
      companyName?: string | null,
      companyRecNo?: number | null,
      companyTel?: string | null,
      companyUrl?: string | null,
      completionMonth?: number | null,
      completionMonthS?: string | null,
      completionSchMonth?: number | null,
      condominiumId?: string | null,
      condominiumName?: string | null,
      condominiumRecNo?: number | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      currentStatus?: string | null,
      currentStatusB?: string | null,
      currentStatusFree?: string | null,
      currentStatusG?: string | null,
      deletedOnSumora?: number | null,
      drivewayPay?: string | null,
      eSchool?: Array< string | null > | null,
      estatePrice?: number | null,
      estateType?: string | null,
      estateUrl?: string | null,
      exactLocation?: number | null,
      floor?: number | null,
      floorAreaRatio?: number | null,
      floorStructure?: string | null,
      fullAddress?: string | null,
      gas?: string | null,
      gasPdf?: string | null,
      groundPdf?: string | null,
      groundType?: Array< string | null > | null,
      groundTypeFree?: string | null,
      id: string,
      infoName: string,
      isLot?: number | null,
      jSchool?: Array< string | null > | null,
      landAreaType?: string | null,
      landRights?: string | null,
      latitude?: number | null,
      layout?: string | null,
      layoutImgs?: Array< string | null > | null,
      license?: string | null,
      location?: string | null,
      longitude?: number | null,
      managementFee?: number | null,
      managementType?: string | null,
      manager?: string | null,
      mapImg?: string | null,
      media?: string | null,
      mediationKind?: string | null,
      name?: string | null,
      nearlyLocation?: number | null,
      notFoundAt?: string | null,
      otherCost?: number | null,
      owner?: string | null,
      parking?: string | null,
      parkingFee?: number | null,
      parkingHeight?: number | null,
      parkingMechOrPlane?: string | null,
      parkingTakeOver?: string | null,
      parkingTakeOverFree?: string | null,
      pet?: string | null,
      prefecture?: string | null,
      priceHistory?:  Array< {
        __typename: "Price",
        price?: number | null,
        pricedAt?: string | null,
      } | null > | null,
      pricedAt?: string | null,
      purposeB?: string | null,
      purposeSummaryB?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      repairCost?: number | null,
      roadDirection?: string | null,
      roadType?: string | null,
      roadWidth?: number | null,
      room?: string | null,
      searchInfo: string,
      seller?: string | null,
      sewer?: string | null,
      sewerPdf?: string | null,
      sold?: boolean | null,
      squareArea?: number | null,
      status?: string | null,
      store?: string | null,
      structure?: string | null,
      structureFree?: string | null,
      subCompany2Address?: string | null,
      subCompany2Fax?: string | null,
      subCompany2Guaranter?: string | null,
      subCompany2Id?: string | null,
      subCompany2License?: string | null,
      subCompany2Name?: string | null,
      subCompany2Tel?: string | null,
      subCompany2Url?: string | null,
      subCompanyAddress?: string | null,
      subCompanyFax?: string | null,
      subCompanyGuaranter?: string | null,
      subCompanyId?: string | null,
      subCompanyLicense?: string | null,
      subCompanyName?: string | null,
      subCompanyRecNo?: number | null,
      subCompanyTel?: string | null,
      subCompanyUrl?: string | null,
      tileOnZoom12?: string | null,
      tileOnZoom14?: string | null,
      tileOnZoom16?: string | null,
      totalArea?: number | null,
      totalHouses?: number | null,
      traffic?: string | null,
      tsuboArea?: number | null,
      unitPrice?: number | null,
      unsettledLocation?: number | null,
      updatedAt?: string | null,
      url?: string | null,
      useDistrict?: Array< string | null > | null,
      water?: string | null,
      waterPdf?: string | null,
    } | null,
  } | null,
};

export type CreateAnnounceMutationVariables = {
  condition?: ModelAnnounceConditionInput | null,
  input: CreateAnnounceInput,
};

export type CreateAnnounceMutation = {
  createAnnounce?:  {
    __typename: "Announce",
    body: string,
    createdAt: string,
    expiredAt?: number | null,
    id: string,
    level: AnnounceLevel,
    owner: string,
    subject: string,
    to: string,
    updatedAt?: string | null,
    ym: string,
  } | null,
};

export type CreateBatchJobMutationVariables = {
  condition?: ModelBatchJobConditionInput | null,
  input: CreateBatchJobInput,
};

export type CreateBatchJobMutation = {
  createBatchJob?:  {
    __typename: "BatchJob",
    createdAt?: string | null,
    expiredAt?: number | null,
    id: string,
    jobName: string,
    remarks: string,
    status: string,
    updatedAt?: string | null,
  } | null,
};

export type CreateBatchJobConfMutationVariables = {
  condition?: ModelBatchJobConfConditionInput | null,
  input: CreateBatchJobConfInput,
};

export type CreateBatchJobConfMutation = {
  createBatchJobConf?:  {
    __typename: "BatchJobConf",
    allowedGroups?: Array< string | null > | null,
    createdAt?: string | null,
    jobName: string,
    remarks: string,
    updatedAt?: string | null,
  } | null,
};

export type CreateBuildPriceMutationVariables = {
  condition?: ModelBuildPriceConditionInput | null,
  input: CreateBuildPriceInput,
};

export type CreateBuildPriceMutation = {
  createBuildPrice?:  {
    __typename: "BuildPrice",
    createdAt?: string | null,
    owner: string,
    unitPriceCB: number,
    unitPriceOther: number,
    unitPriceRC: number,
    unitPriceS: number,
    unitPriceSRC: number,
    unitPriceW: number,
    updatedAt?: string | null,
    year: number,
  } | null,
};

export type CreateCognitoUserFMutationVariables = {
  agreement?: boolean | null,
  companyId: string,
  email: string,
  group: string,
  name: string,
  nameRuby: string,
  paid?: boolean | null,
  password: string,
  pricingAvailable?: boolean | null,
  role?: string | null,
  tel?: string | null,
  trial?: boolean | null,
  trialEndAt?: string | null,
  username: string,
};

export type CreateCognitoUserFMutation = {
  createCognitoUserF?:  {
    __typename: "CognitoUserResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "CognitoUser",
      Attributes?:  Array< {
        __typename: "CognitoUserAttribute",
        Name?: string | null,
        Value?: string | null,
      } | null > | null,
      Company?:  {
        __typename: "CompanyType",
        address?: string | null,
        areaNames?: Array< string | null > | null,
        areaPrefs?: Array< string | null > | null,
        areas?: Array< string | null > | null,
        bldConditionCompanies?: Array< string | null > | null,
        bldConditionSelections?: Array< string | null > | null,
        branchAddress?: string | null,
        branchFax?: string | null,
        branchId?: number | null,
        branchName?: string | null,
        branchTel?: string | null,
        branchUrl?: string | null,
        createdAt?: string | null,
        eAreaNames?: Array< string | null > | null,
        eAreas?: Array< string | null > | null,
        email?: string | null,
        estateTypes?: Array< string | null > | null,
        fax?: string | null,
        guaranter?: string | null,
        id: string,
        infoName: string,
        job?: string | null,
        latitude?: number | null,
        license?: string | null,
        licenseCount?: number | null,
        licenseNo?: string | null,
        licenser?: string | null,
        logoImg?: string | null,
        longitude?: number | null,
        name?: string | null,
        organization?: string | null,
        owner?: string | null,
        recNo?: number | null,
        remarks?: string | null,
        remarks2?: string | null,
        searchInfo: string,
        startMark?: string | null,
        tel?: string | null,
        updatedAt?: string | null,
        url?: string | null,
      } | null,
      Enabled?: boolean | null,
      Groups?:  Array< {
        __typename: "CognitoGroup",
        CreationDate?: string | null,
        Description?: string | null,
        GroupName?: string | null,
        LastModifiedDate?: string | null,
        Precedence?: number | null,
        RoleArn?: string | null,
        UserPoolId?: string | null,
      } | null > | null,
      MFAOptions?:  Array< {
        __typename: "CognitoUserMFAOption",
        AttributeName?: string | null,
        DeliveryMedium?: CognitoUserMFAOptionDeliveryMedium | null,
      } | null > | null,
      User?:  {
        __typename: "UserType",
        agreement?: boolean | null,
        authenticatedAt?: string | null,
        companyBranchName?: string | null,
        companyId?: string | null,
        companyName?: string | null,
        createdAt?: string | null,
        defaultCondition?:  {
          __typename: "DefaultCondition",
          alsoCreatedAtFrom?: number | null,
          alsoCreatedAtTo?: number | null,
          alsoPricedAtFrom?: number | null,
          alsoPricedAtTo?: number | null,
          areaPrefs?: Array< string | null > | null,
          areas?: Array< string | null > | null,
          bldConditionSelections?: Array< string | null > | null,
          companyRecNo?: number | null,
          completionYMFrom?: number | null,
          completionYMTo?: number | null,
          estatePriceFrom?: number | null,
          estatePriceTo?: number | null,
          estateTypes?: Array< string | null > | null,
          exceptForRent?: boolean | null,
          flat?: boolean | null,
          forRent?: boolean | null,
          petOk?: boolean | null,
          priceLabel?: boolean | null,
          purposeSummaryBs?: Array< string | null > | null,
          roomsFrom?: number | null,
          roomsTo?: number | null,
          squareAreaOfMansionFrom?: number | null,
          squareAreaOfMansionTo?: number | null,
          structureSummaries?: Array< string | null > | null,
          tsuboAreaFrom?: number | null,
          tsuboAreaTo?: number | null,
          tsuboLabel?: boolean | null,
          venderOnly?: boolean | null,
        } | null,
        email?: string | null,
        group?: string | null,
        infoName: string,
        name?: string | null,
        nameRuby?: string | null,
        owner?: string | null,
        paid?: boolean | null,
        pricingAvailable?: boolean | null,
        role?: string | null,
        searchInfo?: string | null,
        tel?: string | null,
        trial?: boolean | null,
        trialEndAt?: string | null,
        updatedAt?: string | null,
        username: string,
      } | null,
      UserCreateDate?: string | null,
      UserLastModifiedDate?: string | null,
      UserStatus?: CognitoUserUserStatus | null,
      Username?: string | null,
    } | null,
  } | null,
};

export type CreateDummyMutationVariables = {
  condition?: ModelDummyConditionInput | null,
  input: CreateDummyInput,
};

export type CreateDummyMutation = {
  createDummy?:  {
    __typename: "Dummy",
    createdAt: string,
    id: string,
    kintoneAppScope?: KintoneAppScope | null,
    kintoneDataKind?: KintoneDataKind | null,
    updatedAt: string,
  } | null,
};

export type CreateEstateFMutationVariables = {
  input: CreateEstateInput,
};

export type CreateEstateFMutation = {
  createEstateF?:  {
    __typename: "EstateMutationResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "EstateType",
      address?: string | null,
      appearanceImgs?: Array< string | null > | null,
      area?: string | null,
      balconyArea?: number | null,
      bcr?: number | null,
      bldConditionType?: string | null,
      buildingCompany?: string | null,
      buildingFloors?: string | null,
      cadastralMapPdf?: string | null,
      carsInParkingN?: number | null,
      city?: string | null,
      cityPlanningType?: string | null,
      cleaningMonth?: number | null,
      clearingType?: string | null,
      collectedAt?: string | null,
      companyAddress?: string | null,
      companyBranchId?: number | null,
      companyFax?: string | null,
      companyGuaranter?: string | null,
      companyId?: string | null,
      companyLicense?: string | null,
      companyName?: string | null,
      companyRecNo?: number | null,
      companyTel?: string | null,
      companyUrl?: string | null,
      completionMonth?: number | null,
      completionMonthS?: string | null,
      completionSchMonth?: number | null,
      condominiumId?: string | null,
      condominiumName?: string | null,
      condominiumRecNo?: number | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      currentStatus?: string | null,
      currentStatusB?: string | null,
      currentStatusFree?: string | null,
      currentStatusG?: string | null,
      deletedOnSumora?: number | null,
      drivewayPay?: string | null,
      eSchool?: Array< string | null > | null,
      estatePrice?: number | null,
      estateType?: string | null,
      estateUrl?: string | null,
      exactLocation?: number | null,
      floor?: number | null,
      floorAreaRatio?: number | null,
      floorStructure?: string | null,
      fullAddress?: string | null,
      gas?: string | null,
      gasPdf?: string | null,
      groundPdf?: string | null,
      groundType?: Array< string | null > | null,
      groundTypeFree?: string | null,
      id: string,
      infoName: string,
      isLot?: number | null,
      jSchool?: Array< string | null > | null,
      landAreaType?: string | null,
      landRights?: string | null,
      latitude?: number | null,
      layout?: string | null,
      layoutImgs?: Array< string | null > | null,
      license?: string | null,
      location?: string | null,
      longitude?: number | null,
      managementFee?: number | null,
      managementType?: string | null,
      manager?: string | null,
      mapImg?: string | null,
      media?: string | null,
      mediationKind?: string | null,
      name?: string | null,
      nearlyLocation?: number | null,
      notFoundAt?: string | null,
      otherCost?: number | null,
      owner?: string | null,
      parking?: string | null,
      parkingFee?: number | null,
      parkingHeight?: number | null,
      parkingMechOrPlane?: string | null,
      parkingTakeOver?: string | null,
      parkingTakeOverFree?: string | null,
      pet?: string | null,
      prefecture?: string | null,
      priceHistory?:  Array< {
        __typename: "Price",
        price?: number | null,
        pricedAt?: string | null,
      } | null > | null,
      pricedAt?: string | null,
      purposeB?: string | null,
      purposeSummaryB?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      repairCost?: number | null,
      roadDirection?: string | null,
      roadType?: string | null,
      roadWidth?: number | null,
      room?: string | null,
      searchInfo: string,
      seller?: string | null,
      sewer?: string | null,
      sewerPdf?: string | null,
      sold?: boolean | null,
      squareArea?: number | null,
      status?: string | null,
      store?: string | null,
      structure?: string | null,
      structureFree?: string | null,
      subCompany2Address?: string | null,
      subCompany2Fax?: string | null,
      subCompany2Guaranter?: string | null,
      subCompany2Id?: string | null,
      subCompany2License?: string | null,
      subCompany2Name?: string | null,
      subCompany2Tel?: string | null,
      subCompany2Url?: string | null,
      subCompanyAddress?: string | null,
      subCompanyFax?: string | null,
      subCompanyGuaranter?: string | null,
      subCompanyId?: string | null,
      subCompanyLicense?: string | null,
      subCompanyName?: string | null,
      subCompanyRecNo?: number | null,
      subCompanyTel?: string | null,
      subCompanyUrl?: string | null,
      tileOnZoom12?: string | null,
      tileOnZoom14?: string | null,
      tileOnZoom16?: string | null,
      totalArea?: number | null,
      totalHouses?: number | null,
      traffic?: string | null,
      tsuboArea?: number | null,
      unitPrice?: number | null,
      unsettledLocation?: number | null,
      updatedAt?: string | null,
      url?: string | null,
      useDistrict?: Array< string | null > | null,
      water?: string | null,
      waterPdf?: string | null,
    } | null,
  } | null,
};

export type CreatePublicEstateFMutationVariables = {
  input: CreatePublicEstateInput,
};

export type CreatePublicEstateFMutation = {
  createPublicEstateF?:  {
    __typename: "PublicEstateMutationResponse",
    id: string,
  } | null,
};

export type CreatePublicEstatePdfFMutationVariables = {
  input: CreatePublicEstatePdfInput,
};

export type CreatePublicEstatePdfFMutation = {
  createPublicEstatePdfF?:  {
    __typename: "PublicEstatePdfMutationResponse",
    pdf: string,
  } | null,
};

export type CreateReportMutationVariables = {
  condition?: ModelReportConditionInput | null,
  input: CreateReportInput,
};

export type CreateReportMutation = {
  createReport?:  {
    __typename: "Report",
    companyId: string,
    companyName: string,
    createdAt: string,
    description?: string | null,
    estateId: string,
    estateName?: string | null,
    expiredAt?: number | null,
    id: string,
    latitude?: number | null,
    longitude?: number | null,
    owner: string,
    reportKind: string,
    updatedAt?: string | null,
    userName: string,
  } | null,
};

export type CreateScrapingMutationVariables = {
  condition?: ModelScrapingConditionInput | null,
  input: CreateScrapingInput,
};

export type CreateScrapingMutation = {
  createScraping?:  {
    __typename: "Scraping",
    baseUrl: string,
    createdAt?: string | null,
    endedAt?: string | null,
    input?: string | null,
    operation?: string | null,
    output?: string | null,
    prefName: string,
    remarks?: string | null,
    resultKey?: string | null,
    sortKey: string,
    startedAt?: string | null,
    status: string,
    totalCount?: number | null,
    updated?:  {
      __typename: "ScrapingUpdateDetail",
      blocked?: number | null,
      expired?: number | null,
      newRecord?: number | null,
      onSite?: number | null,
      requiresAuth?: number | null,
      return?: number | null,
      returnAndUpdatePrice?: number | null,
      scrapingFailed?: number | null,
      updateFailed?: number | null,
      updatePrice?: number | null,
    } | null,
    updatedAt?: string | null,
    updating?:  {
      __typename: "ScrapingUpdateDetail",
      blocked?: number | null,
      expired?: number | null,
      newRecord?: number | null,
      onSite?: number | null,
      requiresAuth?: number | null,
      return?: number | null,
      returnAndUpdatePrice?: number | null,
      scrapingFailed?: number | null,
      updateFailed?: number | null,
      updatePrice?: number | null,
    } | null,
  } | null,
};

export type CreateStickyNoteFMutationVariables = {
  input: CreateStickyNoteInput,
};

export type CreateStickyNoteFMutation = {
  createStickyNoteF?:  {
    __typename: "StickyNoteMutationResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "StickyNoteType",
      color?: StickyNoteColor | null,
      companyId: string,
      createdAt?: string | null,
      description?: string | null,
      icon?: StickyNoteIcon | null,
      id: string,
      infoName: string,
      latitude: number,
      longitude: number,
      memoKind: string,
      openLevel: string,
      owner: string,
      searchInfo: string,
      tileOnZoom12: string,
      tileOnZoom14: string,
      tileOnZoom16: string,
      updatedAt?: string | null,
      url1?: string | null,
      url2?: string | null,
      url3?: string | null,
    } | null,
  } | null,
};

export type DeleteAnnounceMutationVariables = {
  condition?: ModelAnnounceConditionInput | null,
  input: DeleteAnnounceInput,
};

export type DeleteAnnounceMutation = {
  deleteAnnounce?:  {
    __typename: "Announce",
    body: string,
    createdAt: string,
    expiredAt?: number | null,
    id: string,
    level: AnnounceLevel,
    owner: string,
    subject: string,
    to: string,
    updatedAt?: string | null,
    ym: string,
  } | null,
};

export type DeleteBatchJobMutationVariables = {
  condition?: ModelBatchJobConditionInput | null,
  input: DeleteBatchJobInput,
};

export type DeleteBatchJobMutation = {
  deleteBatchJob?:  {
    __typename: "BatchJob",
    createdAt?: string | null,
    expiredAt?: number | null,
    id: string,
    jobName: string,
    remarks: string,
    status: string,
    updatedAt?: string | null,
  } | null,
};

export type DeleteBatchJobConfMutationVariables = {
  condition?: ModelBatchJobConfConditionInput | null,
  input: DeleteBatchJobConfInput,
};

export type DeleteBatchJobConfMutation = {
  deleteBatchJobConf?:  {
    __typename: "BatchJobConf",
    allowedGroups?: Array< string | null > | null,
    createdAt?: string | null,
    jobName: string,
    remarks: string,
    updatedAt?: string | null,
  } | null,
};

export type DeleteBuildPriceMutationVariables = {
  condition?: ModelBuildPriceConditionInput | null,
  input: DeleteBuildPriceInput,
};

export type DeleteBuildPriceMutation = {
  deleteBuildPrice?:  {
    __typename: "BuildPrice",
    createdAt?: string | null,
    owner: string,
    unitPriceCB: number,
    unitPriceOther: number,
    unitPriceRC: number,
    unitPriceS: number,
    unitPriceSRC: number,
    unitPriceW: number,
    updatedAt?: string | null,
    year: number,
  } | null,
};

export type DeleteCognitoUserFMutationVariables = {
  username: string,
};

export type DeleteCognitoUserFMutation = {
  deleteCognitoUserF?:  {
    __typename: "CognitoUserResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "CognitoUser",
      Attributes?:  Array< {
        __typename: "CognitoUserAttribute",
        Name?: string | null,
        Value?: string | null,
      } | null > | null,
      Company?:  {
        __typename: "CompanyType",
        address?: string | null,
        areaNames?: Array< string | null > | null,
        areaPrefs?: Array< string | null > | null,
        areas?: Array< string | null > | null,
        bldConditionCompanies?: Array< string | null > | null,
        bldConditionSelections?: Array< string | null > | null,
        branchAddress?: string | null,
        branchFax?: string | null,
        branchId?: number | null,
        branchName?: string | null,
        branchTel?: string | null,
        branchUrl?: string | null,
        createdAt?: string | null,
        eAreaNames?: Array< string | null > | null,
        eAreas?: Array< string | null > | null,
        email?: string | null,
        estateTypes?: Array< string | null > | null,
        fax?: string | null,
        guaranter?: string | null,
        id: string,
        infoName: string,
        job?: string | null,
        latitude?: number | null,
        license?: string | null,
        licenseCount?: number | null,
        licenseNo?: string | null,
        licenser?: string | null,
        logoImg?: string | null,
        longitude?: number | null,
        name?: string | null,
        organization?: string | null,
        owner?: string | null,
        recNo?: number | null,
        remarks?: string | null,
        remarks2?: string | null,
        searchInfo: string,
        startMark?: string | null,
        tel?: string | null,
        updatedAt?: string | null,
        url?: string | null,
      } | null,
      Enabled?: boolean | null,
      Groups?:  Array< {
        __typename: "CognitoGroup",
        CreationDate?: string | null,
        Description?: string | null,
        GroupName?: string | null,
        LastModifiedDate?: string | null,
        Precedence?: number | null,
        RoleArn?: string | null,
        UserPoolId?: string | null,
      } | null > | null,
      MFAOptions?:  Array< {
        __typename: "CognitoUserMFAOption",
        AttributeName?: string | null,
        DeliveryMedium?: CognitoUserMFAOptionDeliveryMedium | null,
      } | null > | null,
      User?:  {
        __typename: "UserType",
        agreement?: boolean | null,
        authenticatedAt?: string | null,
        companyBranchName?: string | null,
        companyId?: string | null,
        companyName?: string | null,
        createdAt?: string | null,
        defaultCondition?:  {
          __typename: "DefaultCondition",
          alsoCreatedAtFrom?: number | null,
          alsoCreatedAtTo?: number | null,
          alsoPricedAtFrom?: number | null,
          alsoPricedAtTo?: number | null,
          areaPrefs?: Array< string | null > | null,
          areas?: Array< string | null > | null,
          bldConditionSelections?: Array< string | null > | null,
          companyRecNo?: number | null,
          completionYMFrom?: number | null,
          completionYMTo?: number | null,
          estatePriceFrom?: number | null,
          estatePriceTo?: number | null,
          estateTypes?: Array< string | null > | null,
          exceptForRent?: boolean | null,
          flat?: boolean | null,
          forRent?: boolean | null,
          petOk?: boolean | null,
          priceLabel?: boolean | null,
          purposeSummaryBs?: Array< string | null > | null,
          roomsFrom?: number | null,
          roomsTo?: number | null,
          squareAreaOfMansionFrom?: number | null,
          squareAreaOfMansionTo?: number | null,
          structureSummaries?: Array< string | null > | null,
          tsuboAreaFrom?: number | null,
          tsuboAreaTo?: number | null,
          tsuboLabel?: boolean | null,
          venderOnly?: boolean | null,
        } | null,
        email?: string | null,
        group?: string | null,
        infoName: string,
        name?: string | null,
        nameRuby?: string | null,
        owner?: string | null,
        paid?: boolean | null,
        pricingAvailable?: boolean | null,
        role?: string | null,
        searchInfo?: string | null,
        tel?: string | null,
        trial?: boolean | null,
        trialEndAt?: string | null,
        updatedAt?: string | null,
        username: string,
      } | null,
      UserCreateDate?: string | null,
      UserLastModifiedDate?: string | null,
      UserStatus?: CognitoUserUserStatus | null,
      Username?: string | null,
    } | null,
  } | null,
};

export type DeleteCompanyFMutationVariables = {
  input: DeleteCompanyInput,
};

export type DeleteCompanyFMutation = {
  deleteCompanyF?:  {
    __typename: "CompanyMutationResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "CompanyType",
      address?: string | null,
      areaNames?: Array< string | null > | null,
      areaPrefs?: Array< string | null > | null,
      areas?: Array< string | null > | null,
      bldConditionCompanies?: Array< string | null > | null,
      bldConditionSelections?: Array< string | null > | null,
      branchAddress?: string | null,
      branchFax?: string | null,
      branchId?: number | null,
      branchName?: string | null,
      branchTel?: string | null,
      branchUrl?: string | null,
      createdAt?: string | null,
      eAreaNames?: Array< string | null > | null,
      eAreas?: Array< string | null > | null,
      email?: string | null,
      estateTypes?: Array< string | null > | null,
      fax?: string | null,
      guaranter?: string | null,
      id: string,
      infoName: string,
      job?: string | null,
      latitude?: number | null,
      license?: string | null,
      licenseCount?: number | null,
      licenseNo?: string | null,
      licenser?: string | null,
      logoImg?: string | null,
      longitude?: number | null,
      name?: string | null,
      organization?: string | null,
      owner?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      remarks2?: string | null,
      searchInfo: string,
      startMark?: string | null,
      tel?: string | null,
      updatedAt?: string | null,
      url?: string | null,
    } | null,
  } | null,
};

export type DeleteDummyMutationVariables = {
  condition?: ModelDummyConditionInput | null,
  input: DeleteDummyInput,
};

export type DeleteDummyMutation = {
  deleteDummy?:  {
    __typename: "Dummy",
    createdAt: string,
    id: string,
    kintoneAppScope?: KintoneAppScope | null,
    kintoneDataKind?: KintoneDataKind | null,
    updatedAt: string,
  } | null,
};

export type DeleteEstateFMutationVariables = {
  input: DeleteEstateInput,
};

export type DeleteEstateFMutation = {
  deleteEstateF?:  {
    __typename: "EstateMutationResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "EstateType",
      address?: string | null,
      appearanceImgs?: Array< string | null > | null,
      area?: string | null,
      balconyArea?: number | null,
      bcr?: number | null,
      bldConditionType?: string | null,
      buildingCompany?: string | null,
      buildingFloors?: string | null,
      cadastralMapPdf?: string | null,
      carsInParkingN?: number | null,
      city?: string | null,
      cityPlanningType?: string | null,
      cleaningMonth?: number | null,
      clearingType?: string | null,
      collectedAt?: string | null,
      companyAddress?: string | null,
      companyBranchId?: number | null,
      companyFax?: string | null,
      companyGuaranter?: string | null,
      companyId?: string | null,
      companyLicense?: string | null,
      companyName?: string | null,
      companyRecNo?: number | null,
      companyTel?: string | null,
      companyUrl?: string | null,
      completionMonth?: number | null,
      completionMonthS?: string | null,
      completionSchMonth?: number | null,
      condominiumId?: string | null,
      condominiumName?: string | null,
      condominiumRecNo?: number | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      currentStatus?: string | null,
      currentStatusB?: string | null,
      currentStatusFree?: string | null,
      currentStatusG?: string | null,
      deletedOnSumora?: number | null,
      drivewayPay?: string | null,
      eSchool?: Array< string | null > | null,
      estatePrice?: number | null,
      estateType?: string | null,
      estateUrl?: string | null,
      exactLocation?: number | null,
      floor?: number | null,
      floorAreaRatio?: number | null,
      floorStructure?: string | null,
      fullAddress?: string | null,
      gas?: string | null,
      gasPdf?: string | null,
      groundPdf?: string | null,
      groundType?: Array< string | null > | null,
      groundTypeFree?: string | null,
      id: string,
      infoName: string,
      isLot?: number | null,
      jSchool?: Array< string | null > | null,
      landAreaType?: string | null,
      landRights?: string | null,
      latitude?: number | null,
      layout?: string | null,
      layoutImgs?: Array< string | null > | null,
      license?: string | null,
      location?: string | null,
      longitude?: number | null,
      managementFee?: number | null,
      managementType?: string | null,
      manager?: string | null,
      mapImg?: string | null,
      media?: string | null,
      mediationKind?: string | null,
      name?: string | null,
      nearlyLocation?: number | null,
      notFoundAt?: string | null,
      otherCost?: number | null,
      owner?: string | null,
      parking?: string | null,
      parkingFee?: number | null,
      parkingHeight?: number | null,
      parkingMechOrPlane?: string | null,
      parkingTakeOver?: string | null,
      parkingTakeOverFree?: string | null,
      pet?: string | null,
      prefecture?: string | null,
      priceHistory?:  Array< {
        __typename: "Price",
        price?: number | null,
        pricedAt?: string | null,
      } | null > | null,
      pricedAt?: string | null,
      purposeB?: string | null,
      purposeSummaryB?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      repairCost?: number | null,
      roadDirection?: string | null,
      roadType?: string | null,
      roadWidth?: number | null,
      room?: string | null,
      searchInfo: string,
      seller?: string | null,
      sewer?: string | null,
      sewerPdf?: string | null,
      sold?: boolean | null,
      squareArea?: number | null,
      status?: string | null,
      store?: string | null,
      structure?: string | null,
      structureFree?: string | null,
      subCompany2Address?: string | null,
      subCompany2Fax?: string | null,
      subCompany2Guaranter?: string | null,
      subCompany2Id?: string | null,
      subCompany2License?: string | null,
      subCompany2Name?: string | null,
      subCompany2Tel?: string | null,
      subCompany2Url?: string | null,
      subCompanyAddress?: string | null,
      subCompanyFax?: string | null,
      subCompanyGuaranter?: string | null,
      subCompanyId?: string | null,
      subCompanyLicense?: string | null,
      subCompanyName?: string | null,
      subCompanyRecNo?: number | null,
      subCompanyTel?: string | null,
      subCompanyUrl?: string | null,
      tileOnZoom12?: string | null,
      tileOnZoom14?: string | null,
      tileOnZoom16?: string | null,
      totalArea?: number | null,
      totalHouses?: number | null,
      traffic?: string | null,
      tsuboArea?: number | null,
      unitPrice?: number | null,
      unsettledLocation?: number | null,
      updatedAt?: string | null,
      url?: string | null,
      useDistrict?: Array< string | null > | null,
      water?: string | null,
      waterPdf?: string | null,
    } | null,
  } | null,
};

export type DeleteReportMutationVariables = {
  condition?: ModelReportConditionInput | null,
  input: DeleteReportInput,
};

export type DeleteReportMutation = {
  deleteReport?:  {
    __typename: "Report",
    companyId: string,
    companyName: string,
    createdAt: string,
    description?: string | null,
    estateId: string,
    estateName?: string | null,
    expiredAt?: number | null,
    id: string,
    latitude?: number | null,
    longitude?: number | null,
    owner: string,
    reportKind: string,
    updatedAt?: string | null,
    userName: string,
  } | null,
};

export type DeleteStickyNoteFMutationVariables = {
  input: DeleteStickyNoteInput,
};

export type DeleteStickyNoteFMutation = {
  deleteStickyNoteF?:  {
    __typename: "StickyNoteMutationResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "StickyNoteType",
      color?: StickyNoteColor | null,
      companyId: string,
      createdAt?: string | null,
      description?: string | null,
      icon?: StickyNoteIcon | null,
      id: string,
      infoName: string,
      latitude: number,
      longitude: number,
      memoKind: string,
      openLevel: string,
      owner: string,
      searchInfo: string,
      tileOnZoom12: string,
      tileOnZoom14: string,
      tileOnZoom16: string,
      updatedAt?: string | null,
      url1?: string | null,
      url2?: string | null,
      url3?: string | null,
    } | null,
  } | null,
};

export type IncrementEstateAtomicCounterCMutationVariables = {
  id: string,
};

export type IncrementEstateAtomicCounterCMutation = {
  incrementEstateAtomicCounterC?:  {
    __typename: "AtomicCounter",
    counterName: string,
    createdAt?: string | null,
    kind: string,
    sequence: number,
    updatedAt?: string | null,
  } | null,
};

export type IncrementRecNoAtomicCounterCMutationVariables = {
};

export type IncrementRecNoAtomicCounterCMutation = {
  incrementRecNoAtomicCounterC?:  {
    __typename: "AtomicCounter",
    counterName: string,
    createdAt?: string | null,
    kind: string,
    sequence: number,
    updatedAt?: string | null,
  } | null,
};

export type IncrementSearchAtomicCounterCMutationVariables = {
};

export type IncrementSearchAtomicCounterCMutation = {
  incrementSearchAtomicCounterC?:  {
    __typename: "AtomicCounter",
    counterName: string,
    createdAt?: string | null,
    kind: string,
    sequence: number,
    updatedAt?: string | null,
  } | null,
};

export type IncrementSiteAtomicCounterCMutationVariables = {
  site: string,
};

export type IncrementSiteAtomicCounterCMutation = {
  incrementSiteAtomicCounterC?:  {
    __typename: "AtomicCounter",
    counterName: string,
    createdAt?: string | null,
    kind: string,
    sequence: number,
    updatedAt?: string | null,
  } | null,
};

export type InvokeExportUserCsvMutationVariables = {
  todayOnly?: boolean | null,
};

export type InvokeExportUserCsvMutation = {
  invokeExportUserCsv?: string | null,
};

export type NotifyEstateCMutationVariables = {
  input: NotifyEstateInput,
};

export type NotifyEstateCMutation = {
  notifyEstateC?:  {
    __typename: "EstateNotifyResponse",
    address?: string | null,
    appearanceImgs?: Array< string | null > | null,
    area?: string | null,
    balconyArea?: number | null,
    bcr?: number | null,
    bldConditionType?: string | null,
    buildingCompany?: string | null,
    buildingFloors?: string | null,
    cadastralMapPdf?: string | null,
    carsInParkingN?: number | null,
    city?: string | null,
    cityPlanningType?: string | null,
    cleaningMonth?: number | null,
    clearingType?: string | null,
    collectedAt?: string | null,
    companyAddress?: string | null,
    companyBranchId?: number | null,
    companyFax?: string | null,
    companyGuaranter?: string | null,
    companyId?: string | null,
    companyLicense?: string | null,
    companyName?: string | null,
    companyRecNo?: number | null,
    companyTel?: string | null,
    companyUrl?: string | null,
    completionMonth?: number | null,
    completionMonthS?: string | null,
    completionSchMonth?: number | null,
    condominiumId?: string | null,
    condominiumName?: string | null,
    condominiumRecNo?: number | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    currentStatus?: string | null,
    currentStatusB?: string | null,
    currentStatusFree?: string | null,
    currentStatusG?: string | null,
    deletedOnSumora?: number | null,
    drivewayPay?: string | null,
    eSchool?: Array< string | null > | null,
    estatePrice?: number | null,
    estateType?: string | null,
    estateUrl?: string | null,
    exactLocation?: number | null,
    floor?: number | null,
    floorAreaRatio?: number | null,
    floorStructure?: string | null,
    fullAddress?: string | null,
    gas?: string | null,
    gasPdf?: string | null,
    groundPdf?: string | null,
    groundType?: Array< string | null > | null,
    groundTypeFree?: string | null,
    id?: string | null,
    infoName?: string | null,
    isLot?: number | null,
    jSchool?: Array< string | null > | null,
    landAreaType?: string | null,
    landRights?: string | null,
    latitude?: number | null,
    layout?: string | null,
    layoutImgs?: Array< string | null > | null,
    license?: string | null,
    location?: string | null,
    longitude?: number | null,
    managementFee?: number | null,
    managementType?: string | null,
    manager?: string | null,
    mapImg?: string | null,
    media?: string | null,
    mediationKind?: string | null,
    name?: string | null,
    nearlyLocation?: number | null,
    notFoundAt?: string | null,
    otherCost?: number | null,
    owner?: string | null,
    parking?: string | null,
    parkingFee?: number | null,
    parkingHeight?: number | null,
    parkingMechOrPlane?: string | null,
    parkingTakeOver?: string | null,
    parkingTakeOverFree?: string | null,
    pet?: string | null,
    prefecture?: string | null,
    priceHistory?:  Array< {
      __typename: "Price",
      price?: number | null,
      pricedAt?: string | null,
    } | null > | null,
    pricedAt?: string | null,
    purposeB?: string | null,
    purposeSummaryB?: string | null,
    recNo?: number | null,
    remarks?: string | null,
    repairCost?: number | null,
    roadDirection?: string | null,
    roadType?: string | null,
    roadWidth?: number | null,
    room?: string | null,
    searchInfo?: string | null,
    seller?: string | null,
    sewer?: string | null,
    sewerPdf?: string | null,
    sold?: boolean | null,
    squareArea?: number | null,
    status?: string | null,
    store?: string | null,
    structure?: string | null,
    structureFree?: string | null,
    subCompany2Address?: string | null,
    subCompany2Fax?: string | null,
    subCompany2Guaranter?: string | null,
    subCompany2Id?: string | null,
    subCompany2License?: string | null,
    subCompany2Name?: string | null,
    subCompany2Tel?: string | null,
    subCompany2Url?: string | null,
    subCompanyAddress?: string | null,
    subCompanyFax?: string | null,
    subCompanyGuaranter?: string | null,
    subCompanyId?: string | null,
    subCompanyLicense?: string | null,
    subCompanyName?: string | null,
    subCompanyRecNo?: number | null,
    subCompanyTel?: string | null,
    subCompanyUrl?: string | null,
    tileOnZoom12?: string | null,
    tileOnZoom14?: string | null,
    tileOnZoom16?: string | null,
    totalArea?: number | null,
    totalHouses?: number | null,
    traffic?: string | null,
    tsuboArea?: number | null,
    unitPrice?: number | null,
    unsettledLocation?: number | null,
    updatedAt?: string | null,
    url?: string | null,
    useDistrict?: Array< string | null > | null,
    water?: string | null,
    waterPdf?: string | null,
  } | null,
};

export type ResetTemporaryPasswordOfCognitoUserFMutationVariables = {
  username: string,
};

export type ResetTemporaryPasswordOfCognitoUserFMutation = {
  resetTemporaryPasswordOfCognitoUserF?:  {
    __typename: "CognitoUserResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "CognitoUser",
      Attributes?:  Array< {
        __typename: "CognitoUserAttribute",
        Name?: string | null,
        Value?: string | null,
      } | null > | null,
      Company?:  {
        __typename: "CompanyType",
        address?: string | null,
        areaNames?: Array< string | null > | null,
        areaPrefs?: Array< string | null > | null,
        areas?: Array< string | null > | null,
        bldConditionCompanies?: Array< string | null > | null,
        bldConditionSelections?: Array< string | null > | null,
        branchAddress?: string | null,
        branchFax?: string | null,
        branchId?: number | null,
        branchName?: string | null,
        branchTel?: string | null,
        branchUrl?: string | null,
        createdAt?: string | null,
        eAreaNames?: Array< string | null > | null,
        eAreas?: Array< string | null > | null,
        email?: string | null,
        estateTypes?: Array< string | null > | null,
        fax?: string | null,
        guaranter?: string | null,
        id: string,
        infoName: string,
        job?: string | null,
        latitude?: number | null,
        license?: string | null,
        licenseCount?: number | null,
        licenseNo?: string | null,
        licenser?: string | null,
        logoImg?: string | null,
        longitude?: number | null,
        name?: string | null,
        organization?: string | null,
        owner?: string | null,
        recNo?: number | null,
        remarks?: string | null,
        remarks2?: string | null,
        searchInfo: string,
        startMark?: string | null,
        tel?: string | null,
        updatedAt?: string | null,
        url?: string | null,
      } | null,
      Enabled?: boolean | null,
      Groups?:  Array< {
        __typename: "CognitoGroup",
        CreationDate?: string | null,
        Description?: string | null,
        GroupName?: string | null,
        LastModifiedDate?: string | null,
        Precedence?: number | null,
        RoleArn?: string | null,
        UserPoolId?: string | null,
      } | null > | null,
      MFAOptions?:  Array< {
        __typename: "CognitoUserMFAOption",
        AttributeName?: string | null,
        DeliveryMedium?: CognitoUserMFAOptionDeliveryMedium | null,
      } | null > | null,
      User?:  {
        __typename: "UserType",
        agreement?: boolean | null,
        authenticatedAt?: string | null,
        companyBranchName?: string | null,
        companyId?: string | null,
        companyName?: string | null,
        createdAt?: string | null,
        defaultCondition?:  {
          __typename: "DefaultCondition",
          alsoCreatedAtFrom?: number | null,
          alsoCreatedAtTo?: number | null,
          alsoPricedAtFrom?: number | null,
          alsoPricedAtTo?: number | null,
          areaPrefs?: Array< string | null > | null,
          areas?: Array< string | null > | null,
          bldConditionSelections?: Array< string | null > | null,
          companyRecNo?: number | null,
          completionYMFrom?: number | null,
          completionYMTo?: number | null,
          estatePriceFrom?: number | null,
          estatePriceTo?: number | null,
          estateTypes?: Array< string | null > | null,
          exceptForRent?: boolean | null,
          flat?: boolean | null,
          forRent?: boolean | null,
          petOk?: boolean | null,
          priceLabel?: boolean | null,
          purposeSummaryBs?: Array< string | null > | null,
          roomsFrom?: number | null,
          roomsTo?: number | null,
          squareAreaOfMansionFrom?: number | null,
          squareAreaOfMansionTo?: number | null,
          structureSummaries?: Array< string | null > | null,
          tsuboAreaFrom?: number | null,
          tsuboAreaTo?: number | null,
          tsuboLabel?: boolean | null,
          venderOnly?: boolean | null,
        } | null,
        email?: string | null,
        group?: string | null,
        infoName: string,
        name?: string | null,
        nameRuby?: string | null,
        owner?: string | null,
        paid?: boolean | null,
        pricingAvailable?: boolean | null,
        role?: string | null,
        searchInfo?: string | null,
        tel?: string | null,
        trial?: boolean | null,
        trialEndAt?: string | null,
        updatedAt?: string | null,
        username: string,
      } | null,
      UserCreateDate?: string | null,
      UserLastModifiedDate?: string | null,
      UserStatus?: CognitoUserUserStatus | null,
      Username?: string | null,
    } | null,
  } | null,
};

export type SaveDefaultConditionOfUserFMutationVariables = {
  defaultCondition: DefaultConditionInput,
  username: string,
};

export type SaveDefaultConditionOfUserFMutation = {
  saveDefaultConditionOfUserF?:  {
    __typename: "CognitoUserResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "CognitoUser",
      Attributes?:  Array< {
        __typename: "CognitoUserAttribute",
        Name?: string | null,
        Value?: string | null,
      } | null > | null,
      Company?:  {
        __typename: "CompanyType",
        address?: string | null,
        areaNames?: Array< string | null > | null,
        areaPrefs?: Array< string | null > | null,
        areas?: Array< string | null > | null,
        bldConditionCompanies?: Array< string | null > | null,
        bldConditionSelections?: Array< string | null > | null,
        branchAddress?: string | null,
        branchFax?: string | null,
        branchId?: number | null,
        branchName?: string | null,
        branchTel?: string | null,
        branchUrl?: string | null,
        createdAt?: string | null,
        eAreaNames?: Array< string | null > | null,
        eAreas?: Array< string | null > | null,
        email?: string | null,
        estateTypes?: Array< string | null > | null,
        fax?: string | null,
        guaranter?: string | null,
        id: string,
        infoName: string,
        job?: string | null,
        latitude?: number | null,
        license?: string | null,
        licenseCount?: number | null,
        licenseNo?: string | null,
        licenser?: string | null,
        logoImg?: string | null,
        longitude?: number | null,
        name?: string | null,
        organization?: string | null,
        owner?: string | null,
        recNo?: number | null,
        remarks?: string | null,
        remarks2?: string | null,
        searchInfo: string,
        startMark?: string | null,
        tel?: string | null,
        updatedAt?: string | null,
        url?: string | null,
      } | null,
      Enabled?: boolean | null,
      Groups?:  Array< {
        __typename: "CognitoGroup",
        CreationDate?: string | null,
        Description?: string | null,
        GroupName?: string | null,
        LastModifiedDate?: string | null,
        Precedence?: number | null,
        RoleArn?: string | null,
        UserPoolId?: string | null,
      } | null > | null,
      MFAOptions?:  Array< {
        __typename: "CognitoUserMFAOption",
        AttributeName?: string | null,
        DeliveryMedium?: CognitoUserMFAOptionDeliveryMedium | null,
      } | null > | null,
      User?:  {
        __typename: "UserType",
        agreement?: boolean | null,
        authenticatedAt?: string | null,
        companyBranchName?: string | null,
        companyId?: string | null,
        companyName?: string | null,
        createdAt?: string | null,
        defaultCondition?:  {
          __typename: "DefaultCondition",
          alsoCreatedAtFrom?: number | null,
          alsoCreatedAtTo?: number | null,
          alsoPricedAtFrom?: number | null,
          alsoPricedAtTo?: number | null,
          areaPrefs?: Array< string | null > | null,
          areas?: Array< string | null > | null,
          bldConditionSelections?: Array< string | null > | null,
          companyRecNo?: number | null,
          completionYMFrom?: number | null,
          completionYMTo?: number | null,
          estatePriceFrom?: number | null,
          estatePriceTo?: number | null,
          estateTypes?: Array< string | null > | null,
          exceptForRent?: boolean | null,
          flat?: boolean | null,
          forRent?: boolean | null,
          petOk?: boolean | null,
          priceLabel?: boolean | null,
          purposeSummaryBs?: Array< string | null > | null,
          roomsFrom?: number | null,
          roomsTo?: number | null,
          squareAreaOfMansionFrom?: number | null,
          squareAreaOfMansionTo?: number | null,
          structureSummaries?: Array< string | null > | null,
          tsuboAreaFrom?: number | null,
          tsuboAreaTo?: number | null,
          tsuboLabel?: boolean | null,
          venderOnly?: boolean | null,
        } | null,
        email?: string | null,
        group?: string | null,
        infoName: string,
        name?: string | null,
        nameRuby?: string | null,
        owner?: string | null,
        paid?: boolean | null,
        pricingAvailable?: boolean | null,
        role?: string | null,
        searchInfo?: string | null,
        tel?: string | null,
        trial?: boolean | null,
        trialEndAt?: string | null,
        updatedAt?: string | null,
        username: string,
      } | null,
      UserCreateDate?: string | null,
      UserLastModifiedDate?: string | null,
      UserStatus?: CognitoUserUserStatus | null,
      Username?: string | null,
    } | null,
  } | null,
};

export type SendAnnounceMailFMutationVariables = {
  input: SendAnnounceMailInput,
};

export type SendAnnounceMailFMutation = {
  sendAnnounceMailF?:  {
    __typename: "SendAnnounceMailResponse",
    errorMessage?: string | null,
  } | null,
};

export type TerminateTrialOfUserFMutationVariables = {
  username: string,
};

export type TerminateTrialOfUserFMutation = {
  terminateTrialOfUserF?:  {
    __typename: "CognitoUserResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "CognitoUser",
      Attributes?:  Array< {
        __typename: "CognitoUserAttribute",
        Name?: string | null,
        Value?: string | null,
      } | null > | null,
      Company?:  {
        __typename: "CompanyType",
        address?: string | null,
        areaNames?: Array< string | null > | null,
        areaPrefs?: Array< string | null > | null,
        areas?: Array< string | null > | null,
        bldConditionCompanies?: Array< string | null > | null,
        bldConditionSelections?: Array< string | null > | null,
        branchAddress?: string | null,
        branchFax?: string | null,
        branchId?: number | null,
        branchName?: string | null,
        branchTel?: string | null,
        branchUrl?: string | null,
        createdAt?: string | null,
        eAreaNames?: Array< string | null > | null,
        eAreas?: Array< string | null > | null,
        email?: string | null,
        estateTypes?: Array< string | null > | null,
        fax?: string | null,
        guaranter?: string | null,
        id: string,
        infoName: string,
        job?: string | null,
        latitude?: number | null,
        license?: string | null,
        licenseCount?: number | null,
        licenseNo?: string | null,
        licenser?: string | null,
        logoImg?: string | null,
        longitude?: number | null,
        name?: string | null,
        organization?: string | null,
        owner?: string | null,
        recNo?: number | null,
        remarks?: string | null,
        remarks2?: string | null,
        searchInfo: string,
        startMark?: string | null,
        tel?: string | null,
        updatedAt?: string | null,
        url?: string | null,
      } | null,
      Enabled?: boolean | null,
      Groups?:  Array< {
        __typename: "CognitoGroup",
        CreationDate?: string | null,
        Description?: string | null,
        GroupName?: string | null,
        LastModifiedDate?: string | null,
        Precedence?: number | null,
        RoleArn?: string | null,
        UserPoolId?: string | null,
      } | null > | null,
      MFAOptions?:  Array< {
        __typename: "CognitoUserMFAOption",
        AttributeName?: string | null,
        DeliveryMedium?: CognitoUserMFAOptionDeliveryMedium | null,
      } | null > | null,
      User?:  {
        __typename: "UserType",
        agreement?: boolean | null,
        authenticatedAt?: string | null,
        companyBranchName?: string | null,
        companyId?: string | null,
        companyName?: string | null,
        createdAt?: string | null,
        defaultCondition?:  {
          __typename: "DefaultCondition",
          alsoCreatedAtFrom?: number | null,
          alsoCreatedAtTo?: number | null,
          alsoPricedAtFrom?: number | null,
          alsoPricedAtTo?: number | null,
          areaPrefs?: Array< string | null > | null,
          areas?: Array< string | null > | null,
          bldConditionSelections?: Array< string | null > | null,
          companyRecNo?: number | null,
          completionYMFrom?: number | null,
          completionYMTo?: number | null,
          estatePriceFrom?: number | null,
          estatePriceTo?: number | null,
          estateTypes?: Array< string | null > | null,
          exceptForRent?: boolean | null,
          flat?: boolean | null,
          forRent?: boolean | null,
          petOk?: boolean | null,
          priceLabel?: boolean | null,
          purposeSummaryBs?: Array< string | null > | null,
          roomsFrom?: number | null,
          roomsTo?: number | null,
          squareAreaOfMansionFrom?: number | null,
          squareAreaOfMansionTo?: number | null,
          structureSummaries?: Array< string | null > | null,
          tsuboAreaFrom?: number | null,
          tsuboAreaTo?: number | null,
          tsuboLabel?: boolean | null,
          venderOnly?: boolean | null,
        } | null,
        email?: string | null,
        group?: string | null,
        infoName: string,
        name?: string | null,
        nameRuby?: string | null,
        owner?: string | null,
        paid?: boolean | null,
        pricingAvailable?: boolean | null,
        role?: string | null,
        searchInfo?: string | null,
        tel?: string | null,
        trial?: boolean | null,
        trialEndAt?: string | null,
        updatedAt?: string | null,
        username: string,
      } | null,
      UserCreateDate?: string | null,
      UserLastModifiedDate?: string | null,
      UserStatus?: CognitoUserUserStatus | null,
      Username?: string | null,
    } | null,
  } | null,
};

export type UpdateAnnounceMutationVariables = {
  condition?: ModelAnnounceConditionInput | null,
  input: UpdateAnnounceInput,
};

export type UpdateAnnounceMutation = {
  updateAnnounce?:  {
    __typename: "Announce",
    body: string,
    createdAt: string,
    expiredAt?: number | null,
    id: string,
    level: AnnounceLevel,
    owner: string,
    subject: string,
    to: string,
    updatedAt?: string | null,
    ym: string,
  } | null,
};

export type UpdateBatchJobMutationVariables = {
  condition?: ModelBatchJobConditionInput | null,
  input: UpdateBatchJobInput,
};

export type UpdateBatchJobMutation = {
  updateBatchJob?:  {
    __typename: "BatchJob",
    createdAt?: string | null,
    expiredAt?: number | null,
    id: string,
    jobName: string,
    remarks: string,
    status: string,
    updatedAt?: string | null,
  } | null,
};

export type UpdateBatchJobConfMutationVariables = {
  condition?: ModelBatchJobConfConditionInput | null,
  input: UpdateBatchJobConfInput,
};

export type UpdateBatchJobConfMutation = {
  updateBatchJobConf?:  {
    __typename: "BatchJobConf",
    allowedGroups?: Array< string | null > | null,
    createdAt?: string | null,
    jobName: string,
    remarks: string,
    updatedAt?: string | null,
  } | null,
};

export type UpdateBuildPriceMutationVariables = {
  condition?: ModelBuildPriceConditionInput | null,
  input: UpdateBuildPriceInput,
};

export type UpdateBuildPriceMutation = {
  updateBuildPrice?:  {
    __typename: "BuildPrice",
    createdAt?: string | null,
    owner: string,
    unitPriceCB: number,
    unitPriceOther: number,
    unitPriceRC: number,
    unitPriceS: number,
    unitPriceSRC: number,
    unitPriceW: number,
    updatedAt?: string | null,
    year: number,
  } | null,
};

export type UpdateCognitoUserFMutationVariables = {
  agreement?: boolean | null,
  companyId: string,
  email: string,
  group: string,
  name: string,
  nameRuby: string,
  paid?: boolean | null,
  pricingAvailable?: boolean | null,
  role?: string | null,
  tel?: string | null,
  trial?: boolean | null,
  trialEndAt?: string | null,
  username: string,
};

export type UpdateCognitoUserFMutation = {
  updateCognitoUserF?:  {
    __typename: "CognitoUserResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "CognitoUser",
      Attributes?:  Array< {
        __typename: "CognitoUserAttribute",
        Name?: string | null,
        Value?: string | null,
      } | null > | null,
      Company?:  {
        __typename: "CompanyType",
        address?: string | null,
        areaNames?: Array< string | null > | null,
        areaPrefs?: Array< string | null > | null,
        areas?: Array< string | null > | null,
        bldConditionCompanies?: Array< string | null > | null,
        bldConditionSelections?: Array< string | null > | null,
        branchAddress?: string | null,
        branchFax?: string | null,
        branchId?: number | null,
        branchName?: string | null,
        branchTel?: string | null,
        branchUrl?: string | null,
        createdAt?: string | null,
        eAreaNames?: Array< string | null > | null,
        eAreas?: Array< string | null > | null,
        email?: string | null,
        estateTypes?: Array< string | null > | null,
        fax?: string | null,
        guaranter?: string | null,
        id: string,
        infoName: string,
        job?: string | null,
        latitude?: number | null,
        license?: string | null,
        licenseCount?: number | null,
        licenseNo?: string | null,
        licenser?: string | null,
        logoImg?: string | null,
        longitude?: number | null,
        name?: string | null,
        organization?: string | null,
        owner?: string | null,
        recNo?: number | null,
        remarks?: string | null,
        remarks2?: string | null,
        searchInfo: string,
        startMark?: string | null,
        tel?: string | null,
        updatedAt?: string | null,
        url?: string | null,
      } | null,
      Enabled?: boolean | null,
      Groups?:  Array< {
        __typename: "CognitoGroup",
        CreationDate?: string | null,
        Description?: string | null,
        GroupName?: string | null,
        LastModifiedDate?: string | null,
        Precedence?: number | null,
        RoleArn?: string | null,
        UserPoolId?: string | null,
      } | null > | null,
      MFAOptions?:  Array< {
        __typename: "CognitoUserMFAOption",
        AttributeName?: string | null,
        DeliveryMedium?: CognitoUserMFAOptionDeliveryMedium | null,
      } | null > | null,
      User?:  {
        __typename: "UserType",
        agreement?: boolean | null,
        authenticatedAt?: string | null,
        companyBranchName?: string | null,
        companyId?: string | null,
        companyName?: string | null,
        createdAt?: string | null,
        defaultCondition?:  {
          __typename: "DefaultCondition",
          alsoCreatedAtFrom?: number | null,
          alsoCreatedAtTo?: number | null,
          alsoPricedAtFrom?: number | null,
          alsoPricedAtTo?: number | null,
          areaPrefs?: Array< string | null > | null,
          areas?: Array< string | null > | null,
          bldConditionSelections?: Array< string | null > | null,
          companyRecNo?: number | null,
          completionYMFrom?: number | null,
          completionYMTo?: number | null,
          estatePriceFrom?: number | null,
          estatePriceTo?: number | null,
          estateTypes?: Array< string | null > | null,
          exceptForRent?: boolean | null,
          flat?: boolean | null,
          forRent?: boolean | null,
          petOk?: boolean | null,
          priceLabel?: boolean | null,
          purposeSummaryBs?: Array< string | null > | null,
          roomsFrom?: number | null,
          roomsTo?: number | null,
          squareAreaOfMansionFrom?: number | null,
          squareAreaOfMansionTo?: number | null,
          structureSummaries?: Array< string | null > | null,
          tsuboAreaFrom?: number | null,
          tsuboAreaTo?: number | null,
          tsuboLabel?: boolean | null,
          venderOnly?: boolean | null,
        } | null,
        email?: string | null,
        group?: string | null,
        infoName: string,
        name?: string | null,
        nameRuby?: string | null,
        owner?: string | null,
        paid?: boolean | null,
        pricingAvailable?: boolean | null,
        role?: string | null,
        searchInfo?: string | null,
        tel?: string | null,
        trial?: boolean | null,
        trialEndAt?: string | null,
        updatedAt?: string | null,
        username: string,
      } | null,
      UserCreateDate?: string | null,
      UserLastModifiedDate?: string | null,
      UserStatus?: CognitoUserUserStatus | null,
      Username?: string | null,
    } | null,
  } | null,
};

export type UpdateCompanyFMutationVariables = {
  input: UpdateCompanyInput,
};

export type UpdateCompanyFMutation = {
  updateCompanyF?:  {
    __typename: "CompanyMutationResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "CompanyType",
      address?: string | null,
      areaNames?: Array< string | null > | null,
      areaPrefs?: Array< string | null > | null,
      areas?: Array< string | null > | null,
      bldConditionCompanies?: Array< string | null > | null,
      bldConditionSelections?: Array< string | null > | null,
      branchAddress?: string | null,
      branchFax?: string | null,
      branchId?: number | null,
      branchName?: string | null,
      branchTel?: string | null,
      branchUrl?: string | null,
      createdAt?: string | null,
      eAreaNames?: Array< string | null > | null,
      eAreas?: Array< string | null > | null,
      email?: string | null,
      estateTypes?: Array< string | null > | null,
      fax?: string | null,
      guaranter?: string | null,
      id: string,
      infoName: string,
      job?: string | null,
      latitude?: number | null,
      license?: string | null,
      licenseCount?: number | null,
      licenseNo?: string | null,
      licenser?: string | null,
      logoImg?: string | null,
      longitude?: number | null,
      name?: string | null,
      organization?: string | null,
      owner?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      remarks2?: string | null,
      searchInfo: string,
      startMark?: string | null,
      tel?: string | null,
      updatedAt?: string | null,
      url?: string | null,
    } | null,
  } | null,
};

export type UpdateDummyMutationVariables = {
  condition?: ModelDummyConditionInput | null,
  input: UpdateDummyInput,
};

export type UpdateDummyMutation = {
  updateDummy?:  {
    __typename: "Dummy",
    createdAt: string,
    id: string,
    kintoneAppScope?: KintoneAppScope | null,
    kintoneDataKind?: KintoneDataKind | null,
    updatedAt: string,
  } | null,
};

export type UpdateEstateFMutationVariables = {
  input: UpdateEstateInput,
};

export type UpdateEstateFMutation = {
  updateEstateF?:  {
    __typename: "EstateMutationResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "EstateType",
      address?: string | null,
      appearanceImgs?: Array< string | null > | null,
      area?: string | null,
      balconyArea?: number | null,
      bcr?: number | null,
      bldConditionType?: string | null,
      buildingCompany?: string | null,
      buildingFloors?: string | null,
      cadastralMapPdf?: string | null,
      carsInParkingN?: number | null,
      city?: string | null,
      cityPlanningType?: string | null,
      cleaningMonth?: number | null,
      clearingType?: string | null,
      collectedAt?: string | null,
      companyAddress?: string | null,
      companyBranchId?: number | null,
      companyFax?: string | null,
      companyGuaranter?: string | null,
      companyId?: string | null,
      companyLicense?: string | null,
      companyName?: string | null,
      companyRecNo?: number | null,
      companyTel?: string | null,
      companyUrl?: string | null,
      completionMonth?: number | null,
      completionMonthS?: string | null,
      completionSchMonth?: number | null,
      condominiumId?: string | null,
      condominiumName?: string | null,
      condominiumRecNo?: number | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      currentStatus?: string | null,
      currentStatusB?: string | null,
      currentStatusFree?: string | null,
      currentStatusG?: string | null,
      deletedOnSumora?: number | null,
      drivewayPay?: string | null,
      eSchool?: Array< string | null > | null,
      estatePrice?: number | null,
      estateType?: string | null,
      estateUrl?: string | null,
      exactLocation?: number | null,
      floor?: number | null,
      floorAreaRatio?: number | null,
      floorStructure?: string | null,
      fullAddress?: string | null,
      gas?: string | null,
      gasPdf?: string | null,
      groundPdf?: string | null,
      groundType?: Array< string | null > | null,
      groundTypeFree?: string | null,
      id: string,
      infoName: string,
      isLot?: number | null,
      jSchool?: Array< string | null > | null,
      landAreaType?: string | null,
      landRights?: string | null,
      latitude?: number | null,
      layout?: string | null,
      layoutImgs?: Array< string | null > | null,
      license?: string | null,
      location?: string | null,
      longitude?: number | null,
      managementFee?: number | null,
      managementType?: string | null,
      manager?: string | null,
      mapImg?: string | null,
      media?: string | null,
      mediationKind?: string | null,
      name?: string | null,
      nearlyLocation?: number | null,
      notFoundAt?: string | null,
      otherCost?: number | null,
      owner?: string | null,
      parking?: string | null,
      parkingFee?: number | null,
      parkingHeight?: number | null,
      parkingMechOrPlane?: string | null,
      parkingTakeOver?: string | null,
      parkingTakeOverFree?: string | null,
      pet?: string | null,
      prefecture?: string | null,
      priceHistory?:  Array< {
        __typename: "Price",
        price?: number | null,
        pricedAt?: string | null,
      } | null > | null,
      pricedAt?: string | null,
      purposeB?: string | null,
      purposeSummaryB?: string | null,
      recNo?: number | null,
      remarks?: string | null,
      repairCost?: number | null,
      roadDirection?: string | null,
      roadType?: string | null,
      roadWidth?: number | null,
      room?: string | null,
      searchInfo: string,
      seller?: string | null,
      sewer?: string | null,
      sewerPdf?: string | null,
      sold?: boolean | null,
      squareArea?: number | null,
      status?: string | null,
      store?: string | null,
      structure?: string | null,
      structureFree?: string | null,
      subCompany2Address?: string | null,
      subCompany2Fax?: string | null,
      subCompany2Guaranter?: string | null,
      subCompany2Id?: string | null,
      subCompany2License?: string | null,
      subCompany2Name?: string | null,
      subCompany2Tel?: string | null,
      subCompany2Url?: string | null,
      subCompanyAddress?: string | null,
      subCompanyFax?: string | null,
      subCompanyGuaranter?: string | null,
      subCompanyId?: string | null,
      subCompanyLicense?: string | null,
      subCompanyName?: string | null,
      subCompanyRecNo?: number | null,
      subCompanyTel?: string | null,
      subCompanyUrl?: string | null,
      tileOnZoom12?: string | null,
      tileOnZoom14?: string | null,
      tileOnZoom16?: string | null,
      totalArea?: number | null,
      totalHouses?: number | null,
      traffic?: string | null,
      tsuboArea?: number | null,
      unitPrice?: number | null,
      unsettledLocation?: number | null,
      updatedAt?: string | null,
      url?: string | null,
      useDistrict?: Array< string | null > | null,
      water?: string | null,
      waterPdf?: string | null,
    } | null,
  } | null,
};

export type UpdateReportMutationVariables = {
  condition?: ModelReportConditionInput | null,
  input: UpdateReportInput,
};

export type UpdateReportMutation = {
  updateReport?:  {
    __typename: "Report",
    companyId: string,
    companyName: string,
    createdAt: string,
    description?: string | null,
    estateId: string,
    estateName?: string | null,
    expiredAt?: number | null,
    id: string,
    latitude?: number | null,
    longitude?: number | null,
    owner: string,
    reportKind: string,
    updatedAt?: string | null,
    userName: string,
  } | null,
};

export type UpdateScrapingMutationVariables = {
  condition?: ModelScrapingConditionInput | null,
  input: UpdateScrapingInput,
};

export type UpdateScrapingMutation = {
  updateScraping?:  {
    __typename: "Scraping",
    baseUrl: string,
    createdAt?: string | null,
    endedAt?: string | null,
    input?: string | null,
    operation?: string | null,
    output?: string | null,
    prefName: string,
    remarks?: string | null,
    resultKey?: string | null,
    sortKey: string,
    startedAt?: string | null,
    status: string,
    totalCount?: number | null,
    updated?:  {
      __typename: "ScrapingUpdateDetail",
      blocked?: number | null,
      expired?: number | null,
      newRecord?: number | null,
      onSite?: number | null,
      requiresAuth?: number | null,
      return?: number | null,
      returnAndUpdatePrice?: number | null,
      scrapingFailed?: number | null,
      updateFailed?: number | null,
      updatePrice?: number | null,
    } | null,
    updatedAt?: string | null,
    updating?:  {
      __typename: "ScrapingUpdateDetail",
      blocked?: number | null,
      expired?: number | null,
      newRecord?: number | null,
      onSite?: number | null,
      requiresAuth?: number | null,
      return?: number | null,
      returnAndUpdatePrice?: number | null,
      scrapingFailed?: number | null,
      updateFailed?: number | null,
      updatePrice?: number | null,
    } | null,
  } | null,
};

export type UpdateStickyNoteFMutationVariables = {
  input: UpdateStickyNoteInput,
};

export type UpdateStickyNoteFMutation = {
  updateStickyNoteF?:  {
    __typename: "StickyNoteMutationResponse",
    errorMessage?: string | null,
    item?:  {
      __typename: "StickyNoteType",
      color?: StickyNoteColor | null,
      companyId: string,
      createdAt?: string | null,
      description?: string | null,
      icon?: StickyNoteIcon | null,
      id: string,
      infoName: string,
      latitude: number,
      longitude: number,
      memoKind: string,
      openLevel: string,
      owner: string,
      searchInfo: string,
      tileOnZoom12: string,
      tileOnZoom14: string,
      tileOnZoom16: string,
      updatedAt?: string | null,
      url1?: string | null,
      url2?: string | null,
      url3?: string | null,
    } | null,
  } | null,
};

export type OnCreateBatchJobSubscriptionVariables = {
  filter?: ModelSubscriptionBatchJobFilterInput | null,
};

export type OnCreateBatchJobSubscription = {
  onCreateBatchJob?:  {
    __typename: "BatchJob",
    createdAt?: string | null,
    expiredAt?: number | null,
    id: string,
    jobName: string,
    remarks: string,
    status: string,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateDummySubscriptionVariables = {
  filter?: ModelSubscriptionDummyFilterInput | null,
};

export type OnCreateDummySubscription = {
  onCreateDummy?:  {
    __typename: "Dummy",
    createdAt: string,
    id: string,
    kintoneAppScope?: KintoneAppScope | null,
    kintoneDataKind?: KintoneDataKind | null,
    updatedAt: string,
  } | null,
};

export type OnCreateScrapingSubscriptionVariables = {
  filter?: ModelSubscriptionScrapingFilterInput | null,
};

export type OnCreateScrapingSubscription = {
  onCreateScraping?:  {
    __typename: "Scraping",
    baseUrl: string,
    createdAt?: string | null,
    endedAt?: string | null,
    input?: string | null,
    operation?: string | null,
    output?: string | null,
    prefName: string,
    remarks?: string | null,
    resultKey?: string | null,
    sortKey: string,
    startedAt?: string | null,
    status: string,
    totalCount?: number | null,
    updated?:  {
      __typename: "ScrapingUpdateDetail",
      blocked?: number | null,
      expired?: number | null,
      newRecord?: number | null,
      onSite?: number | null,
      requiresAuth?: number | null,
      return?: number | null,
      returnAndUpdatePrice?: number | null,
      scrapingFailed?: number | null,
      updateFailed?: number | null,
      updatePrice?: number | null,
    } | null,
    updatedAt?: string | null,
    updating?:  {
      __typename: "ScrapingUpdateDetail",
      blocked?: number | null,
      expired?: number | null,
      newRecord?: number | null,
      onSite?: number | null,
      requiresAuth?: number | null,
      return?: number | null,
      returnAndUpdatePrice?: number | null,
      scrapingFailed?: number | null,
      updateFailed?: number | null,
      updatePrice?: number | null,
    } | null,
  } | null,
};

export type OnDeleteBatchJobSubscriptionVariables = {
  filter?: ModelSubscriptionBatchJobFilterInput | null,
};

export type OnDeleteBatchJobSubscription = {
  onDeleteBatchJob?:  {
    __typename: "BatchJob",
    createdAt?: string | null,
    expiredAt?: number | null,
    id: string,
    jobName: string,
    remarks: string,
    status: string,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteDummySubscriptionVariables = {
  filter?: ModelSubscriptionDummyFilterInput | null,
};

export type OnDeleteDummySubscription = {
  onDeleteDummy?:  {
    __typename: "Dummy",
    createdAt: string,
    id: string,
    kintoneAppScope?: KintoneAppScope | null,
    kintoneDataKind?: KintoneDataKind | null,
    updatedAt: string,
  } | null,
};

export type OnNotifyEstateCSubscriptionVariables = {
};

export type OnNotifyEstateCSubscription = {
  onNotifyEstateC?:  {
    __typename: "EstateNotifyResponse",
    address?: string | null,
    appearanceImgs?: Array< string | null > | null,
    area?: string | null,
    balconyArea?: number | null,
    bcr?: number | null,
    bldConditionType?: string | null,
    buildingCompany?: string | null,
    buildingFloors?: string | null,
    cadastralMapPdf?: string | null,
    carsInParkingN?: number | null,
    city?: string | null,
    cityPlanningType?: string | null,
    cleaningMonth?: number | null,
    clearingType?: string | null,
    collectedAt?: string | null,
    companyAddress?: string | null,
    companyBranchId?: number | null,
    companyFax?: string | null,
    companyGuaranter?: string | null,
    companyId?: string | null,
    companyLicense?: string | null,
    companyName?: string | null,
    companyRecNo?: number | null,
    companyTel?: string | null,
    companyUrl?: string | null,
    completionMonth?: number | null,
    completionMonthS?: string | null,
    completionSchMonth?: number | null,
    condominiumId?: string | null,
    condominiumName?: string | null,
    condominiumRecNo?: number | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    currentStatus?: string | null,
    currentStatusB?: string | null,
    currentStatusFree?: string | null,
    currentStatusG?: string | null,
    deletedOnSumora?: number | null,
    drivewayPay?: string | null,
    eSchool?: Array< string | null > | null,
    estatePrice?: number | null,
    estateType?: string | null,
    estateUrl?: string | null,
    exactLocation?: number | null,
    floor?: number | null,
    floorAreaRatio?: number | null,
    floorStructure?: string | null,
    fullAddress?: string | null,
    gas?: string | null,
    gasPdf?: string | null,
    groundPdf?: string | null,
    groundType?: Array< string | null > | null,
    groundTypeFree?: string | null,
    id?: string | null,
    infoName?: string | null,
    isLot?: number | null,
    jSchool?: Array< string | null > | null,
    landAreaType?: string | null,
    landRights?: string | null,
    latitude?: number | null,
    layout?: string | null,
    layoutImgs?: Array< string | null > | null,
    license?: string | null,
    location?: string | null,
    longitude?: number | null,
    managementFee?: number | null,
    managementType?: string | null,
    manager?: string | null,
    mapImg?: string | null,
    media?: string | null,
    mediationKind?: string | null,
    name?: string | null,
    nearlyLocation?: number | null,
    notFoundAt?: string | null,
    otherCost?: number | null,
    owner?: string | null,
    parking?: string | null,
    parkingFee?: number | null,
    parkingHeight?: number | null,
    parkingMechOrPlane?: string | null,
    parkingTakeOver?: string | null,
    parkingTakeOverFree?: string | null,
    pet?: string | null,
    prefecture?: string | null,
    priceHistory?:  Array< {
      __typename: "Price",
      price?: number | null,
      pricedAt?: string | null,
    } | null > | null,
    pricedAt?: string | null,
    purposeB?: string | null,
    purposeSummaryB?: string | null,
    recNo?: number | null,
    remarks?: string | null,
    repairCost?: number | null,
    roadDirection?: string | null,
    roadType?: string | null,
    roadWidth?: number | null,
    room?: string | null,
    searchInfo?: string | null,
    seller?: string | null,
    sewer?: string | null,
    sewerPdf?: string | null,
    sold?: boolean | null,
    squareArea?: number | null,
    status?: string | null,
    store?: string | null,
    structure?: string | null,
    structureFree?: string | null,
    subCompany2Address?: string | null,
    subCompany2Fax?: string | null,
    subCompany2Guaranter?: string | null,
    subCompany2Id?: string | null,
    subCompany2License?: string | null,
    subCompany2Name?: string | null,
    subCompany2Tel?: string | null,
    subCompany2Url?: string | null,
    subCompanyAddress?: string | null,
    subCompanyFax?: string | null,
    subCompanyGuaranter?: string | null,
    subCompanyId?: string | null,
    subCompanyLicense?: string | null,
    subCompanyName?: string | null,
    subCompanyRecNo?: number | null,
    subCompanyTel?: string | null,
    subCompanyUrl?: string | null,
    tileOnZoom12?: string | null,
    tileOnZoom14?: string | null,
    tileOnZoom16?: string | null,
    totalArea?: number | null,
    totalHouses?: number | null,
    traffic?: string | null,
    tsuboArea?: number | null,
    unitPrice?: number | null,
    unsettledLocation?: number | null,
    updatedAt?: string | null,
    url?: string | null,
    useDistrict?: Array< string | null > | null,
    water?: string | null,
    waterPdf?: string | null,
  } | null,
};

export type OnUpdateBatchJobSubscriptionVariables = {
  filter?: ModelSubscriptionBatchJobFilterInput | null,
};

export type OnUpdateBatchJobSubscription = {
  onUpdateBatchJob?:  {
    __typename: "BatchJob",
    createdAt?: string | null,
    expiredAt?: number | null,
    id: string,
    jobName: string,
    remarks: string,
    status: string,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateDummySubscriptionVariables = {
  filter?: ModelSubscriptionDummyFilterInput | null,
};

export type OnUpdateDummySubscription = {
  onUpdateDummy?:  {
    __typename: "Dummy",
    createdAt: string,
    id: string,
    kintoneAppScope?: KintoneAppScope | null,
    kintoneDataKind?: KintoneDataKind | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateScrapingSubscriptionVariables = {
  filter?: ModelSubscriptionScrapingFilterInput | null,
};

export type OnUpdateScrapingSubscription = {
  onUpdateScraping?:  {
    __typename: "Scraping",
    baseUrl: string,
    createdAt?: string | null,
    endedAt?: string | null,
    input?: string | null,
    operation?: string | null,
    output?: string | null,
    prefName: string,
    remarks?: string | null,
    resultKey?: string | null,
    sortKey: string,
    startedAt?: string | null,
    status: string,
    totalCount?: number | null,
    updated?:  {
      __typename: "ScrapingUpdateDetail",
      blocked?: number | null,
      expired?: number | null,
      newRecord?: number | null,
      onSite?: number | null,
      requiresAuth?: number | null,
      return?: number | null,
      returnAndUpdatePrice?: number | null,
      scrapingFailed?: number | null,
      updateFailed?: number | null,
      updatePrice?: number | null,
    } | null,
    updatedAt?: string | null,
    updating?:  {
      __typename: "ScrapingUpdateDetail",
      blocked?: number | null,
      expired?: number | null,
      newRecord?: number | null,
      onSite?: number | null,
      requiresAuth?: number | null,
      return?: number | null,
      returnAndUpdatePrice?: number | null,
      scrapingFailed?: number | null,
      updateFailed?: number | null,
      updatePrice?: number | null,
    } | null,
  } | null,
};
